(function () {
	'use strict';
	angular
		.module('app.core')
		.directive('leanTable', leanTable);

	function leanTable() {
		var directive = {
			restrict: 'EA',
			templateUrl: 'core/table/lean-table.html',
			scope: {
				getData: '&',
				getMeta: '&'
			},
			link: linkFunc,
			controller: LeanTableCtrl,
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;

		function linkFunc(scope, el, attr, ctrl) {}
	}

	LeanTableCtrl.$inject = ['$rootScope', '$scope', '$compile', '$timeout', '$sce', '$filter',
		'$uibModal', '$translate', '$location', '$http', '$q', '$state', '$window', '$interval', 'leanTableService',
		'tableFilterFunctionsService', 'leanFilterService', 'leanTableConfigService',
		'excelExportService', 'URLS', 'slideInModalService', 'commentsService',
		'numberFormatService', 'integerFormatService', 'formatterService',
		'assessmentService', 'procurementTaskService',
		'inventoryActionConfigService', 'watcherFunctionsService', '$experiments', 'supplierLateDeliveryIssueService', 'inventoryActionsService', 'storeService',
		'poStatusCategoryService', 'flexFieldConfigService', 'drilldownFunctionsService',
		'FIRST_VIEW', 'supplyOrderForecastService', 'Upload', 'valueStreamService', 'reportCardParamsService',
		'manageEmailAlertsService', 'userManagementService', 'userService', 'siteService',
		'navigationService', 'localStorageService', 'projectAreaService', 'userAttributes' , 'uploadPOModalService', 'customerOrderStatusCategoryService'
	];

	function LeanTableCtrl($rootScope, $scope, $compile, $timeout, $sce, $filter,
			$uibModal, $translate, $location, $http, $q, $state, $window, $interval, leanTableService,
			tableFilterFunctionsService, leanFilterService, leanTableConfigService,
			excelExportService, URLS, slideInModalService, commentsService,
			numberFormatService, integerFormatService, formatterService,
			assessmentService, procurementTaskService,
			inventoryActionConfigService, watcherFunctionsService, $experiments,
			supplierLateDeliveryIssueService, inventoryActionsService, storeService,
			poStatusCategoryService, flexFieldConfigService, drilldownFunctionsService,
			FIRST_VIEW, supplyOrderForecastService,
			Upload, valueStreamService, reportCardParamsService,
			manageEmailAlertsService, userManagementService, userService, siteService,
			navigationService, localStorageService, projectAreaService, userAttributes, uploadPOModalService, customerOrderStatusCategoryService) {
		var vm = this;
		this.$onInit = function() {
			var preconfig = vm.getMeta().preConfigPromise || Promise.resolve();
			preconfig.then(createTable).then(chatChangeListener);
		};
		var fakeScrollListener;
		var scrollbarTimeout;
		var tableState;
		var reportSettingsName;
		var isGlobalReportSetting;
		var reportUrl;
		var extraParams;
		var rendererParams;
		var currencySymbol;
		var data = [];
		var originalData = [];
		var defaultSort = '';
		var defaultSortDirection;
		var defaultFilters = [];
		var currentSort = [];
		var noPaging = false;
		var getDataCalled = false;
		var paginationObject = {};
		var searchType = '';
		var reportConfigListener;
		var chatChangeListener;
		var recordsPerPage;
		var curUrl;
		var newStart;
		var defaultCols;
		var controllerModifiesColumns = false;
		var usePost = false;
		var useReportBuilderForExcel = false;
		var useExtraParamsForExcelWithReportBuilder = false;
		var isBackendGrouping = false;
		var reportHasMandatoryFilters = true;
		var rowsReady = {
			'pinnedTable': false,
			'groupTable': false,
			'mainTable': false
		};
		var urlGenerator;
		var refreshMeta;
		var noFactory;
		var colorClassMap = {
			'color-code-10-red': 'Red',
			'color-code-30-yellow': 'Yellow',
			'color-code-20-blue': 'Blue'
		};
		var tooltips = {};
		var opened = false;
		var commentClipboard = {};
		var timeoutMap = {};
		var visibleMap = {};
		var promiseMap = {};
		var excelRequest = false;
		var compiledScopes = {};
		var createRowCounter = 0;
		var alreadyOpenedDrilldown = false;
		var saveErrorUnsub;
		var supplierScoreCardOpened = {};
		var reportSettingsScope;
		var hasChat = false;
		var chatIdentifier = null;
		var poIdentifierColumns = [
			'scheduleLine',
			'orderLine',
			'supplyOrderNumber'
		];
		var isSupplierPreview = globalConfig.user.supplierView && globalConfig.user.supplierView.switchType &&
			globalConfig.user.supplierView.switchType === 'SUPPLIER';
		vm.foundNothing = false;
		vm.filtered = false;
		vm.noResultsText = 'We couldn\'t find any results that match that search on this report.';
		vm.noResultsSuggestion = 'Please try another one.';
		vm.allExpanded = false;
		vm.hideSearch;
		vm.reportIsAuthorized = true;

		vm.selectedRow;
		vm.groupBy = '';
		vm.displayedData = [];
		vm.columns = [];
		vm.pinnedColumns = [];
		vm.search = {};
		vm.searchPlaceholderText = '';
		vm.refreshTable = refreshTable;
		vm.doNothing = doNothing;
		vm.waitForFilters = false;
		vm.hideFilters = false;
		vm.hideFiltersContainer = false;
		vm.hideNoResultsSuggestion = false;
		vm.hasTabs = false;
		vm.showPinned = showPinned;
		vm.updateColumnWidth = updateColumnWidth;
		vm.sortData = sortData;
		vm.toggleSelectRow = toggleSelectRow;
		vm.pinColumn = pinColumn;
		vm.unpinColumn = unpinColumn;
		vm.groupColumn = groupColumn;
		vm.ungroupColumn = ungroupColumn;
		vm.showColumn = showColumn;
		vm.resetWidth = resetWidth;
		vm.getGroupExpanded = getGroupExpanded;
		vm.expandCollapseRows = expandCollapseRows;
		vm.expandAllRows = expandAllRows;
		vm.collapseAllRows = collapseAllRows;
		vm.updateGroupFakeScroller = updateGroupFakeScroller;

		// Paging functions
		vm.hasPaging = hasPaging;
		vm.getPaginationObject = getPaginationObject;
		vm.reloadTable = reloadTable;

		// Search functions
		vm.searchOptionSelected = searchOptionSelected;
		vm.getSearchValues = getSearchValues;
		vm.clearText = clearText;
		vm.searchInputFocused = searchInputFocused;

		// Tagging functions
		vm.getUsersForTagging = watcherFunctionsService.getUsersForTagging;
		vm.formatTagResult = watcherFunctionsService.formatTagResult;

		//Shortage Tooltip Functions
		vm.rowData = {};
		vm.startEditList = startEditList;
		vm.startEditDate = startEditDate;
		vm.onSingleSelect = onSingleSelect;
		vm.handleSingleSelectOpenClose = handleSingleSelectOpenClose;
		vm.saveEditDate = saveEditDate;
		vm.checkValidDate = checkValidDate;
		vm.startEdit = startEdit;
		vm.saveTaskComment = saveTaskComment;
		vm.getTooltip = getTooltip;
		vm.showIt = showIt;
		vm.hideIt = hideIt;
		vm.copy = copy;
		vm.paste = paste;
		vm.cancelEdit = cancelEdit;
		vm.saveEdit = saveEdit;
		vm.canSaveStatusChange = canSaveStatusChange;
		vm.getActiveUnableToFixCategories = getActiveUnableToFixCategories;
		vm.hasNoActiveUnableToFixCategories = hasNoActiveUnableToFixCategories;
		vm.showStatusHistory = showStatusHistory;
		vm.sboShowStatusHistory = sboShowStatusHistory;
		vm.tagTransform = tagTransform;
		vm.approveProject = approveProject;
		vm.deleteProject = deleteProject;
		vm.archiveProject = archiveProject;
		vm.viewA3Report = viewA3Report;
		vm.viewSOTDReport = viewSOTDReport;
		vm.refreshTagListResults = refreshTagListResults;
		vm.openExcessToSellDetail = openExcessToSellDetail;
		vm.archiveLateDeliveryIssue = archiveLateDeliveryIssue;
		vm.archivePoStatusCategory = archivePoStatusCategory;
		vm.archiveCustomerOrderStatusCategory = archiveCustomerOrderStatusCategory;
		vm.lateDeliveryCauseGrouping = lateDeliveryCauseGrouping;
		vm.openEmailPreview = openEmailPreview;
		vm.openAuditLogContent = openAuditLogContent;
		vm.downloadEmailTrigger = downloadEmailTrigger;
		vm.openSupplierScoreCard = openSupplierScoreCard;
		vm.inlineLists = {};
		vm.showExcel = true;
		vm.expandedRows = {};
		vm.updateActionStatusPosition = updateActionStatusPosition;
		vm.addSupplierUser = addSupplierUser;

		// PO Forecast Functions
		vm.currentForecast = undefined;
		vm.addForecastRow = addForecastRow;
		vm.removeForecastRow = removeForecastRow;
		vm.startEditForecast = startEditForecast;
		vm.disableSaveForecast = disableSaveForecast;
		vm.openForecastDatePicker = openForecastDatePicker;

		// Lean Sync Config Functions
		vm.openLeanSyncConfigModal = openLeanSyncConfigModal;

		// Value Stream Functions
		vm.deleteValueStream = deleteValueStream;

		// Report Card Parameter Functions
		vm.deleteReportCardParameter = deleteReportCardParameter;

		// Strategic Goals Functions
		vm.editStrategicGoal = editStrategicGoal;
		vm.showStrategicGoalProjects = showStrategicGoalProjects;
		vm.updateStrategicGoalStatus = updateStrategicGoalStatus;
		vm.deleteStrategicGoal = deleteStrategicGoal;

		// View Metric Data Functions
		vm.deleteMetricResult = deleteMetricResult;

		// Checkbox Modal Functions
		vm.startEditCheckbox = startEditCheckbox;
		vm.getCheckboxTemplate = getCheckboxTemplate;

		// Checkbox Functions
		vm.toggleCheckboxRow = toggleCheckboxRow;
		vm.toggleAllCheckboxes = toggleAllCheckboxes;

		// Manage Email Alerts Functions
		vm.saveEditConditions = saveEditConditions;

		// Start edit functions
		vm.startMultiSelectEdit = startMultiSelectEdit;

		// Update Targets
		vm.copyMetricTargets = copyMetricTargets;

		// Report Card
		vm.openReportCard = openReportCard;

		// User Factory
		vm.startEditSelectForUserFactory = startEditSelectForUserFactory;
		vm.saveEditSelectForUserFactory = saveEditSelectForUserFactory;

		// Project Type Functions
		vm.editProjectType = editProjectType;
		vm.deleteProjectType = deleteProjectType;

		// Project Savings Category Functions
		vm.editProjectSavingsCategory = editProjectSavingsCategory;
		vm.deleteProjectSavingsCategory = deleteProjectSavingsCategory;
		vm.updateProjectSavingsCategoryStatus = updateProjectSavingsCategoryStatus;

		// Saml Config Functions
		vm.disableSamlProfile = disableSamlProfile;
		vm.activateSamlProfile = activateSamlProfile;
		vm.deleteSamlProfile = deleteSamlProfile;
		vm.editSamlProfile = editSamlProfile;
		vm.addSamlProfile = addSamlProfile;
		vm.addMetadataSp = addMetadataSp;
		vm.toggleLegacyEntityID = toggleLegacyEntityID;



		// Project Area Functions
		vm.startEditProjectAreaApprovers = startEditProjectAreaApprovers;
		vm.saveEditProjectAreaApprovers = saveEditProjectAreaApprovers;
		vm.deleteProjectArea = deleteProjectArea;

		// Flex Field Config Functions
		vm.deactivateFlexField = deactivateFlexField;

		// Renderer functions
		vm.openSlideIn = openSlideIn;
		vm.openItemDrilldown = openItemDrilldown;

		vm.openItemSearchSlideIn = openItemSearchSlideIn;
		vm.addTask = addTask;
		vm.tooltipIsReady = tooltipIsReady;
		vm.openLatePrCountDrilldown = drilldownFunctionsService.openLatePrCountDrilldown;

		vm.isReadOnly = isReadOnly;
		vm.tooltipPlacements = {};

		vm.maybeGenerateReportURL = maybeGenerateReportURL;
		vm.setReportURL = setReportURL;

		// Project Category Functions
		vm.saveProjectCategory = saveProjectCategory;
		vm.updateProjectCategoryStatus = updateProjectCategoryStatus;
		vm.deleteProjectCategory = deleteProjectCategory;

		// chat
		vm.chatsLastActive = {};
		vm.watchedChats = [];

		// Handle select-dropdown roleGroup grouping translations
		vm.translateRoleGroup = function(item) {
			return $translate.instant(item.roleGroup);
		};

		//Hails from SmartTable utilities folder. Modified to rely on lean-table directive content instead.
		//Receives signal from new-grid-test.html to activate. Necessary because that HTML file can't use this controller
		//directly.

		$scope.$on('reloadTable', function (event, args) {
			reloadTable(args && args['start']);
		});

		$scope.$on('refreshTable', function(event, args) {
			refreshTable(undefined, undefined, false, false);
		});

		$rootScope.$on('updateChatWatchers', function (event, watchedChats) {
			var decided = {};
			var updateArgs = [];

			if (watchedChats && watchedChats.length) {
				// checking against last watched
				vm.watchedChats.forEach(function (chatId) {
					if (watchedChats.includes(chatId)) {
						updateArgs.push({
							useChatIdentifier: true,
							chatId: chatId,
							newValues: {
								chatWatchedByCurrentUser: true
							}
						});
					} else {
						updateArgs.push({
							useChatIdentifier: true,
							chatId: chatId,
							newValues: {
								chatWatchedByCurrentUser: false
							}
						});
					}

					decided[chatId] = true;
				});

				// any new watched - true
				watchedChats.forEach(function (chatId) {
					if (!decided[chatId]) {
						updateArgs.push({
							useChatIdentifier: true,
							chatId: chatId,
							newValues: {
								chatWatchedByCurrentUser: true
							}
						});
					}
				});

				if (updateArgs.length) {
					updateRows(updateArgs, true);
				}
				vm.watchedChats = watchedChats;
			}
		});

		var isChatEnabled = $experiments.isEnabled('chat-enabled');

		var updateInterval = $interval(function () {
			if(isChatEnabled) {
				var updateArgs = [];
				Object.keys(vm.chatsLastActive).forEach(function(key) {
					var lastActivity = vm.chatsLastActive[key];
					var updateObj = {
						useChatIdentifier: true,
						chatId: key,
						newValues: {
							chatLastActivity: lastActivity,
							chatLastActivityString: storeService.dateUtils.getShortRelativeDate(lastActivity)
						}
					};
					updateArgs.push(updateObj);
				});

				if(updateArgs.length) {
					updateRows(updateArgs, true);
				}
			}
		}, 10000);

		$scope.$on('updateRows', function(event, args) {
			updateRows(args);
		});

		function updatePoIdentifierColumnForExport(columns) {
			if (!columns.includes('poIdentifier')) {
				return;
			}
			var hasExistingIdentifierColumns = false;
			poIdentifierColumns.forEach(function (poIdentifierColumn) {
				var existingPoIdentifierColumn = columns.findIndex(function (column) {
					return column === poIdentifierColumn;
				});
				if (existingPoIdentifierColumn >= 0) {
					hasExistingIdentifierColumns = true;
				}
			});

			var poIdentifierIndex = columns.findIndex(function (column) {
				return column === 'poIdentifier';
			});

			columns.splice(poIdentifierIndex, 1);
			if (hasExistingIdentifierColumns) {
				return;
			}
			poIdentifierColumns.forEach(function (column) {
				columns.splice(poIdentifierIndex, 0, column);
			});
		}

		function doExport(args) {
			var modalScope = $scope.$new();
			var columns = args.columns ? args.columns.map(function(c) { return c.id; }) : [];
			if (args.type === 'visibleOnly') {
				columns = vm.pinnedColumns.filter(function(col) { return col.show && !col.disabled;}).map(function(col) { return col.id;});
				if (!columns) {
					columns = [];
				}
				columns = columns.concat(vm.columns.filter(function(col) { return col.show && !col.disabled;}).map(function(col) { return col.defaultId || col.id;}));
			}
			var url = '';
			if (excelRequest) {
				url = URLS.prefix + leanFilterService.getFactoryList() + '/' + vm.tableName + '?';
			} else {
				url = URLS.prefix + leanFilterService.getFactoryList() + '/ExcelReports/' + vm.tableName + '?';
			}
			url += 'columns=' + columns + '&';
			var sorter = [{}];
			for (var i = 0; i < currentSort.length; i++) {
				sorter[0].property = currentSort[i].overrideProperty || currentSort[i].property;
				sorter[0].direction = currentSort[i].direction.toUpperCase();
			}
			if (sorter[0].property) {
				url += 'sort=' + JSON.stringify(sorter);
			}
			if (extraParams) {
				for (var i = 0; i < extraParams.length; i++) {
					if (extraParams[i].name != undefined) {
						url = appendQueryParam(url, extraParams[i].name, extraParams[i].value);
					}
				}
			}
			url = encodeURI(url);
			url = appendQueryParam(url, 'excelRequest', true);
			if (usePost) {
				url = leanFilterService.addFilterQueryParams(url, true);
				var data = {};
				var msFilters = leanFilterService.getQueryParam(true, false, true);
				for (var i = 0; i < msFilters.length; i++) {
					data[msFilters[i].key] = msFilters[i].value.toString();
				}
				data.columns = columns;

				return excelExportService.getExcelReportNew(vm.tableName, leanFilterService.getFactoryList(), data, url, modalScope, undefined, undefined, args.exportFileName);
			} else if (useReportBuilderForExcel) {
				var body = {};
				var tempUrl = args.alternateUrl ? args.alternateUrl : reportUrl;
				var factoryIds = args.factoryNdxs ? args.factoryNdxs: leanFilterService.getFactoryList();
				tempUrl = maybeGenerateReportURL(tempUrl);
				url = (noFactory ? '2/' : URLS.prefix) +
					String.format(tempUrl, factoryIds);
				body.excelExportType = args.type;
				body.isUploadTemplate = args.isUploadTemplate;
				body.isForecast = args.isForecast;
				body.filters = args.filters ? args.filters: leanFilterService.getFiltersForPost();
				if (args.exportParams) {
					body.exportParams = args.exportParams;
				}
				if (useExtraParamsForExcelWithReportBuilder && extraParams) {
					var extraParamsObj = {};
					for (var i = 0; i < extraParams.length; i++) {
						var extraParam = extraParams[i];
						extraParamsObj[extraParam.name] = extraParam.value;
					}
					if (args.addSupplyDemandRows) {
						extraParamsObj.addSupplyDemandRows = args.addSupplyDemandRows;
					}
					if (args.includeTotalRows !== null) {
						extraParamsObj.includeTotalRows = args.includeTotalRows;
					}
					if (args.scheduledDeliveriesHotSheetFlag && args.hotSheetTrigger) {
						extraParamsObj.isHotSheet = true;
					}
					body.extraParams = extraParamsObj;
				}
				if (currentSort && currentSort[0]) {
					body.sorters = currentSort;
				}
				updatePoIdentifierColumnForExport(columns);
				body.extendedColumns = {
					'requestedColumns': columns,
					'includeAllColumns': args.includeAllColumnsForExcel
				};
				body.operation = 'excelExport';
				return excelExportService.getExcelReportNew(vm.tableName, leanFilterService.getFactoryList(), body, url, modalScope, true, args.isCsv, args.exportFileName);
			} else {
				url = URLS.host + leanFilterService.addFilterQueryParams(url);
				return excelExportService.getExcelReportWithGet(leanFilterService.getFactoryList(), url, modalScope, undefined, undefined, args.exportFileName);
			}
		}

		$scope.$on('export-excel', function (event, args) {
			if (!args) {
				args = {};
			}
			if (!args.doChooseColumns) {
				return doExport(args);
			}
			var chooseColumnScope = $scope.$new();
			chooseColumnScope.args = args;
			var opts = {
				scope: chooseColumnScope,
				windowClass: 'uib-modal-z-above-pendo',
				templateUrl: '/application/f/reports/excel-export-choose-columns.html',
				backdropClass: 'uib-modal-backdrop-z-above-pendo'
			};

			chooseColumnScope.doExport = function(args) {
				if (instance) {
					instance.close();
					chooseColumnScope.$destroy();
				}
				doExport(args);
			};

			chooseColumnScope.showSupplyAndDemandRowCheckbox = args.showSupplyAndDemandRowCheckbox;
			chooseColumnScope.showTotalRowCheckbox = args.showTotalRowCheckbox;

			chooseColumnScope.toggleSupplyDemandRows = function () {
				userAttributes.set({ 'addSupplyDemandRows': args.addSupplyDemandRows ? 1 : 0 }, true);
			};

			chooseColumnScope.toggleTotalRows = function () {
				userAttributes.set({ 'includeTotalRows': args.includeTotalRows ? 1 : 0 }, true);
			};

			var instance = $uibModal.open(opts);
			chooseColumnScope.closeDialog = function() {
				instance.close();
				chooseColumnScope.$destroy();
			};
		});

		$scope.$on('show-po-comments-upload', function (event, args) {
			var csvArgs = {
				'fileName': 'po_comment_template.csv',
				'columns': 'Site,PO Number,PO Line,Schedule Line,Item Code,Supply Order Commit Date,Supply Order Tracking Number,Supply Order Status,Supply Order Status Category'
			};
			var uploadArgs = {
				'controller': '/SupplyOrder/UploadPoComments',
				'template': '/application/f/supply-chain/reports/supply/upload-po-comments.html'
			};
			var modalTemplateUrl = '/application/f/supply-chain/reports/supply/po-upload-modal.html';
			var s3XLSXFilePath = '/Template/PurchaseOrder';
			var useLegacy = false;
			if (args) {
				csvArgs = _.merge(csvArgs, args.csvArgs);
				uploadArgs = _.merge(csvArgs, args.uploadArgs);
				if (args.modalTemplateUrl) {
					modalTemplateUrl = args.modalTemplateUrl;
				}
				if (args.s3XLSXFilePath) {
					s3XLSXFilePath = args.s3XLSXFilePath;
				}
				useLegacy = args.useLegacy;
			}
			var uploadScope = $scope.$new();
			uploadScope.uploadPoCommentsFile = function (file, errFiles) {
				uploadScope.closeDialog();
				uploadPoCommentsFile(file, errFiles, uploadArgs);
			};

			uploadScope.isSupplier = globalConfig.user.role === 'Supplier';
			uploadScope.header = 'Upload PO Data';

			var opts = {
				scope: uploadScope,
				templateUrl: modalTemplateUrl,
				windowClass: 'uib-modal-z-above-pendo',
				backdropClass: 'uib-modal-backdrop-z-above-pendo'
			};

			uploadScope.downloadTemplate = function () {
				// IE11 workaround
				if (window.navigator.msSaveBlob) {
					var blob = new Blob([csvArgs.columns], { type: 'text/csv' });
					window.navigator.msSaveOrOpenBlob(blob, csvArgs.fileName);
				} else {
					var a = window.document.createElement('a');
					a.href = 'data:text/csv;charset=utf-8,' + csvArgs.columns;
					a.download = csvArgs.fileName;
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				}
			};

			uploadScope.downloadExcelTemplate = function () {
				if (useLegacy) {
					var adminConfig = storeService.getState().adminConfig;
					jQuery.fileDownload(URLS.host + URLS.prefix + adminConfig.factory.id + s3XLSXFilePath, {
						httpMethod: 'GET',
						encodeHTMLEntities: false,
						successCallback: function (url) { },
						failCallback: function (responseHtml, url) {
							$rootScope.$emit('toast', {
								'message': 'Unable to Download XLSX Template',
								'success': false
							});
						}
					});

				} else {
					var url = URLS.host + URLS.prefix + globalConfig.factory.id + '/PoTemplate';
					var modalScope = $scope.$new();
					return excelExportService.getExcelReportWithGet(globalConfig.factory.id, url, modalScope, undefined, undefined);
				}
			};

			var instance = $uibModal.open(opts);
			uploadScope.closeDialog = function () {
				instance.close();
				uploadScope.$destroy();
			};
		});

		$scope.$on('show-production-order-comments-upload', function (event, args) {
			var uploadArgs = {
				'controller': '/ShortageByOrder/UploadProductionOrderComments',
				'template': '/application/f/supply-chain/analytics/upload-production-order-comments.html'
			};
			var modalTemplateUrl = '/application/f/supply-chain/analytics/production-order-upload-modal.html';

			var uploadScope = $scope.$new();
			uploadScope.uploadProductionOrderCommentsFile = function (file, errFiles) {
				uploadScope.closeDialog();
				uploadPoCommentsFile(file, errFiles, uploadArgs);
			};

			uploadScope.isSupplier = globalConfig.user.role === 'Supplier';
			uploadScope.header = 'Upload PO Data';

			var opts = {
				scope: uploadScope,
				templateUrl: modalTemplateUrl,
				windowClass: 'uib-modal-z-above-pendo',
				backdropClass: 'uib-modal-backdrop-z-above-pendo'
			};

			uploadScope.downloadExcelTemplate = function () {
				uploadScope.$emit('download-production-order-template');
			};

			var instance = $uibModal.open(opts);
			uploadScope.closeDialog = function () {
				instance.close();
				uploadScope.$destroy();
			};
		});

		function uploadPoCommentsFile(file, errFiles, uploadArgs) {
			var errFile = errFiles && errFiles[0];
			if (file) {
				var uploadScope = $scope.$new();
				uploadScope.progressValue = 0;
				uploadScope.showProcessingMessage = false;
				uploadScope.showResults = false;
				uploadScope.allowClose = false;
				uploadScope.progressType = 'primary';
				file.upload = Upload.upload({
					url: '/api/2/factndx/' + globalConfig.factory.id + uploadArgs.controller,
					data: { file: file },
					headers: {
						'isFileUpload': true
					}
				});
				var opts = {
					scope: uploadScope,
					templateUrl: uploadArgs.template,
					backdrop: 'static',
					windowTemplateUrl: '/application/f/reports/upload_comments_template.html'
				};
				var instance = $uibModal.open(opts);
				uploadScope.closeModal = function () {
					instance.close();
					uploadScope.$destroy();
					$scope.$broadcast('reloadTable');
				};
				file.upload.then(function (response) {
					if (response.status && response.status >= 200 && response.status < 400) {
						uploadScope.showProcessingMessage = false;
						uploadScope.showResults = true;
						uploadScope.resultsData = response.data;
						uploadScope.allowClose = true;
						uploadScope.progressType = response.data.rowsRejected === 0 ? 'success' : response.data.rowsProcessed > 0 ? 'warning' : 'danger';
					}
				}, function (response) {
					uploadScope.progressType = 'danger';
					if (response.status > 0) {
						if (response.data && response.data.errors && response.data.errors.length) {
							uploadScope.showResults = false;
							uploadScope.errorData = response.data.errors[0].message;
						} else {
							uploadScope.errorData = 'Unknown error with file.';
						}
						uploadScope.showProcessingMessage = false;
						uploadScope.showError = true;
						uploadScope.allowClose = true;
					}
				}, function (evt) {
					file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					uploadScope.progressValue = file.progress;
					if (uploadScope.progressValue >= 100) {
						uploadScope.showProcessingMessage = true;
					}
				});
			} else if (errFile) {
				$rootScope.$emit('toast', {
					message: 'Invalid file (must be .xlsx)',
					success: false
				});
			}
		}

		$scope.$watch('reportsItemLoading', function(loading) {
			if (loading) {
				jQuery('.report-item-search-typeahead ul.dropdown-menu').hide();
			} else {
				jQuery('.report-item-search-typeahead ul.dropdown-menu').show();
			}
		});

		function setColumnDefaults(columns, pinnedColumns, setColumnDefaults) {
			if (setColumnDefaults) {
				var pinnedPositions = pinnedColumns.map(function (a) { return a.position; });
				var curPosition = 0;
				for (var j = 0; j < pinnedColumns.length; j++) {
					setIndividualColumnDefaultValues(pinnedColumns[j]);
				}
				for (var i = 0; i < columns.length; i++) {
					var col = columns[i];
					curPosition = setDefaultColumnPosition(col, pinnedPositions, curPosition);
					setIndividualColumnDefaultValues(col);
					curPosition++;
				}
			}
			return columns;
		}


		function setIndividualColumnDefaultValues(col) {
			if (col.sort === undefined) {
				col.sort = true;
			}
			if (col.show === undefined) {
				col.show = true;
			}
			if (col.enablePinning === undefined) {
				col.enablePinning = true;
			}
			if (col.enableGrouping === undefined) {
				col.enableGrouping = false;
			}
			if (col.width === undefined) {
				col.width = Math.min(Math.max(col.display.length, 8) * 10, 120);
			}
			if (col.grouped) {
				vm.groupBy = col.id;
			}
			if (col.disabled === undefined) {
				col.disabled = false;
			}
		}

		function setDefaultColumnPosition(col, pinnedPositions, curPosition) {
			if (col.position === undefined) {
				while (pinnedPositions.includes(curPosition)) {
					curPosition++;
				}
				col.position = curPosition;
				col.order = curPosition;
				return col.position;
			}
			return col.position;
		}

		function setDefaultWidths() {
			if (vm.columns && vm.columns.length) {
				for (var i = 0; i < vm.columns.length; i++) {
					var col = vm.columns[i];
					col.defaultWidth = col.width;
				}
			}
		}

		function ensurePopupInBound(position, popupWidth, popupHeight) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + popupWidth > windowWidth) {
				position.left = position.left - (position.left + popupWidth - windowWidth - 8);
			}
			if (position.top + popupHeight > windowHeight) {
				position.top = position.top - (position.top + popupHeight - windowHeight - 8);
			}
		}

		function reportConfigReady(reportConfig, controllerModifiesColumns) {
			if (reportSettingsName === globalReportName || vm.getMeta().reportSettingsId === globalReportName) {
				var reportSettings = storeService.getState().reportSettings;
				if (['dashboards', 'savedReports', 'savedLeanProjects'].indexOf(reportSettings.viewType) > -1) {
					if (reportSettings.identifierNdx && reportSettings.identifierNdx !== globalConfig.customer.id) {
						var sitesByCustomer = siteService.getSitesByCustomer(reportSettings.identifierNdx);
						if (sitesByCustomer.length) {
							var customerName = globalConfig.user.authFacts[sitesByCustomer[0].id].customerName;
							showSiteSwitchModal(reportSettings.viewType, reportSettings.reportName, customerName, reportSettings.identifierNdx);
						} else {
							goToHome(reportSettings.viewType);
						}
						return;
					}
				}
				vm.reportIsAuthorized = storeService.getState().reportSettings.authorizationLevel !== 'NONE';
				if (vm.reportIsAuthorized) {
					processConfig(reportConfig);
					if (!controllerModifiesColumns) {
						updateWidthOfTables();
					}
					if (vm.waitForFilters) {
						leanFilterService.loadFilters(true);
						getData(undefined, false, vm.waitForFilters);
					} else {
						getData(undefined, true, vm.waitForFilters);
					}
				} else {
					vm.unauthorizedType = reportSettings.viewType === 'dashboards' ? 'dashboard' : 'shared view';
					$scope.$emit('hideButtonsForMissingSites');
				}
			}
		}

		function showSiteSwitchModal(viewType, reportName, customerName, identifierNdx) {
			var modalScope = $scope.$new();
			modalScope.switch = {
				'typeOfView': viewType === 'dashboards' ? 'dashboard' : 'saved report',
				'viewName': reportName,
				'customerName': customerName
			};

			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/core/navigation/switch-site-modal.html'
			};
			var siteChangedModal = $uibModal.open(opts);

			modalScope.closeModal = function() {
				siteChangedModal.close();
				if (viewType === 'savedReports') {
					$state.go('app.supply-chain.report-list');	
				} else {
					goToHome(viewType);
				}
			};

			modalScope.switchSite = function() {
				navigationService.getLoginSiteForCustomer(identifierNdx).then(function (data) {
					localStorageService.set('newSiteId', data.factoryNdx);
					userService.switchSite(data.factoryNdx, true);
				});
			};
		}

		function goToHome(viewType) {
			if (viewType === 'dashboards') {
				$state.go('app.dashboard');
			} else {
				$state.go('.', {reportId: undefined});
			}
		}

		function createTable() {
			getDataCalled = false;
			// Get Meta Info for Report
			var meta = vm.getMeta();
			globalReportName = meta.reportSettingsId || meta.reportSettingsName;
			reportSettingsName = meta.reportSettingsName;
			isGlobalReportSetting = meta.isGlobalReportSetting;
			extraParams = meta.extraParams;
			rendererParams = meta.rendererParams;
			searchType = meta.searchType ? meta.searchType : 'item';
			leanFilterService.searchType = searchType;
			defaultSort = meta.defaultSort;
			defaultSortDirection = meta.defaultSortDirection || 'asc';
			defaultFilters = meta.defaultFilters;
			noPaging = meta.noPaging;
			recordsPerPage = meta.recordsPerPage ? meta.recordsPerPage : 50;
			controllerModifiesColumns = meta.controllerModifiesColumns;
			usePost = typeof meta.usePost !== 'undefined' && meta.usePost;
			useReportBuilderForExcel = typeof meta.useReportBuilderForExcel !== 'undefined' && meta.useReportBuilderForExcel;
			useExtraParamsForExcelWithReportBuilder = typeof meta.useExtraParamsForExcelWithReportBuilder !== 'undefined' && meta.useExtraParamsForExcelWithReportBuilder;
			isBackendGrouping =  typeof meta.isBackendGrouping !== 'undefined' && meta.isBackendGrouping;
			reportHasMandatoryFilters = typeof meta.hasMandatoryFilters !== 'undefined' && meta.hasMandatoryFilters;
			urlGenerator = meta.urlGenerator;
			vm.hidePeggedIcon = meta.hidePeggedIcon;
			vm.tableClass = meta.tableClass ? meta.tableClass: '';
			vm.searchType = searchType;
			vm.columns = setColumnDefaults(meta.columns, meta.pinnedColumns, meta.setColumnDefaults);
			vm.pinnedColumns = meta.pinnedColumns;
			reportUrl = meta.reportUrl;
			noFactory = meta.noFactory;
			vm.hideSearch = meta.hideSearch;
			vm.footer = meta.footer;
			vm.showExcel = extraParams[0].showExcel;
			vm.tableName = extraParams[0].excelReportName;
			vm.searchPlaceholderText = meta.specialPlaceholderText ? meta.specialPlaceholderText : 'Search ' + searchType + 's...';
			vm.hideFilters = typeof meta !== 'undefined' && meta.hideFilters;
			vm.hideFiltersContainer= meta.hideFiltersContainer;
			vm.hideNoResultsSuggestion = meta.hideNoResultsSuggestion;
			vm.hasTabs = meta.hasTabs;
			vm.waitForFilters = meta.waitForFilters ? meta.waitForFilters : false;
			vm.useBackendCurrencyConversion = typeof meta.useBackendCurrencyConversion !== 'undefined' && meta.useBackendCurrencyConversion;
			vm.showSaveButton = typeof meta.showSaveButton !== 'undefined' && meta.showSaveButton;
			vm.extraText = meta.extraText;
			vm.hideColumnSelector = meta.hideColumnSelector;
			hasChat = meta.hasChat;
			chatIdentifier = meta.chatIdentifier;
			if (meta.alternateNoResultText) {
				vm.alternateNoResultText = meta.alternateNoResultText;
			}
			if (meta.alternateNoResultSuggest) {
				vm.alternateNoResultSuggest = meta.alternateNoResultSuggest;
			}

			excelRequest = meta.excelRequest;
			setDefaultWidths();

			// Pagination
			paginationObject.pageSize = meta.pageSize ? meta.pageSize : 0;
			paginationObject.currentStart = 0;
			paginationObject.totalRows = 0;
			paginationObject.currentPage = 1;
			paginationObject.totalPages = 1;
			paginationObject.pagingResultsTimedOut = false;
			curUrl = window.location.href;

			// Set Filters
			$scope.filterService = leanFilterService;
			$scope.filters = leanFilterService.masterFilterList;
			$scope.rangeFilters = leanFilterService.masterRangeFilterList;
			$scope.stringFilters = leanFilterService.masterStringFilterList;
			$scope.singleSelectFilters = leanFilterService.masterSingleSelectFilterList;
			leanFilterService.setSearchBoxDataValue('');
			leanFilterService.clearFiltersLoaded();
			setFilterFunctions();

			reportSettingsScope = meta.reportSettingsScope || 'customer';
			reportSettingsScope = isGlobalReportSetting ? 'global' : reportSettingsScope;

			leanFilterService.setResetReportSettingsSettings(reportSettingsName, reportSettingsScope);

			//Check URL query params here and set variables appropriately
			checkQueryParams();

			reportConfigListener = $rootScope.$on('reportConfigReady', function () {
				reportConfigReady(storeService.getState().reportSettings, controllerModifiesColumns);
			});
			leanTableConfigService.setExtraFilters(meta.extraFilters);
			leanTableConfigService.setMandatoryDefaultFilters(reportHasMandatoryFilters);
			leanTableConfigService.setDefaultFilters(defaultFilters);
			storeService.dispatch(storeService.actionCreators.setDefaultFilters(defaultFilters));
			leanTableConfigService.setDefaultSorter(defaultSort, defaultSortDirection);
			leanTableConfigService.setReportSettingsId(meta.reportSettingsId);
			var viewType = FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[reportSettingsName] || '';
			var siteForReportSettings = meta.useAdminSiteForReportSettings ? storeService.getState().adminConfig.factory.id : null;
			$timeout(function () {
				leanTableConfigService.getConfig(vm.columns, reportSettingsName, reportSettingsScope, viewType, siteForReportSettings);
			});
		}

		/**
		 * Takes the backend config and updates sort, pinned, grouped, and displayed columns
		 */
		function checkQueryParams() {
			var queryParams = $location.search();
			if (!noPaging) {
				var curPage = queryParams['Pg'];
				if (curPage == undefined) {
					curPage = 1;
				} else {
					curPage = parseInt(curPage);
				}
				paginationObject.currentStart = (curPage - 1) * paginationObject.pageSize;
				paginationObject.currentPage = curPage;
			}
			var sortCol = queryParams['sort'];
			if (sortCol && !checkValidSort(sortCol)) {
				queryParams['sort'] = '';
			}
			$location.search(queryParams);
		}

		//If user has passed in a sort value for a column
		//this function checks to see if that column actually exists in the report so that the GET call doesn't get bad input
		function checkValidSort(sortId) {
			var exists = getColumn(sortId);
			if (exists == undefined) {
				return false;
			}
			return true;
		}

		function readColumnWidthsFromStoredSettings(columnSettings) {
			var resolutionVal = getResolutionVal();
			angular.forEach(columnSettings, function (col) {
				var uWidth = col.width[resolutionVal];
				if (uWidth && uWidth < 0) {
					uWidth = 20;
				}
				if (uWidth) {
					var index = findInArray(vm.columns, 'id', col.name);
					if (index >= 0) {
						vm.columns[index].width = parseInt(uWidth);
					}
				}
			});
		}

		function updateColumnsFromStoredSettings(columnSettings) {
			if (columnSettings && columnSettings.length) {
				// clear out existing positions
				vm.columns.forEach(function(col) {
					col.position = -1;
				});
				var i = 0;
				for (i = 0; i < columnSettings.length; i++) {
					var index = findInArray(vm.columns, 'id', columnSettings[i].name);
					if (index >= 0) {
						vm.columns[index].show = columnSettings[i].show;
						vm.columns[index].pinnedLeft = columnSettings[i].pinnedLeft;
						vm.columns[index].grouped = columnSettings[i].grouped;
						vm.columns[index].position = i;
					}
				}
				// set all columns that were not in reportsettings to end (for now)
				vm.columns.forEach(function(col) {
					if(col.position < 0) {
						col.position = i++;
					}
				});

				// reorder vm.columns based on position
				vm.columns = _.orderBy(vm.columns, ['position'], ['asc']);
			}
		}

		function processConfig(reportConfig) {
			if (!reportConfig) return;

			if (reportConfig.sorters && reportConfig.sorters.length) {
				currentSort = [];
				_.forEach(reportConfig.sorters, function (sorter) {
					var newSorter = {
						property: sorter.property,
						direction: sorter.direction.toLowerCase()
					};
					var sortColumn = getColumn(newSorter.property);
					if (sortColumn && sortColumn.sort) {
						currentSort.push(newSorter);
					}
				});
			}
			if (reportConfig.columns && reportConfig.columns.length) {
				updateColumnsFromStoredSettings(reportConfig.columns);
				readColumnWidthsFromStoredSettings(reportConfig.columns);
				var pinnedColList = [];
				_.forEach(reportConfig.columns, function (col) {
					if (col.grouped) {
						vm.groupBy = col.name;
					}
					if (col.pinnedLeft) {
						pinnedColList.push(col);
					}
				});
				pinnedColList = _.sortBy(pinnedColList, ['pinnedPosition']);
				_.forEach(pinnedColList, function (col) {
					pinColumn(col.name, true);
				});
			}
			if (reportConfig.search) {
				vm.search.term = reportConfig.search;
				vm.noResultsText = 'We couldn\'t find any results that match that search on this report.';
				vm.noResultsSuggestion = 'Please try another one.';
				vm.filtered = false;
			}
			if (reportConfig.filters) {
				vm.noResultsText = 'We couldn\'t find any results that match this filter.';
				if (reportConfig.childReportSettingsId) {
					vm.noResultsSuggestion = 'If this is unexpected, check with the owner of this shared view.';
					vm.isShared = true;
				} else {
					vm.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
					vm.clearFiltersText = 'Or, clear the filters and start over.';
					vm.isShared = false;
					vm.filtered = true;
				}
			}
			if (vm.alternateNoResultText) {
				vm.noResultsText = vm.alternateNoResultText;
				vm.filtered = false;
			}
			if (vm.alternateNoResultSuggest) {
				vm.noResultsSuggestion = vm.alternateNoResultSuggest;
				vm.filtered = false;
			}
		}

		function maybeGenerateReportURL(originalUrl) {
			if (urlGenerator) {
				return urlGenerator();
			}
			return originalUrl;
		}

		function setReportURL(params, reportURL) {
			params.url = reportURL;
		}

		// not 0 since sometimes it doesn't take one macrotask in event loop
		var debouncedFindTopicsFromChatCellsDispatch = _.debounce(function() {
			storeService.dispatch(storeService.thunks.findTopicsFromChatCells());
		}, 50, false);

		function loadChats() {
			var chatState = storeService.getState();
			if (chatState['chat']) {
				chatState = chatState['chat'];
			}
			angular.forEach(vm.displayedData, function(row) {

				var identifier = row.poIdentifier;
				var poNumber = row.firstPurchaseOrderNumber || row.supplyOrderNumber || row.purchaseOrderNumber || row.orderNumber;

				if(!identifier && poNumber) {
					var poLine = row.firstPurchaseOrderLine || row.orderLine || row.purchaseOrderLine;
					var scheduleLine = row.firstPurchaseOrderScheduleLine || row.scheduleLine;

					identifier = row.itemNdx + ':' + poNumber + ':' + poLine + ':' + scheduleLine;
				}

				var isSupplier = globalConfig.user.role === 'Supplier';

				if (identifier) {
					var chatAvailable = (chatState && chatState.currentChats) ? Boolean(chatState.currentChats[identifier]) : false;
					var extTopicMissing = chatAvailable ? !chatState.currentChats[identifier].external.topicName : true;
					var intTopicMissing = true;
					if(!isSupplier) {
						intTopicMissing = chatAvailable ? !chatState.currentChats[identifier].internal.topicName : true;
					}

					// if one of topics missing create/find
					if (extTopicMissing || intTopicMissing) {
						// if both topics are missing - create chat skeleton in redux
						if(extTopicMissing && intTopicMissing) {
							storeService.dispatch(storeService.actionCreators.createChatObjById({ chatId: identifier, withInternal: !isSupplier }));
						}
						debouncedFindTopicsFromChatCellsDispatch();
					}

					if(chatAvailable) {
						row['chatWatchedByCurrentUser'] = chatState.watchedChats.includes(identifier);
						row['chatLastActivity'] = chatState.currentChats[identifier].lastActivity;
						row['chatStatus'] = leanTableConfigService.getChatStatus(chatState.currentChats[identifier]);
					}
				}
			});
		}

		function getData(start, loadFilters, waitForFilters, isFilterChanged) {
			if (tableState && (!waitForFilters || !leanFilterService.isLoading())) {
				var params = {
					reportName: reportSettingsName,
					start: 0,
					number: recordsPerPage,
					sort: currentSort,
					noPaging: noPaging,
					url: reportUrl,
					grouped: vm.groupBy,
					noFactory: noFactory,
					usePost: usePost,
					isBackendGrouping: isBackendGrouping
				};

				setReportURL(params, maybeGenerateReportURL(params.url));

				if (currentSort && currentSort.length && !noPaging) {
					params.sort = [];
					_.forEach(currentSort, function (sorter) {
						var obj = {
							property: sorter.overrideProperty || sorter.property,
							direction: sorter.direction.toUpperCase()
						};
						params.sort.push(obj);
					});
				}
				if (start === 0) {
					paginationObject.currentStart = start;
					paginationObject.currentPage = Math.floor(paginationObject.currentStart / paginationObject.pageSize) + 1;
				} else {
					start = paginationObject.currentStart;
				}
				params.start = start;


				//If URL queries need be set, set them here.

				if (!noPaging) {
					var queryParams = $location.search();
					if (queryParams['Pg'] != paginationObject.currentPage) {
						vm.expandedRows = {};
					}
					queryParams['Pg'] = paginationObject.currentPage;
					$location.search(queryParams);
					window.location.replace($location.$$absUrl);
				}
				vm.cancelEdit();
				var dataPromise = vm.getData({
					'params': params,
					'extraParams': extraParams,
					'isFilterChanged': isFilterChanged
				});

				if (dataPromise) {
					dataPromise.then(function (response) {
						if (reportSettingsName !== globalReportName && vm.getMeta().reportSettingsId !== globalReportName) {
							return;
						}
						if (controllerModifiesColumns) {
							updateWidthOfTables();
						}
						//Internal Inventory actions returns only row data fields.
						if (!response[0].data) {
							originalData = response[0];
							vm.displayedData = response[0];
							if (response[0] === '' || !Array.isArray(response[0])) {
								originalData = [];
								vm.displayedData = [];
							}
						} else {
							if (response[0].excludePurchaseReqs) {
								rendererParams.excludePurchaseReqs = true;
							}
							vm.displayedData = response[0].data;
							originalData = response[0].data;
							vm.rowData = vm.displayedData;
						}
						refreshMeta = response.refreshMeta;
						if (refreshMeta) {
							vm.columns = vm.getMeta().columns;
							vm.pinnedColumns = vm.getMeta().pinnedColumns;
							// remove pinnedColumns from columns
							for (var i = 0; i < vm.pinnedColumns.length; i++) {
								var indexInCols = findInArray(vm.columns, 'id', vm.pinnedColumns[i].id);
								if (indexInCols >= 0) {
									vm.columns.splice(indexInCols, 1);
								}
							}
							setColumnDefaults(vm.columns, vm.pinnedColumns, vm.getMeta().setColumnDefaults);
							rendererParams.columns = vm.columns;
						}
						// Set currency
						currencySymbol = response[0].targetCurrency ? response[0].targetCurrency : '$';
						rendererParams.currencySymbol = currencySymbol;
						rendererParams.conversionFactorBySite = response[0].conversionFactorBySite && !vm.useBackendCurrencyConversion ? response[0].conversionFactorBySite : null;
						if (!noPaging) {
							// Set total count of data
							if (!(isBackendGrouping && vm.groupBy)) {
								paginationObject.totalRows = response[1].total;
							} else {
								paginationObject.totalRows = 0;
							}
							paginationObject.pagingResultsTimedOut = response[1].pagingResultsTimedOut;
							if (response[1].total) {
								paginationObject.totalPages = Math.ceil(response[1].total / paginationObject.pageSize);
								paginationObject.totalPages = paginationObject.totalPages == 0 ? 1 : paginationObject.totalPages;
							} else {
								paginationObject.totalPages = 1;
							}
						}

						if (vm.displayedData && vm.displayedData.length === 0) {
							vm.foundNothing = true;
							paginationObject.currentPage = 1;
							paginationObject.totalRows = 0;
							jQuery('.fake-scroller').height(0);
							getDataCalled = true;
							refreshTable(undefined, true, false);
							$scope.$emit('showRowsCalled');
						} else {
							if (hasChat) {
								loadChats();
							}
							vm.foundNothing = false;
							var updateTableWidths = vm.foundNothing;
							reapplyGroup();
							reapplySort();
							if (vm.footer) {
								vm.displayedData.push(response['footer']);
								rendererParams.lastIndex = vm.displayedData.length - 1;
							}
							vm.selectedRow = '';
							initialWidths();
							getDataCalled = true;
							refreshTable(undefined, undefined, false, updateTableWidths);
							// Scroll to the top
							jQuery('#mainTableScroll').scrollTop(0);
						}
						// Reset everything
					});
				}
				if (loadFilters && !vm.getMeta().controllerHandlesFilterLoad && dataPromise) {
					$timeout(function () {
						if (reportSettingsName === globalReportName || vm.getMeta().reportSettingsId === globalReportName) {
							leanFilterService.loadFilters();
						}
					});
				}
			} else {
				setTimeout(function () {
					getData(start, loadFilters, waitForFilters, isFilterChanged);
				}, 10);
			}
		}

		function savePoCommentStatus(factoryNdx, comment) {
			commentsService.saveComment(factoryNdx, 'poComment', comment);
		}

		function updateRows(args, keepEdit) {
			if (!Array.isArray(args)) {
				args = [args];
			}

			if(args.length) {
				args.forEach(updateRowData);
				refreshTable(undefined, undefined, false, false, keepEdit);
			}
		}

		function updateRowData(args) {
			if (hasChat && chatIdentifier && args.useChatIdentifier) {
				args.identifier = {
					poIdentifier: args.chatId
				};
				var lastActivity = args.newValues.chatLastActivity;
				if(lastActivity) {
					vm.chatsLastActive[args.chatId] = lastActivity;

					if(!args.newValues.chatLastActivityString) {
						args.newValues.chatLastActivityString = storeService.dateUtils.getShortRelativeDate(lastActivity);
					}
				}
			}

			var filteredResults = _.filter(vm.displayedData, args.identifier);

			if (args.updatePoStatus && filteredResults.length !== 0) {
				var result = filteredResults[0];
				var factoryNdx = result.factoryNdx || result.leanDirFactoryNdx;
				var comment = {
					itemNdx: chatIdentifierValues[0],
					poNumber: chatIdentifierValues[1],
					poLine: chatIdentifierValues[2],
					scheduleLine: chatIdentifierValues[3],
					comment: strip(args.newValues.firstPoStatus || ''),
					subType: 'status'
				};
				savePoCommentStatus(factoryNdx, comment);
			}
			_.map(filteredResults, function(row) {
				if (args.incrementActionCount && args.newValues) {
					var prevCount = 0;
					// Prefer taskCount (procurement only) over actionCount so an IA-inclusive
					// actionCount left on the row does not inflate the badge after add.
					if (row.taskCount != null && row.taskCount !== '' && !isNaN(Number(row.taskCount))) {
						prevCount = Number(row.taskCount);
					} else if (row.actionCount != null && row.actionCount !== '' && !isNaN(Number(row.actionCount))) {
						prevCount = Number(row.actionCount);
					} else if (row.taskIds) {
						prevCount = String(row.taskIds).split(',').map(function (part) {
							return part.trim();
						}).filter(Boolean).length;
					} else if (row.actionStatusNdx != null && row.actionStatusNdx !== '') {
						if (typeof row.actionStatusNdx === 'number') {
							prevCount = 1;
						} else {
							prevCount = String(row.actionStatusNdx).split(',').map(function (part) {
								return part.trim();
							}).filter(Boolean).length;
						}
					} else if (typeof row.actionStatus === 'string' && row.actionStatus.indexOf(', ') >= 0) {
						prevCount = row.actionStatus.split(', ').map(function (part) {
							return part.trim();
						}).filter(Boolean).length;
					} else if ((row.taskId || row.actionNdx) && row.actionStatus && row.actionStatus !== 'None' && row.actionStatus !== 'Archived') {
						prevCount = 1;
					}
					var newTaskId = args.newValues.taskId;
					var existingTaskId = row.taskId != null ? row.taskId : row.actionNdx;
					// Count as an additional task when the item already has tasks and this is a new id
					// (or the row has no task id field — e.g. Spend exposes actionNdx only sometimes).
					var isAdditionalTask = prevCount > 0 && newTaskId != null
						&& (existingTaskId == null || String(existingTaskId) !== String(newTaskId));
					// First task on an empty row, or a second+ task on an item that already has tasks.
					if (isAdditionalTask) {
						args.newValues.actionCount = prevCount + 1;
					} else if (prevCount === 0 && (newTaskId != null || args.newValues.actionStatus)) {
						args.newValues.actionCount = 1;
					} else {
						args.newValues.actionCount = Math.max(prevCount, 1);
					}
					args.newValues.numTasks = args.newValues.actionCount;
					args.newValues.taskCount = args.newValues.actionCount;
				}
				for (var key in args.newValues) {
					row[key] = args.newValues[key];
				}
			});
		}

		/**
		 * Called by Smart Table's ST-Pipe and used by us to refresh data
		 *
		 * @param {Object} tableState - Smart Table's table meta information
		 */

		function refreshTable(newTableState, skipCreateRows, saveToDb, updateTableWidths, keepEdit) {
			if(!keepEdit) {
				vm.cancelEdit();
			}
			var params = {
				reportName: reportSettingsName,
				start: 0,
				number: recordsPerPage,
				sort: currentSort,
				noPaging: noPaging,
				url: reportUrl,
				grouped: vm.groupBy
			};

			setReportURL(params, maybeGenerateReportURL(params.url));

			if (currentSort && currentSort.length && !noPaging) {
				params.sort = [];
				_.forEach(currentSort, function (sorter) {
					var obj = {
						property: sorter.property,
						direction: sorter.direction.toUpperCase()
					};
					params.sort.push(obj);
				});
			}
			if (newTableState) {
				tableState = newTableState;
			}
			if (getDataCalled && !skipCreateRows) {
				createRows(true, updateTableWidths);
			}
		}


		/**
		 * Roughly, a "<td>" for the report table
		 * returns string
		 *
		 * @param {String} id - Value of id for element
		 * @param {String} classString - Value of class attribute for element
		 * @param {String} styleString - Value of style attribute for element
		 * @param {String} cellContent - What the cell should display
		 */
		function cellToString(id, classString, styleString, cellContent, dataTestAtt) {
			return '<div data-testid="' + dataTestAtt + '" ' + (vm.getMeta().allColumnNonBinding ? 'ng-non-bindable' : '') + ' class="' + classString + '" id="' + id + '" style="' + styleString + '">' + cellContent + '</div>';
		}

		/**
		 * Creates a list of <tr>'s for each table and
		 * appends them to the DOM
		 *
		 * @param {String} cellValue - Content you want to display in the table cell, should be a value like a string or number, not markup
		 * @param {String} classString - value of class attribute for element
		 */
		function cellContentToString(cellValue, classString, translate) {
			var cleanedCellValue = cellValue === undefined ? '' : strip(cellValue);
			if (translate && cleanedCellValue !== '') {
				cleanedCellValue = $translate.instant(cleanedCellValue);
			}
			return '<div class="' + classString + '" title="' + cleanedCellValue.replace(/\"/g, '&quot;') + '">' + cleanedCellValue + '</div>';
		}

		/**
		 * Creates an array of cells
		 * Returns an array of strings representing markup of cells in row
		 *
		 * @param {Array} cols - Array of column data
		 * @param {Object} row - ???
		 * @param {Object} rendererParams - ???
		 */
		function createRowContentString(cols, row, index, rendererParams) {
			var colList = '';
			_.forEach(cols, function (col) {
				if (!col.show || col.disabled) {
					return; // This is 'continue' to lodash // TODO: Does this still work?
				}
				if (col.forceWidth) {
					col.width = col.forceWidth;
				}
				var styleString = 'width: ' + col.width + 'px;';
				var classString = 'cell-div';

				if (row.isTotal) {
					classString += ' total-row';
				}

				if (rendererParams.lastIndex && index == rendererParams.lastIndex) {
					classString += ' footer';
				}
				if (rendererParams.grayRow && (row.description == null || row.description == '' || row.displayName == null || row.displayName == '')) {
					classString += ' grayCell';
				}
				var renderedCell;
				if (!col.renderer) {
					renderedCell = cellContentToString(row[col.id], classString, col.translate);
				} else {
					renderedCell = col.renderer(row, col, index, rendererParams);
				}
				var editableTag = col.editable ? 'editable-' : '';
				var dataTestAtt =  'reportCell-' + editableTag + col.id + '-' + index + '-click';
				var cellString = cellToString(col.id + index, col.id + ' ' + col.class, styleString, renderedCell, dataTestAtt);
				colList += cellString;
			});

			return colList;
		}

		/**
		 * Creates a "<tr>" like element
		 * Returns a string representing markup of a row
		 *
		 * @param {Int} index - Row number
		 * @param {String} classString - Value of class attribute for element
		 * @param {String} rowContent - String representing cols in this row
		 */
		function createRowString(index, classString, rowContent, rowFactoryNdx) {
			var dataTrackingAttribute = rowFactoryNdx ? ' data-tracking-reportrow-factoryndx="' + rowFactoryNdx + '"' : '';
			return '<div ng-click="vm.toggleSelectRow(' + index + ', $event)" ng-class="{ expanded: vm.expandedRows[' + index + '], selected: vm.selectedRow === ' + index + ', hovered: vm.hovering === ' + index + '}" ' +
				'ng-mouseenter="vm.hovering =' + index + ';" ng-mouseleave="vm.hovering = -1;" class="table-row ' + classString + '"' + dataTrackingAttribute + '>' + rowContent + '</div>';
		}

		/**
		 * Creates a header for the main section of the table
		 *
		 * @param {String} col - column to create header for
		 */
		function createMainHeaderString(col, visibleColumnIndex) {
			var header = '';
			var colDisplay = $translate.instant(col.display);
			var headerTitle = col.headerTitle && $translate.instant(col.headerTitle);
			if (col.show && !col.disabled) {
				if (col.forceWidth) {
					col.width = col.forceWidth;
				}
				header += '<div ' + (col.forceWidth ? '' : 'resizable-test') + (col.headerTitle ? ' title="' + headerTitle + '"' : '') + ' on-resize="vm.updateColumnWidth(\'' + col.id + '\')" id="header' +
					col.id + '" class="header main-table-headers ' + (col.sort ? ' sortable ' : '') + (!col.sortDirection ? ' not-sorted ' : '') + (!col.hideMenu ? ' has-menu' : '') +
					(col.customHeaderClass ? ' ' + col.customHeaderClass : '') + '" style="width: ' + col.width + 'px" ';

				if ((!vm.hidePeggedIcon && col.peggingTooltip) || col.uibTooltip) {
					var tooltip = col.peggingTooltip || col.uibTooltip;
					header += ' uib-tooltip="{{\''+ tooltip + '\' | translate}}" tooltip-trigger="mouseenter" tooltip-animation="true" tooltip-placement="top" ';
				}
				header += '>';
				var dataTestId = 'data-testid="reportColumn-header-' + col.id;
				header += '<div ' + dataTestId + '-click" ng-click="vm.sortData(\'' + col.id + '\')" class="header-contents"> ';
				if (col.sortDirection) {
					header += '<i class="sort-icon ' +
						((col.isReverseSort && col.sortDirection === 'desc') || (!col.isReverseSort && col.sortDirection === 'asc') ? ' fa fa-fw fa-arrow-up ' : '') +
						((col.isReverseSort && col.sortDirection === 'asc') || (!col.isReverseSort && col.sortDirection === 'desc') ? ' fa fa-fw fa-arrow-down ' : '') +
						'"></i>';
				}
				if (col.display === '$checkbox') {
					header += '<a href ng-click="vm.toggleAllCheckboxes(\'' + col.id + '\')"><i class="fa fa-fw fa-square-o"></i></a>';
				} else {
					if (!vm.hidePeggedIcon && col.peggingTooltip) {
						header += '<ng-include class="pegged-icon" src="\'/application/library/ui_images/svg_icons/pegged.svg\'"></ng-include>';
					}
					header += colDisplay;
				}
				header += '</div>';

				if (!col.hideMenu) {
					header += '<div class="dropdown dropdown-append-to-body" uib-dropdown is-open="vm.columnMenus.' + col.id + '">' +
						'<a href class="dropdown-toggle" aria-haspopup="true" aria-expanded="true" uib-dropdown-toggle>' +
						'<i class="fa fa-caret-down" aria-hidden="true"></i>' +
						'</a>' +
						'<div ng-if="vm.columnMenus.' + col.id + '" class="dropdown-menu ' + (visibleColumnIndex > 3 ? 'open-left' : '') + '" uib-dropdown-menu>' +
						(col.enablePinning ? '<li ' + dataTestId + '-menu-pinColumn" ng-click="vm.pinColumn(\'' + col.id + '\')"><i class="fa fa-thumb-tack"></i><span translate>Pin Column</span></li>' : '') +
						(col.enableGrouping && !isReadOnly() ? '<li ' + dataTestId + '-menu-group" ng-click="vm.groupColumn(\'' + col.id + '\')"><i class="fa fa-object-group" aria-hidden="true"></i><span translate>Group Column</span></li>' : '') +
						(col.sort ? '<li ' + dataTestId + '-menu-sortAscending" ng-click="vm.sortData(\'' + col.id + '\', \'asc\')"><i class="fa fa-sort-amount-asc" aria-hidden="true"></i><span translate>Sort Ascending</span></li>' : '') +
						(col.sort ? '<li ' + dataTestId + '-menu-sortDescending" ng-click="vm.sortData(\'' + col.id + '\', \'desc\')"><i class="fa fa-sort-amount-desc" aria-hidden="true"></i><span translate>Sort Descending</span></li>' : '') +
						(col.sortDirection ? '<li ' + dataTestId + '-menu-removeSort" ng-click="vm.sortData(\'' + col.id + '\', \'clear\')"><i class="fa fa-remove" aria-hidden="true"></i><span translate>Remove Sort</span></li>' : '') +
						(!col.disabledShowHide && !isReadOnly() ? '<li ' + dataTestId + '-menu-removeColumn" ng-click="vm.showColumn(\'' + col.id + '\', false)"><i class="fa fa-user-secret" aria-hidden="true"></i><span translate>Hide Column</span></li>' : '') +
						'<li ' + dataTestId + '-menu-resetWidth" ng-click="vm.resetWidth(\'' + col.id + '\')"><i class="fa fa-refresh"></i><span translate>Reset Width</span></li>' +
						'</div></div>';
				}
				header += '</div>';
			}
			return header;
		}

		/**
		 * Creates a header for the pinned section of the table
		 *
		 * @param {String} col - column to create a header for
		 */
		function createPinnedHeaderString(col) {
			var header = '';
			if (col.show && !col.disabled) {
				if (col.forceWidth) {
					col.width = col.forceWidth;
				}
				var headerTitle = col.headerTitle && $translate.instant(col.headerTitle);
				header += '<div ' + (col.forceWidth ? '' : 'resizable-test') + ' on-resize="vm.updateColumnWidth(\'' + col.id + '\')" id="header' +
					col.id + '" class="header pinned-table-headers ' + (col.sort ? ' sortable ' : '') + (!col.sortDirection ? ' not-sorted ' : '') + (!col.hideMenu ? ' has-menu' : '') +
					(col.customHeaderClass ? ' ' + col.customHeaderClass  : '') + '" style="width: ' + col.width + 'px" ';
				if ((!vm.hidePeggedIcon && col.peggingTooltip) || col.uibTooltip) {
					var tooltip = col.peggingTooltip || col.uibTooltip;
					header += ' uib-tooltip="{{\'' + tooltip + '\' | translate}}" tooltip-trigger="mouseenter" tooltip-animation="true" tooltip-placement="top" ';
				} else if (headerTitle) {
					header += ' title="' + headerTitle + '"';
				}
				header += '>';
				var dataTestId = 'data-testid="reportColumn-header-' + col.id;
				header += '<div ' + dataTestId + '-click" ng-click="vm.sortData(\'' + col.id + '\')" class="header-contents"> ';
				if (col.sortDirection) {
					header += '<i class="sort-icon ' +
						((col.isReverseSort && col.sortDirection === 'desc') || (!col.isReverseSort && col.sortDirection === 'asc') ? ' fa fa-fw fa-arrow-up ' : '') +
						((col.isReverseSort && col.sortDirection === 'asc') || (!col.isReverseSort && col.sortDirection === 'desc') ? ' fa fa-fw fa-arrow-down ' : '') +
						'"></i>';
				}
				if (!vm.hidePeggedIcon && col.peggingTooltip) {
					header += '<ng-include class="pegged-icon" src="\'/application/library/ui_images/svg_icons/pegged.svg\'"></ng-include>';
				}
				if (col.display === '$checkbox') {
					header += '<a href ng-click="vm.toggleAllCheckboxes(\'' + col.id + '\')"><i class="fa fa-fw fa-square-o"></i></a>';
				} else {
					header += $translate.instant(col.display);
				}
				header += '</div>';

				if (!col.hideMenu) {
					header += '<div class="dropdown dropdown-append-to-body" uib-dropdown is-open="vm.columnMenus.' + col.id + '">' +
						'<a href class="dropdown-toggle" aria-haspopup="true" aria-expanded="true" uib-dropdown-toggle>' +
						'<i class="fa fa-caret-down" aria-hidden="true"></i>' +
						'</a>' +
						'<div ng-if="vm.columnMenus.' + col.id + '" class="dropdown-menu" uib-dropdown-menu>' +
						'<li ' + dataTestId + '-menu-unpinColumn" ng-click="vm.unpinColumn(\'' + col.id + '\')"><i class="fa fa-remove"></i><span translate>Unpin Column</span></li>' +
						(col.enableGrouping && !isReadOnly() ? '<li ' + dataTestId + '-menu-group" ng-click="vm.groupColumn(\'' + col.id + '\')"><i class="fa fa-object-group" aria-hidden="true"></i><span translate>Group Column</span></li>' : '') +
						(col.sort ? '<li ' + dataTestId + '-menu-sortAscending" ng-click="vm.sortData(\'' + col.id + '\', \'asc\')"><i class="fa fa-sort-amount-asc" aria-hidden="true"></i><span translate>Sort Ascending</span></li>' : '') +
						(col.sort ? '<li ' + dataTestId + '-menu-sortDescending" ng-click="vm.sortData(\'' + col.id + '\', \'desc\')"><i class="fa fa-sort-amount-desc" aria-hidden="true"></i><span translate>Sort Descending</span></li>' : '') +
						(col.sortDirection ? '<li ' + dataTestId + '-menu-removeSort" ng-click="vm.sortData(\'' + col.id + '\', \'clear\')"><i class="fa fa-remove" aria-hidden="true"></i><span translate>Remove Sort</span></li>' : '') +
						(!col.disabledShowHide && !isReadOnly() ? '<li ' + dataTestId + '-menu-removeColumn" ng-click="vm.showColumn(\'' + col.id + '\', false)"><i class="fa fa-user-secret" aria-hidden="true"></i><span translate>Hide Column</span></li>' : '') +
                        '<li ' + dataTestId + '-menu-resetWidth" ng-click="vm.resetWidth(\'' + col.id + '\')"><i class="fa fa-refresh"></i><span translate>Reset Width</span></li>' +
						'</div></div>';
				}
				header += '</div>';
			}
			return header;
		}

		/**
		 * Creates a header for the grouped part of the table
		 *
		 * @param {String} col - column to create a header for
		 */
		function createGroupHeaderString(col, visibleColumnIndex) {
			var header = '';
			if (col.show && !col.disabled) {
				header += '<div resizable-test on-resize="vm.updateColumnWidth(\'' + col.id + '\')" id="header' +
					col.id + '" class="header group-table-headers ' + (col.sort ? ' sortable ' : '') + (!col.sortDirection ? ' not-sorted ' : '') + (!col.hideMenu ? ' has-menu' : '') +
					(col.customHeaderClass ? ' ' + col.customHeaderClass  : '') + '" style="width: ' + col.width + 'px"> ';

				if (col == vm.columns[0]) {
					header += '<div>' +
						'<i ng-hide="vm.allExpanded" ng-click="vm.expandAllRows()" class="fa fa-plus-square header-button"></i>' +
						'<i ng-show="vm.allExpanded" ng-click="vm.collapseAllRows()" class="fa fa-minus-square header-button"></i>' +
						'</div>';
				}

				header += '<div ng-click="vm.sortData(\'' + col.id + '\')" class="header-contents ' + (vm.groupBy == col.id ? 'grouped-column-header' : '') + '"> ';
				if (col.sortDirection) {
					header += '<i class="sort-icon ' +
						((col.isReverseSort && col.sortDirection === 'desc') || (!col.isReverseSort && col.sortDirection === 'asc') ? ' fa fa-fw fa-arrow-up ' : '') +
						((col.isReverseSort && col.sortDirection === 'asc') || (!col.isReverseSort && col.sortDirection === 'desc') ? ' fa fa-fw fa-arrow-down ' : '') +
						'"></i>';
				}
				header += col.display;
				header += '</div>';

				if (!col.hideMenu) {
					header += '<div class="dropdown dropdown-append-to-body" uib-dropdown is-open="vm.columnMenus.' + col.id + '">' +
						'<a href class="dropdown-toggle" aria-haspopup="true" aria-expanded="true" uib-dropdown-toggle>' +
						'<i class="fa fa-caret-down" aria-hidden="true"></i>' +
						'</a>' +
						'<div ng-if="vm.columnMenus.' + col.id + '" class="dropdown-menu ' + (visibleColumnIndex > 3 ? 'open-left' : '') + '" uib-dropdown-menu>' +
						(col.id === vm.groupBy && !isReadOnly() ? '<li ng-click="vm.ungroupColumn(\'' + col.id + '\')"><i class="fa fa-remove"></i><span translate>Ungroup Column</span></li>' : '') +
						(col.enableGrouping && col.id !== vm.groupBy && !isReadOnly() ? '<li ng-click="vm.groupColumn(\'' + col.id + '\')"><i class="fa fa-object-group" aria-hidden="true"></i><span translate>Group Column</span></li>' : '') +
						(col.sort ? '<li ng-click="vm.sortData(\'' + col.id + '\', \'asc\')"><i class="fa fa-sort-amount-asc" aria-hidden="true"></i><span translate>Sort Ascending</span></li>' : '') +
						(col.sort ? '<li ng-click="vm.sortData(\'' + col.id + '\', \'desc\')"><i class="fa fa-sort-amount-desc" aria-hidden="true"></i><span translate>Sort Descending</span></li>' : '') +
						(col.sortDirection ? '<li ng-click="vm.sortData(\'' + col.id + '\', \'clear\')"><i class="fa fa-remove" aria-hidden="true"></i><span translate>Remove Sort</span></li>' : '') +
						(!col.disabledShowHide && !isReadOnly() ? '<li ng-click="vm.showColumn(\'' + col.id + '\', false)"><i class="fa fa-user-secret" aria-hidden="true"></i><span translate>Hide Column</span></li>' : '') +
						'</div></div>';
				}
				header += '</div>';
			}

			return header;
		}

		/**
		 * Creates a list of <tr>'s for each table and
		 * appends them to the DOM
		 *
		 * @param {Boolean} initAfter - whether to run init function after completion
		 */

		function createRows(initAfter, updateTableWidths) {
			rowsReady['pinnedTable'] = false;
			rowsReady['mainTable'] = false;
			rowsReady['groupTable'] = false;
			var index = 0;

			if (compiledScopes['createRowScope' + createRowCounter]) {
				compiledScopes['createRowScope' + createRowCounter].$destroy();
			}
			createRowCounter++;
			compiledScopes['createRowScope' + createRowCounter] = $scope.$new();

			var urlParams = $location.search();
			var highlightedItemCode = urlParams['drilldownItemCode'];
			var highlightedTaskId = parseInt(urlParams['taskId']) || null;
			var highlightedActionId = parseInt(urlParams['actionId']) || null;
			// don't highlight by item code if task or action id is provided
			if (highlightedTaskId || highlightedActionId) {
				highlightedItemCode = null;
			}

			var tdList = [];
			vm.columnMenus = {};
			// vm.columnMenus = {};
			if (!vm.groupBy) {
				rowsReady['groupTable'] = true;
				// Pinned/Main Table Headers
				var newMainHeaders = '';
				var visibleColumnIndex = 0;
				_.forEach(vm.columns, function (col) {
					var mainHeader = createMainHeaderString(col, visibleColumnIndex);
					if (col.show && !col.disabled) {
						visibleColumnIndex++;
					}
					newMainHeaders += mainHeader;
				});
				var compiledRows = $compile(newMainHeaders)(compiledScopes['createRowScope' + createRowCounter]);
				appendRows(compiledRows, 'mainTableHeaders');

				var newPinnedHeaders = '';
				_.forEach(vm.pinnedColumns, function (col) {
					var pinnedHeader = createPinnedHeaderString(col);
					newPinnedHeaders += pinnedHeader;
				});
				if (newPinnedHeaders !== '' && showPinned()) {
					compiledRows = $compile(newPinnedHeaders)(compiledScopes['createRowScope' + createRowCounter]);
					appendRows(compiledRows, 'pinnedTableHeaders');
				}

				// Pinned/Main Table Rows
				var newMainRows = '';
				var newPinnedRows = '';
				var hasPinned = false;
				if (showPinned()) {
					hasPinned = true;
				}
				var hasRollup = false;

				_.forEach(vm.displayedData, function (row) {
					var classString = '';
					if (row.firstPurchaseOrder == '' || row.firstPurchaseOrder == '-' || row.firstPurchaseOrder == 'No PO\'s Available') {
						classString = 'hoverGray';
					}
					if (row.isTotal) {
						classString += ' total-row';
					}

					if (row.isRollup === 1) {
						if (hasRollup) {
							newMainRows += '</div>';
							if (hasPinned) {
								newPinnedRows += '</div>';
							}
						}
						hasRollup = true;
						classString += ' rollup-summary';
					} else if (row.isRollup === 0) {
						classString += ' rollup-detail';
					}

					if (highlightedTaskId && highlightedTaskId === row.taskId ||
							highlightedActionId && highlightedActionId === row.actionId ||
							highlightedItemCode && highlightedItemCode === row.itemCode) {
						vm.selectedRow = index;
					}

					var rowStrings = createRowContentString(vm.columns, row, index, rendererParams);
					var mainTr = createRowString(index, classString, rowStrings, row.factoryNdx || row.leanDirFactoryNdx);
					newMainRows += mainTr;

					if (hasPinned) {
						var pinnedRowStrings = createRowContentString(vm.pinnedColumns, row, index, rendererParams);
						var pinnedTr = createRowString(index, classString, pinnedRowStrings, row.factoryNdx || row.leanDirFactoryNdx);
						newPinnedRows += pinnedTr;
					}

					if (row.isRollup === 1) {
						var detailContainerStart = '<div ng-show="vm.expandedRows['+index+']">';
						newMainRows += detailContainerStart;
						if (hasPinned) {
							newPinnedRows += detailContainerStart;
						}
					}
					index++;
				});

				if (hasRollup) {
					newMainRows += '</div>';
					if (hasPinned) {
						newPinnedRows += '</div>';
					}
				}

				// open item drilldown on top of the report
				if (!alreadyOpenedDrilldown && urlParams.drilldownItemCode) {
					alreadyOpenedDrilldown = true;
					storeService.dispatch(storeService.actionCreators.modal.openItemDrilldownAction({
						itemCode: urlParams.drilldownItemCode,
						actionId: highlightedActionId,
						taskId: highlightedTaskId,
						row: vm.rowData[vm.selectedRow],
						rowIndex: vm.selectedRow,
						factoryNdx: urlParams.factoryNdx
					}));
				}
				if (hasPinned) {
					var compiledPinnedRows = $compile(newPinnedRows)(compiledScopes['createRowScope' + createRowCounter]);
					appendRows(compiledPinnedRows, 'pinnedTable');
				} else {
					rowsReady['pinnedTable'] = true;
				}
				var compiledRows = $compile(newMainRows)(compiledScopes['createRowScope' + createRowCounter]);
				appendRows(compiledRows, 'mainTable');

				compiledScopes.oldHash = compiledScopes.newHash;

				init(updateTableWidths);
			} else {
				rowsReady['mainTable'] = true;
				rowsReady['pinnedTable'] = true;
				// Grouped Table Headers
				var newGroupHeaders = [];
				var visibleColumnIndex = 0;
				_.forEach(vm.columns, function (col) {
					if (col.show && !col.disabled) {
						visibleColumnIndex++;
					}
					var groupHeader = createGroupHeaderString(col, visibleColumnIndex);
					newGroupHeaders.push(groupHeader);
				});
				var compiledRows = $compile(newGroupHeaders.join(''))(compiledScopes['createRowScope' + createRowCounter]);
				appendRows(compiledRows, 'groupTableHeaders');

				// Grouped Table Rows
				var newRows = [];
				_.forEach(vm.displayedData, function (group) {
					var rowClass = 'row' + group.key.toString().replace(/\s/g, '');
					var groupHeaderTr = '<div ng-click="vm.expandCollapseRows(\'' + rowClass + '\')"><div colspan="' +
						getActiveColumns() + '" class="text-left group-header">';
					groupHeaderTr += '<i ng-if="!vm.getGroupExpanded(\'' + group.key + '\')" " class="fa fa-plus-square group-button"></i><i ng-if="vm.getGroupExpanded(\'' + group.key + '\')" class="fa fa-minus-square group-button"></i>';
					groupHeaderTr += ' ' + group.display + ' (' + group.items.length + ')';
					groupHeaderTr += '</div></div>';
					newRows.push(groupHeaderTr);
					_.forEach(group.items, function (row) {
						var mainTr = '<div ng-click="vm.toggleSelectRow(' + index + ')" ng-class="{selected: vm.selectedRow === ' +
							index + ', hovered: vm.hovering === ' + index + '}" ng-mouseenter="vm.hovering =' + index + ';" ng-mouseleave="vm.hovering = -1;"' +
							'class="' + rowClass + ' table-row collapse-row">';
						tdList.length = 0;
						_.forEach(vm.columns, function (col) {
							if (!col.show || col.disabled) {
								return; // This is 'continue' to lodash
							}
							var renderedCell;
							var forceWidth = '';
							if (col.forceWidth) {
								forceWidth = ' style="width: ' + col.forceWidth + 'px" ';
							}
							if (!col.renderer) {
								var colVal = row[col.id] === undefined ? '' : strip(row[col.id]);
								var colValEscapedQuotes = colVal.replace(/\"/g, '&quot;');
								renderedCell = '<div class="cell-div" title="' + colValEscapedQuotes + '">' + colVal + '</div>';
							} else {
								renderedCell = col.renderer ? col.renderer(row, col, index, rendererParams) : '<div class="cell-div" title="' +
									colValEscapedQuotes + '">' + colVal + '</div>';
							}
							var mainTd = '<div class="' + col.id + ' ' + col.class + '" id="' + col.id + index + '"' +
								forceWidth + '>' + renderedCell + '</div>';
							tdList.push(mainTd);
						});
						mainTr += tdList.join('') + '</div>';
						newRows.push(mainTr);

						index++;
					});
				});
				var compiledRows = $compile(newRows.join(''))($scope);
				appendRows(compiledRows, 'groupTable');

				compiledScopes.oldHash = compiledScopes.newHash;

				init();
			}
		}

		/**
		 * Takes a list of <tr>'s and appends them to the page
		 *
		 * @param {List of Strings} rows - row to append to page
		 * @param {String} tableName - id of table to append rows to
		 * @param {Boolean} initAfter - whether to run init after append
		 */
		function appendRows(rows, tableName) {
			if (jQuery('#' + tableName).length > 0) {
				jQuery('#' + tableName).empty();
				var docFragment = document.createDocumentFragment();
				for (var i = 0; i < rows.length; i++) {
					docFragment.appendChild(rows[i]);
				}
				jQuery('#' + tableName).append(docFragment);
				rowsReady[tableName] = true;
			} else {
				setTimeout(function () {
					appendRows(rows, tableName);
				}, 10);
			}
		}

		/**
		 * Returns whether the group is currently expanded or collapsed
		 *
		 * @param {String} groupKey - the group header key to check
		 */
		function getGroupExpanded(groupKey) {
			var header = _.find(vm.displayedData, {
				key: groupKey
			});
			if (header) {
				return header.expanded;
			}
		}


		/**
		 * Adds a highlight to the row the user selects by
		 * setting selectedRow to the respective row. This triggers
		 * a class to be added on all those cells.
		 *
		 * @param {Number} rowNum - number of row to highlight
		 */
		function toggleSelectRow(rowNum, e) {
			if (!e) {
				return;
			}
			var doExpandCollapse = true;
			var classList;
			if (e.target && e.target.baseURI && e.target.baseURI.search('user-form') > -1) {
				classList = Array.from(e.target.parentElement.classList);
				if (classList.indexOf('customerName') <= -1) doExpandCollapse = false;
			}
			if (doExpandCollapse) {
				vm.selectedRow = rowNum;
				vm.expandedRows[rowNum] = !vm.expandedRows[rowNum];
				setTimeout(function() { fixWidths(); /* and heights :) */}, 100);
			}
		}

		/**
		 * Applies or removes a class that will show/hide the rows
		 * underneath each group header for a grouped table
		 *
		 * @param {String} group - name of group to expand/collapse
		 */
		function expandCollapseRows(group) {
			var rows = jQuery('.' + group);
			if (rows.hasClass('collapse-row')) {
				rows.removeClass('collapse-row');
			} else {
				rows.addClass('collapse-row');
			}

			var header = _.find(vm.displayedData, {
				key: group.substring(3)
			});
			header.expanded = !header.expanded;

			setTimeout(function () {
				fixWidths();
			}, 0);
		}



		function expandAllRows() {
			for (var i = 0; i < vm.displayedData.length; i++) {
				expandRow('row' + vm.displayedData[i].key);
			}
			vm.allExpanded = true;
			setTimeout(function () {
				fixWidths();
			}, 0);
		}


		function collapseAllRows() {
			for (var i = 0; i < vm.displayedData.length; i++) {
				collapseRow('row' + vm.displayedData[i].key);
			}
			vm.allExpanded = false;
			setTimeout(function () {
				fixWidths();
			}, 0);
		}


		function expandRow(group) {
			var rows = jQuery('.' + group);
			if (rows.hasClass('collapse-row')) {
				rows.removeClass('collapse-row');
			}
			var header = _.find(vm.displayedData, {
				key: group.substring(3)
			});
			header.expanded = true;
		}


		function collapseRow(group) {
			var rows = jQuery('.' + group);
			if (!rows.hasClass('collapse-row')) {
				rows.addClass('collapse-row');
			}
			var header = _.find(vm.displayedData, {
				key: group.substring(3)
			});
			header.expanded = false;

		}

		/**
		 * Reset column width to default
		 *
		 * @param {String} col - column to show or hide
		 */
		function resetWidth(col) {
			var column = getColumn(col);
			if (column) {
				var newWidth = 100;
				if (column.defaultWidth) {
					newWidth = column.defaultWidth;
				}
				column.width = newWidth;
				storeService.dispatch({
					type: storeService.actions.COLUMNS_SET_WIDTH,
					payload: {
						name: col,
						size: getResolutionVal(),
						width: newWidth
					},
					meta: {
						reportName: reportSettingsName,
						reportSettingsId: vm.getMeta().reportSettingsId,
						doNotSave: isReadOnly(),
						userModified: true
					}
				});
			}
			refreshTable(tableState, undefined, true, true);
		}

		/**
		 * Shows/Hides column by updating 'show' property in columns array
		 *
		 * @param {String} col - column to show or hide
		 * @param {Boolean} show - whether it is shown or hidden
		 */
		function showColumn(col, show) {
			storeService.dispatch({
				type: storeService.actions.COLUMNS_SET_SHOW,
				payload: {
					name: col,
					show: show
				},
				meta: {
					reportName: reportSettingsName,
					reportSettingsId: vm.getMeta().reportSettingsId,
					userModified: true
				}
			});
			var column = getColumn(col);
			if (!show) {
				column.show = !column.show;
			} else {
				column.show = show;
			}
			refreshTable(tableState, undefined, true, true);
		}

		/**
		 * Reapplies the current grouping
		 */
		function reapplyGroup() {
			if (!vm.groupBy) {
				return;
			}

			// Make sure there are no pinned columns
			// (We do not support grouping while pinning)
			vm.columns = vm.pinnedColumns.concat(vm.columns);
			vm.pinnedColumns = [];

			// Move grouped column to front of columns array
			var column = _.remove(vm.columns, {
				'id': vm.groupBy
			})[0];

			// If a column is not found, don't do anything
			if (column) {
				vm.columns.unshift(column);
				// Set dataset to original ungrouped dataset
				vm.displayedData = originalData;

				vm.displayedData = groupByProperty(vm.displayedData, vm.groupBy);
				// originalData = vm.displayedData;
			}
		}

		/**
		 * Groups a column
		 * @param {String} col - column to group by
		 */
		function groupColumn(col) {
			if (vm.groupBy != undefined && vm.groupBy != col && vm.groupBy != '') {
				var old = getColumn(vm.groupBy);
				if (old != undefined) {
					getColumn(old.id).grouped = false;
				}
			}
			vm.groupBy = col;
			getColumn(col).grouped = true;
			// Make sure there are no pinned columns
			// (We do not support grouping while pinning)
			vm.columns = vm.pinnedColumns.concat(vm.columns);
			vm.pinnedColumns = [];

			storeService.dispatch({
				type: storeService.actions.COLUMNS_SET_GROUPED,
				payload: {
					name: col,
					grouped: true
				},
				meta: {
					reportName: reportSettingsName,
					reportSettingsId: vm.getMeta().reportSettingsId,
					userModified: true
				}
			});

			// Move grouped column to front of columns array
			var column = _.remove(vm.columns, {
				'id': col
			})[0];

			// If a column is not found, don't do anything
			if (column) {
				vm.columns.unshift(column);
				// Set dataset to original ungrouped dataset
				vm.displayedData = originalData;

				vm.displayedData = groupByProperty(vm.displayedData, vm.groupBy);
				// originalData = vm.displayedData;

				// Clear sorts and sort by the grouped column
				_.forEach(vm.columns, function (col) {
					col.sortDirection = '';
				});
				if (isBackendGrouping) {
					getData(0, undefined, undefined, true);
				} else {
					clearSorts();
					sortData(col, 'asc');
				}
			}

		}

		function ungroupColumn(col) {
			if (vm.groupBy) {
				getColumn(col).grouped = false;
				var groupedCol = vm.columns[0];
				vm.columns = _.drop(vm.columns, 1);
				groupedCol.sortDirection = '';

				if (groupedCol.position === 0) {
					vm.columns.unshift(groupedCol);
				} else {
					var foundPosition;
					for (var i = 0; i < vm.columns.length; i++) {
						if (vm.columns[i].position < groupedCol.position && i !== vm.columns.length &&
							vm.columns[i + 1].position > groupedCol.position) {
							vm.columns.splice(i + 1, 0, groupedCol);
							foundPosition = true;
							break;
						}
					}
					if (!foundPosition) {
						vm.columns.push(groupedCol);
					}
				}


				vm.groupBy = '';
				vm.pinnedColumns = [];

				currentSort = _.drop(currentSort, 1);
				// Set displayedData to original dataset
				vm.displayedData = originalData;

				if (noPaging) {
					reapplySort();
				}

				vm.groupBy = undefined;
				storeService.dispatch({
					type: storeService.actions.COLUMNS_SET_GROUPED,
					payload: {
						name: col,
						grouped: false
					},
					meta: {
						reportName: reportSettingsName,
						reportSettingsId: vm.getMeta().reportSettingsId,
						userModified: true
					}
				});
				refreshTable(tableState, undefined, true, true);
				if (isBackendGrouping) {
					getData(0, undefined, undefined, true);
				}
			}
		}

		/**
		 * Pins a column by removing it from the columns array
		 * and into the pinnedColumns array
		 *
		 * @param {String} col - column to pin
		 */
		function pinColumn(col, noRefresh) {

			// Make sure there are no grouped columns
			// (We do not support pinning while grouping)
			if (vm.groupBy) {
				var groupedCol = vm.columns[0];
				vm.columns = _.drop(vm.columns, 1);
				groupedCol.sortDirection = '';
				vm.columns.splice(groupedCol.position, 0, groupedCol);

				vm.groupBy = '';
				vm.pinnedColumns = [];

				// TODO: Should we clear the sort on the column that was grouped when we want to pin?
				currentSort = _.drop(currentSort, 1);

				// Set displayedData to original dataset
				vm.displayedData = originalData;
			}

			// Remove column from columns and add to pinnedColumns
			var column = _.remove(vm.columns, {
				'id': col
			})[0];

			if (column) {
				vm.pinnedColumns.push(column);
			}

			if (column && !noRefresh) {
				storeService.dispatch({
					type: storeService.actions.COLUMNS_SET_PINNED,
					payload: {
						name: col,
						pinnedLeft: true
					},
					meta: {
						reportName: reportSettingsName,
						reportSettingsId: vm.getMeta().reportSettingsId,
						doNotSave: isReadOnly(),
						userModified: true
					}
				});
				refreshTable(tableState, undefined, true, true);
			}
		}

		function unpinColumn(col) {
			var unPinnedColumn = _.remove(vm.pinnedColumns, {
				'id': col
			})[0];
			if (unPinnedColumn) {
				unPinnedColumn['unpinned'] = true;
				if (vm.columns.length === 0 || unPinnedColumn.position < vm.columns[0].position) {
					vm.columns.unshift(unPinnedColumn);
				} else if (unPinnedColumn.position >= vm.columns[vm.columns.length - 1].position) {
					vm.columns.push(unPinnedColumn);
				} else {
					var foundPosition;
					for (var i = 0; i < vm.columns.length; i++) {
						if (vm.columns[i].position < unPinnedColumn.position && i !== vm.columns.length &&
							vm.columns[i + 1].position > unPinnedColumn.position) {
							vm.columns.splice(i + 1, 0, unPinnedColumn);
							foundPosition = true;
							break;
						}
					}
					if (!foundPosition) {
						vm.columns.push(unPinnedColumn);

					}
				}
				storeService.dispatch({
					type: storeService.actions.COLUMNS_SET_PINNED,
					payload: {
						name: col,
						pinnedLeft: false
					},
					meta: {
						reportName: reportSettingsName,
						reportSettingsId: vm.getMeta().reportSettingsId,
						doNotSave: isReadOnly(),
						userModified: true
					}
				});
				refreshTable(tableState, undefined, true, true);
			}
		}

		/**
		 * Reapply the currentSort
		 */
		function reapplySort() {
			if (!currentSort || !currentSort.length) {
				clearSorts();
				return;
			}
			for (var i = 0; i < currentSort.length; i++) {
				var column = getColumn(currentSort[i].property);
				if (column != undefined) {
					column.sortDirection = currentSort[i].direction;
				}
			}
			if (!vm.groupBy) {
				if (noPaging && currentSort.length !== 0) {
					var property = _.map(currentSort, 'property')[0];
					var direction = _.map(currentSort, 'direction')[0];
					vm.displayedData = sortDataAndMoveNullsAtEnd(vm.displayedData, property, direction);
				}
			} else {
				if (!(isBackendGrouping && vm.groupBy)) {
					if (currentSort.length === 1) {
						vm.displayedData = _.orderBy(vm.displayedData, 'key', currentSort[0].direction);
					} else {
						vm.displayedData = _.orderBy(vm.displayedData, 'key', currentSort[0].direction);
						_.forEach(vm.displayedData, function (group) {
							group.items = _.orderBy(group.items, _.map(currentSort, 'property'), _.map(currentSort, 'direction'));
						});
					}
				}
			}
		}

		/**
		 * Move Null at the end
		 */
		function sortDataAndMoveNullsAtEnd(rawData, property, direction) {
			var result = _.partition(rawData, function(data) {
				return data.hasOwnProperty(property) && data[property] != null;
			});
			return _.flatten([_.orderBy(result[0], [function (o) { return _.isString(o[property]) ? o[property].toLowerCase() : o[property]; }], direction), result[1]]);
		}

		function getSortDirection(order, isReverse) {
			if (!isReverse) {
				return order;
			}
			return order === 'asc' ? 'desc' : 'asc';
		}

		$scope.$on('sort-columns', function (event, args) {
			return sortData(args.col, args.order);
		});

		/**
		 * Sorts the data in the table according to the following params
		 * Allows multiple sorting by keeping track of what is being sorted in 'currentSort'
		 *
		 * @param {String} col - id of column that will be sorted
		 * @param {String} order - if sort order direction needs to be forced, provide this
		 */
		function sortData(col, order) {
			var column = getColumn(col);
			if (!column || !column.sort) {
				return;
			}
			var index = currentSort.map(function (x) {
				return x.property;
			}).indexOf(col);

			var footerRow = vm.footer ? vm.displayedData.splice(-1) : null;

			if (index === -1) {
				var sortObj = {};
				sortObj.overrideProperty = column.defaultId;
				sortObj.property =  col;
				if (order) {
					sortObj.direction = order;
				} else if (column.sortDefaultReverse) {
					sortObj.direction = 'desc';
				} else {
					sortObj.direction = 'asc';
				}

				sortObj.direction = getSortDirection(sortObj.direction , column.isReverseSort);
				// Backend sorting only works with 1 sort

				//TODO: Reenable multi sort after we figure out how to mark primary sort more clearly.
				if (!vm.groupBy) {
					clearSorts();
				}
				column.sortDirection = sortObj.direction;
				currentSort.push(sortObj);
			} else {
				if (order) {
					if (order === 'clear') {
						column['unsorted'] = true;
						currentSort.splice(index, 1);
						column.sortDirection = '';
					} else {
						var sortOrder = getSortDirection(order , column.isReverseSort);
						currentSort[index].direction = sortOrder;
						column.sortDirection = sortOrder;
					}
				} else {
					if (column.sortDefaultReverse) {
						if (currentSort[index].direction === 'asc') {
							currentSort.splice(index, 1);
							column.sortDirection = '';
						} else if (index === 0 && vm.groupBy) {
							currentSort[index].direction = 'asc';
							column.sortDirection = 'asc';
						} else if (currentSort[index].direction === 'desc') {
							currentSort[index].direction = 'asc';
							column.sortDirection = 'asc';
						}
					} else if (column.isReverseSort) {
						if (currentSort[index].direction === 'desc') {
							currentSort[index].direction = 'asc';
							column.sortDirection = 'asc';
						} else if (index === 0 && vm.groupBy) {
							currentSort[index].direction = 'desc';
							column.sortDirection = 'desc';
						} else {
							currentSort.splice(index, 1);
							column.sortDirection = '';
						}
					} else {
						if (currentSort[index].direction === 'asc') {
							currentSort[index].direction = 'desc';
							column.sortDirection = 'desc';
						} else if (index === 0 && vm.groupBy) {
							currentSort[index].direction = 'asc';
							column.sortDirection = 'asc';
						} else {
							currentSort.splice(index, 1);
							column.sortDirection = '';
						}
					}
				}
			}

			if (!vm.groupBy || (isBackendGrouping && vm.groupBy)) {
				if (noPaging) {
					if (currentSort.length !== 0) {
						var property = _.map(currentSort, 'property')[0];
						var direction = _.map(currentSort, 'direction')[0];
						vm.displayedData = sortDataAndMoveNullsAtEnd(vm.displayedData, property, direction);
					} else {
						vm.displayedData = originalData;
						currentSort.push({
							'property': defaultSort,
							'direction': defaultSortDirection
						});
						reapplySort();
					}
				} else {
					if (currentSort.length === 0 && defaultSort && defaultSortDirection) {
						currentSort.push({
							'property': defaultSort,
							'direction': defaultSortDirection
						});
					}
					getData(0, undefined, undefined, true);
				}
			} else {
				if (currentSort.length === 1) {
					vm.displayedData = _.orderBy(vm.displayedData, 'key', currentSort[0].direction);
				} else {
					var primarySort = currentSort[0];
					var secondarySort = currentSort[currentSort.length - 1];
					clearSorts();
					currentSort.push(primarySort);
					currentSort.push(secondarySort);
					reapplySort();
				}
			}
			storeService.dispatch({
				type: storeService.actions.SORTERS_SET_ALL,
				payload: {
					sorters: currentSort
				},
				meta: {
					reportName: reportSettingsName,
					reportSettingsId: vm.getMeta().reportSettingsId,
					doNotSave: isReadOnly(),
					userModified: true
				}
			});

			if (vm.footer && footerRow != null) {
				vm.displayedData.push(footerRow[0]);
				rendererParams.lastIndex = vm.displayedData.length - 1;
			}

			vm.expandedRows = {};

			if (vm.groupBy || ((!order || order) && noPaging)) {
				refreshTable(tableState, undefined, true);
			}
		}

		/**
		 * Takes a resized column id and sets all the td's in the respective column
		 * to the appropriate width
		 *
		 * @param {String} id - the id of the column that was resized
		 */
		function updateColumnWidth(id) {
			if (!vm.groupBy) {
				if (getColumn(id).forceWidth) {
					return; // no resizing for forceWidth
				}
				var newWidth = jQuery('#header' + CSS.escape(id)).outerWidth();
				jQuery('.' + CSS.escape(id)).outerWidth(newWidth);
				getColumn(id).width = newWidth;
				storeService.dispatch({
					type: storeService.actions.COLUMNS_SET_WIDTH,
					payload: {
						name: id,
						size: getResolutionVal(),
						width: newWidth
					},
					meta: {
						reportName: reportSettingsName,
						reportSettingsId: vm.getMeta().reportSettingsId,
						doNotSave: isReadOnly(),
						userModified: true
					}
				});
			} else {
				// Grouped tables need all their columns width checked
				// regardless of which one is resized
				for (var i = 0; i < vm.columns.length; i++) {
					var newWidth = jQuery('#header' + CSS.escape(vm.columns[i].id)).outerWidth();
					jQuery('.' + CSS.escape(vm.columns[i].id)).outerWidth(newWidth);
					getColumn(vm.columns[i].id).width = newWidth;
					storeService.dispatch({
						type: storeService.actions.COLUMNS_SET_WIDTH,
						payload: {
							name: vm.columns[i].id,
							size: getResolutionVal(),
							width: newWidth
						},
						meta: {
							reportName: reportSettingsName,
							reportSettingsId: vm.getMeta().reportSettingsId,
							doNotSave: isReadOnly(),
							userModified: true
						}
					});
				}
			}
			refreshTable(tableState, undefined, true);
		}


		/**
		 * Groups the data on the property provided
		 *
		 * @param {Array of Objects} collection - set of data to be grouped
		 * @param {String} property - the id to group by
		 */
		function groupByProperty(collection, property) {
			var output = [];
			var groupReference = {};
			for (var i = 0; i < collection.length; i++) {
				var item = collection[i];
				var display = _.escape(item[property]);
				var keyValue = display.replace(/['"\s:/&#;).,$%(]+/g, '');
				var group = groupReference[keyValue];
				if (group === undefined) {
					group = {
						key: keyValue,
						display: display,
						items: [],
						expanded: false
					};
					groupReference[keyValue] = group;
					output.push(group);
				}
				group.items.push(item);
			}
			return output;
		}

		/**
		 *
		 * Only run when initial data is loaded. Sets width of each column explicitly
		 * to the width of either the header or the cell, whichever is largest.
		 * It is important to hard code the width of each header so that when we
		 * resize a column, the other columns do not change width.
		 *
		 */
		function initialWidths() {
			var header_width = 0;

			// Get sum of header widths
			_.forEach(vm.columns, function (col) {
				header_width += col.width;
			});

			if (!vm.groupBy) {
				jQuery('.main-table-container').width(header_width);
			} else {
				jQuery('.group-table-container').width(header_width);

			}
		}

		/**
		 * Goes through all the columns and matches the widths of the th to the td
		 * Also sets the height of the fake scroller to accomodoate for any height changes
		 *
		 */
		function fixWidths(updateTableWidths) {
			// We may be able to optimize this, but we didn't attempt to
			if (vm.groupBy) {

				// Make sure table exists
				if (jQuery('#groupTable').height() === 0) {
					setTimeout(function () {
						fixWidths();
					}, 10);
				}
				var parent = document.getElementById('groupTableHideScroll');
				var child = document.getElementById('groupTableScroll');
				parent.style.width = 'inherit';
				child.style.width = 'inherit';
				jQuery('#groupTable').outerWidth(jQuery('#groupTable').outerWidth());

				for (var i = 0; i < vm.columns.length; i++) {
					var cell = jQuery('.' + CSS.escape(vm.columns[i].id));
					var header = jQuery('#header' + CSS.escape(vm.columns[i].id));

					// TODO: Check to see if there is a report config
					// If there is, set the header width to that
					// If there isn't, set the header width to the default width
					// from columns object
					if (vm.columns[i].width) {
						header.outerWidth(vm.columns[i].width);
					}
					cell.outerWidth(header.outerWidth());
				}

				// Get width of header row
				var headers = jQuery('#groupTableHeaders .header');
				var headerRowWidth = 0;
				for (var i = 0; i < headers.length; i++) {
					headerRowWidth += jQuery(headers[i]).outerWidth();
				}

				var extraPadding = child.offsetWidth - child.clientWidth;
				parent.style.width = headerRowWidth + 'px';
				child.style.width = headerRowWidth + extraPadding + 'px';

				jQuery('#groupTable').outerWidth(headerRowWidth);
				// Set container back to size of table
				jQuery('.group-table-container').outerWidth(headerRowWidth);

				var tableWidth = jQuery('#groupTableHeaders').width();
				jQuery('.group-header').outerWidth(tableWidth);
			}
			// Set height of table and fake scroller
			var tableContainerHeight;
			var tableHeight;
			var scrollWidth;
			// this if/else  is almost exactly the same as setScroll -- do we need this duplication?
			if (!vm.groupBy) {
				if (!updateTableWidths) {
					scrollWidth = Math.max(jQuery('#mainTableHeaders').width(), jQuery('.tables').width());
					jQuery('#mainTableScroll').width(scrollWidth);
					jQuery('#mainTable').width(scrollWidth);
					jQuery('#mainTableHideScroll').width(scrollWidth);
				} else {
					updateWidthOfTables();
				}
				tableContainerHeight = jQuery('.main-table').height() - jQuery('.header').height();
				jQuery('#mainTableScroll').height(tableContainerHeight - 30); // why 30? Should be a constant?
				if (showPinned()) {
					jQuery('#pinnedTableScroll').height(tableContainerHeight - 30); // again, 30
				}
				tableHeight = jQuery('#mainTable').height() + jQuery('.header').height(); // we shouldn't need to keep querying the DOM for height
			} else {
				tableContainerHeight = jQuery('.group-table').height() - jQuery('#groupTableHeaders').height();
				jQuery('#groupTableScroll').height(tableContainerHeight - 20); // why 20?
				tableHeight = jQuery('#groupTable').height() + jQuery('#groupTableHeaders').height();
			}
			jQuery('.fake-scroller-container').height(jQuery('.tables').outerHeight());
			jQuery('.fake-scroller').height(tableHeight + 35); // why  35?
			hideScrollBars();
		}


		window.addEventListener('resize', setScroll);

		function setScroll() {
			if (!vm.groupBy) {
				var tableContainerHeight = jQuery('.main-table').height() - jQuery('.header').height();
				var scrollWidth = Math.max(jQuery('#mainTableHeaders').width(), jQuery('.tables').width());
				jQuery('#mainTableScroll').height(tableContainerHeight - 30);
				jQuery('#pinnedTableScroll').height(tableContainerHeight - 30);
				jQuery('#mainTableScroll').width(scrollWidth);
				jQuery('#mainTableHideScroll').width(scrollWidth);
				jQuery('#mainTable').width(scrollWidth);
				hideScrollBars();
			} else {
				var tableContainerHeight = jQuery('.group-table').height() - jQuery('.header').height();
				var scrollWidth = Math.max(jQuery('#groupTableHeaders').width(), jQuery('.tables').width());
				jQuery('#groupTableScroll').height(tableContainerHeight - 30);
				jQuery('#groupTableScroll').width(scrollWidth);
				jQuery('#groupTableHideScroll').width(scrollWidth);
				jQuery('#groupTable').width(scrollWidth);
				hideScrollBars();
			}
		}

		function updateWidthOfTables() {
			if (!vm.groupBy) {
				var pinnedTableWidth = 0;
				_.forEach(vm.pinnedColumns, function (pinnedColumn) {
					if (pinnedColumn.show && !pinnedColumn.disabled) {
						pinnedTableWidth += pinnedColumn.width;
					}
				});
				vm.pinnedTableWidth = pinnedTableWidth;

				var mainTableWidth = 0;
				_.forEach(vm.columns, function (column) {
					if (column.show && !column.disabled) {
						mainTableWidth += column.width;
					}
				});
				jQuery('#pinnedTableHideScroll').width(pinnedTableWidth);
				jQuery('#pinnedTableScroll').width(pinnedTableWidth);
				jQuery('#pinnedTable').width(pinnedTableWidth);
				jQuery('#mainTableHideScroll').width(mainTableWidth);
				jQuery('#mainTableScroll').width(mainTableWidth);
				jQuery('#mainTable').width(mainTableWidth);
				jQuery('.header-table.hide-headers').removeClass('hide-headers');
			}
		}


		/**
		 * Hides the scroll bar on the pinned and main tables
		 * Firefox and IE don't support webkit so we need to do this trick
		 * (We never want to see these if we can avoid it)
		 *
		 */
		function hideScrollBars() {
			// Needs to be a timeout to make sure the previous width update gets used
			$timeout(function () {
				if (showPinned()) {
					// Pinned Table
					var parent = document.getElementById('pinnedTableHideScroll');
					var child = document.getElementById('pinnedTableScroll');
					if (parent && child) {
						var extraPadding = child.offsetWidth - child.clientWidth;
						parent.style.width = vm.pinnedTableWidth + 'px';
						child.style.width = vm.pinnedTableWidth + extraPadding + 'px';
					}
				}

				// Main Table

				if (!vm.groupBy) {
					var parent = document.getElementById('mainTableHideScroll');
					var child = document.getElementById('mainTableScroll');
					if (parent && child) {
						var extraPadding = child.offsetWidth - child.clientWidth;
						parent.style.width = jQuery(parent).width() + 'px';
						child.style.width = jQuery(parent).width() + extraPadding + 'px';
						jQuery('.main-table-container').width(jQuery(parent).width());
					}
				}
			});
		}

		/**
		 * Hides the scroll bar on the grouped table
		 * Firefox and IE don't support webkit so we need to do this trick
		 * (We never want to see this if we can avoid it)
		 */
		function hideGroupedScrollBars() {
			// Grouped Table
			var parent = document.getElementById('groupTableHideScroll');
			var child = document.getElementById('groupTableScroll');
			var extraPadding = child.offsetWidth - child.clientWidth;
			parent.style.width = jQuery(parent).width() + 'px';
			child.style.width = jQuery(parent).width() + extraPadding + 'px';
		}

		/**
		 * Syncs the pinned, main, and fake scroller to the same scroll event
		 *
		 */
		function tableScrollSync() {
			// Clear existiing listeners
			jQuery('#pinnedTableScroll, #mainTableScroll, #fakeScrollerContainer').off();

			jQuery('#pinnedTableScroll, #mainTableScroll, #fakeScrollerContainer').on('scroll', function callback() {
				// clear the scrollbarTimeout every scroll event call
				clearTimeout(scrollbarTimeout);

				var source = jQuery(this);
				var targetOne, targetTwo;

				if (source.is('#pinnedTableScroll')) {
					targetOne = jQuery('#mainTableScroll');
					targetTwo = jQuery('#fakeScrollerContainer');
				} else if (source.is('#mainTableScroll')) {
					targetOne = jQuery('#pinnedTableScroll');
					targetTwo = jQuery('#fakeScrollerContainer');
				} else {
					targetOne = jQuery('#mainTableScroll');
					targetTwo = jQuery('#pinnedTableScroll');
				}

				// remove the callback from the other div and set the scrollTop
				targetOne.off('scroll').scrollTop(source.scrollTop());
				targetTwo.off('scroll').scrollTop(source.scrollTop());

				// create a new timeout and reassign scroll event
				scrollbarTimeout = setTimeout(function () {
					targetOne.on('scroll', callback);
					targetTwo.on('scroll', callback);
				}, 100);
			});
		}

		/**
		 * Syncs the main and fake scroller to the same scroll event
		 * (There are no pinned columns in a grouped table)
		 */
		function groupTableScrollSync() {
			// Clear existing listeners
			jQuery('#groupTableScroll, #fakeScrollerContainer').off();

			// Add new listener
			jQuery('#groupTableScroll, #fakeScrollerContainer').on('scroll', function callback() {
				// clear the scrollbarTimeout every scroll event call
				clearTimeout(scrollbarTimeout);

				var source = jQuery(this),
					target = jQuery(source.is('#groupTableScroll') ? '#fakeScrollerContainer' : '#groupTableScroll');
				// remove the callback from the other div and set the scrollTop
				target.off('scroll').scrollTop(source.scrollTop());

				// create a new timeout and reassign scroll event
				scrollbarTimeout = setTimeout(function () {
					target.on('scroll', callback);
				}, 100);
			});
		}

		/**
		 * Updates the height of the fake right scroller upon
		 * expand/collapse of group table.
		 */
		function updateGroupFakeScroller() {
			setTimeout(function () {
				fixWidths();
			}, 0);
		}

		/**
		 * Returns a count of the active columns by checking
		 * the 'show' property of the columns list. This is
		 * mainly for grouped tables colspan calculation.
		 *
		 */
		function getActiveColumns() {
			var count = 0;
			_.forEach(vm.columns, function (col) {
				if (col.show && !col.disabled) {
					count++;
				}
			});
			return count;
		}

		/**
		 * Checks to see if pinned columns should be shown
		 *
		 */
		function showPinned() {
			var show = false;
			_.forEach(vm.pinnedColumns, function (col) {
				if (col.show && !col.disabled) {
					show = true;
					return;
				}
			});
			return show;
		}

		function expandGroups() {
			_.forEach(vm.displayedData, function (group) {
				if (group.expanded) {
					var rows = jQuery('.row' + group.key);
					rows.removeClass('collapse-row');
				}
			});
		}

		/**
		 * Clears both sort containers
		 *
		 */
		function clearSorts() {
			currentSort = [];
			_.forEach(vm.columns, function (col) {
				if (col.sortDirection) {
					col.sortDirection = '';
				}
			});
			_.forEach(vm.pinnedColumns, function (col) {
				if (col.sortDirection) {
					col.sortDirection = '';
				}
			});
		}

		/**
		 * Returns the column object from the list of column objects
		 *
		 * @param {String} id - id of column you want to find
		 */
		function getColumn(id) {
			var column;
			column = _.find(vm.columns, {
				'id': id
			});
			if (!column) {
				column = _.find(vm.pinnedColumns, {
					'id': id
				});
			}
			return column;
		}

		function doNothing() {

		}

		/**
		 * The report filters have 3 functions that need to call
		 * a scope function (specifically getData)
		 * Defining them here allows the passing of a callback function
		 */
		function setFilterFunctions() {
			$scope.filterFunctions = tableFilterFunctionsService;
			vm.noResultsText = 'We couldn\'t find any results that match this filter.';
			// Filter related functions
			$scope.filterFunctions.applySelection = function ($event, filterId) {
				vm.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
				vm.clearFiltersText = 'Or, clear the filters and start over.';
				vm.filtered = true;
				tableFilterFunctionsService.applySelectionInner($event, getData, filterId, true, reportSettingsName, vm.getMeta().reportSettingsId);
			};
			$scope.filterFunctions.removeFilter = function (filter) {
				vm.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
				vm.clearFiltersText = 'Or, clear the filters and start over.';
				vm.filtered = true;
				tableFilterFunctionsService.removeFilterInner(filter, getData, true, reportSettingsName, vm.getMeta().reportSettingsId);
			};
			$scope.filterFunctions.clearAllFilters = function () {
				vm.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
				vm.clearFiltersText = 'Or, clear the filters and start over.';
				vm.filtered = true;
				tableFilterFunctionsService.clearAllFiltersInner(getData, true, reportSettingsName, vm.getMeta().reportSettingsId, defaultFilters);
			};
		}

		function getPaginationObject() {
			return paginationObject;
		}

		function reloadTable(start) {
			getData(start);
		}

		function hasPaging() {
			return !noPaging;
		}

		function searchInputFocused() {
			if (vm.search && vm.search.term) {
				if (vm.search.term.indexOf('Starts with') === 0) {
					vm.search.term = vm.search.term.substring(13, vm.search.term.length - 1);
				} else if (vm.search.term.indexOf('Contains') === 0) {
					vm.search.term = vm.search.term.substring(10, vm.search.term.length - 1);
				}
			}
		}

		function searchOptionSelected(searchTerm, searchItem, event) {
			if ($scope.reportsItemLoading) {
				vm.search.term = vm.searchValue;
				return;
			}
			var currentSearchTermSelected = leanFilterService.getSearchBoxDataValue();
			var selectedSearchTerm = vm.search.term;
			if (searchType === 'item' && typeof searchItem !== 'undefined') {
				selectedSearchTerm = searchItem.itemCode;
			}
			if (currentSearchTermSelected !== selectedSearchTerm) {
				vm.noResultsText = 'We couldn\'t find any results that match that search on this report.';
				vm.noResultsSuggestion = 'Please try another one.';
				vm.filtered = false;
				leanFilterService.setSearchBoxDataValue(selectedSearchTerm);
				getData(0, undefined, undefined, 'filtersChanged');
			}
			if (event && event.target) {
				jQuery(event.target).blur();
			}
		}

		function getSearchValues(name) {
			vm.searchValue = name;
			var partialMatch = 'Contains "' + name + '"';

			if (searchType === 'project' || searchType === 'task' || searchType === 'lateDeliveryCategory' || searchType === 'email' || searchType === 'goal') {
				return [];
			}
			if (globalConfig.user.role == 'Supplier') {
				return [{itemCode: partialMatch}];
			}
			return leanFilterService.getSearchData(name).then(function (response) {
				if (response && response.data && response.data.length) {
					var sortField;
					if (searchType === 'supplier') {
						sortField = 'name';
					} else if (searchType === 'user') {
						sortField = 'term';
					}
					response.data.sort(function (a, b) {
						return (a[sortField].length - b[sortField].length) || a[sortField].localeCompare(b[sortField]);
					});
					return response.data;
				}
				if (searchType === 'item' && response.data.data && response.data.data.length) {
					var returnList = response.data.data;
					returnList.push({itemCode: partialMatch});
					return returnList;
				}
				return [];
			});
		}

		function clearText(param) {
			vm.search.term = param;
			vm.searchOptionSelected({
				searchTerm: ''
			});
			$timeout(function () {
				jQuery('.searchBlock .search input').focus();
			});
		}

		function init(updateTableWidths) {
			if (rowsReady['pinnedTable'] && rowsReady['mainTable'] && rowsReady['groupTable']) {
				setTimeout(function () {
					fixWidths(updateTableWidths);
					if (!vm.groupBy) {
						hideScrollBars();
						tableScrollSync();
					} else {
						hideGroupedScrollBars();
						groupTableScrollSync();
						expandGroups();
					}
					$scope.$emit('showRowsCalled');


					jQuery('.header.has-menu').hover(function() {
						var floatDirection = 'right';
						if (jQuery(this).find('.fa.fa-caret-down').offset().left > jQuery(window).width()) {
							floatDirection = 'left';
						}
						jQuery(jQuery(this).find('.dropdown')).css('float', floatDirection);
					});
				}, 0);
			} else {
				$timeout(function () {
					init(updateTableWidths);
				}, 10);
			}
		}

		function openLeanSyncConfigModal(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.openModal(row);
		}

		/* Renderer Functions START */


		function getTooltip(colId, rowId) {
			if (!tooltips[rowId]) return '';
			return tooltips[rowId][colId];
		}

		function showIt(colId, rowId, type, label, rowIndex, commentType) {
			var currentTTs = angular.element('.tooltip');
			var cell = jQuery('#' + type + rowIndex);
			// fall back for old implementions
			if (!cell.length) {
				cell = jQuery('#' + colId + rowIndex);
			}
 			var rect = cell[0].getBoundingClientRect();
			var midX = (rect.x + rect.right) / 2;
			if (midX < window.innerWidth / 2) {
				vm.tooltipPlacements[type + rowIndex] = 'right';
			} else {
				vm.tooltipPlacements[type + rowIndex] = 'left';
			}
			for (var i = 0; i < currentTTs.length; i++) {
				var tt = angular.element(currentTTs[i]);
				if (tt && tt.scope())
					tt.scope().tt_isOpen = false;
				jQuery('.tooltip').remove();
			}
			if (!timeoutMap[rowId]) {
				timeoutMap[rowId] = {};
			}
			if (!visibleMap[rowId]) {
				visibleMap[rowId] = {};
			}
			if (!tooltips[rowId]) {
				tooltips[rowId] = {};
			}

			var rawData = getRawData();

			var commentIdMap = {
				YtdProject: rawData[rowIndex]['projNdx'],
				assessmentQuestion: rawData[rowIndex]['assessmentNdx'],
				lateDeliveryIssueCommentNdx: 0
			};
			var commentId = commentIdMap[type] || vm.displayedData[rowIndex][colId];

			var factoryNdx = rawData[rowIndex]['leanDirFactoryNdx'];

			visibleMap[rowId][colId] = true;

			timeoutMap[rowId][colId] = $timeout(function () {
				if (commentId || commentId === 0) {
					if (visibleMap[rowId][colId]) {
						switch(type){
						case 'aggregateRiskScore':
							tooltips[rowId][colId] = getRiskScoreLoadingHtml();
							break;
						case 'YtdProject':
							tooltips[rowId][colId] = getYtdProjectLoadingHtml();
							break;
						case 'lastComment':
							tooltips[rowId][colId] =  getTaskCommentHtml(undefined, true);
							break;
						default:
							tooltips[rowId][colId] = getLoadingHtml(label);
						}
						vm.showTooltip = false;
						tooltipSetReady(colId, rowId);
						if (!promiseMap[rowId]) {
							promiseMap[rowId] = {};
						}
						if (type === 'YtdProject') {
							promiseMap[rowId][colId] = leanTableService.getYtdProjectSavings(commentId, leanFilterService.getFactoryList());
						} else if (type === 'assessmentQuestion') {
							tooltips[rowId][colId] = getAssessmentQuestionTooltipHtml(strip(rawData[rowIndex][colId]));
							return;
						} else if (type === 'lastComment') {
							promiseMap[rowId][colId] = procurementTaskService.getCommentsForAction(vm.displayedData[rowIndex][colId], vm.displayedData[rowIndex]['leanDirFactoryNdx']);
						} else if (type === 'aggregateRiskScore'){
							var itemNdx = rawData[rowIndex].itemNdx;
							promiseMap[rowId][colId] = leanTableService.getRiskScores(itemNdx, factoryNdx);
						} else {
							promiseMap[rowId][colId] = leanTableService.getCommentHistory(commentId, commentType, factoryNdx, type, rawData[rowIndex].lateDeliveryIssueCommentNdx, rawData[rowIndex].firstPoEcdNdx);
						}

						promiseMap[rowId][colId].promise
							.then(function (response) {
								if (response && response.status && response.status >= 200 && response.status < 400) {
									$timeout(function () {
										vm.showTooltip = true;
										if (visibleMap[rowId][colId]) {
											if (type === 'YtdProject') {
												tooltips[rowId][colId] = getYtdProjectTooltipHtml(type, response.data, label);
											} else if (type === 'lastComment') {
												tooltips[rowId][colId] = getTaskCommentHtml(response.data);
											} else if (type === 'aggregateRiskScore'){
												tooltips[rowId][colId] = getRiskScoreTooltipHtml(response.data);
											} else {
												tooltips[rowId][colId] = getCommentTooltipHtml(type, response.data, label);
											}
										}
										$timeout(function () {
											var tooltip = jQuery('.tooltip');
											var arrow = jQuery('.tooltip-arrow');
											var tooltipPosition = tooltip.position();
											if (tooltipPosition) {
												if (tooltipPosition.top < 0) {
													jQuery('.tooltip').addClass('history-tooltip');
													arrow.css('top', 'calc(50% + ' + tooltipPosition.top + 'px)');
												} else {
													jQuery('.tooltip').removeClass('history-tooltip');
												}
											}
										});
									});
								} else {
									$timeout(function () {
										hideIt(colId, rowId);
									});
								}
							});
					}
				}
			}, 1000);
		}

		function hideIt(colId, rowId, type) {
			//changed from vm
			vm.showTooltip = false;
			tooltipSetNotReady(colId, rowId);
			delete tooltips[rowId];
			delete visibleMap[rowId];
			if (timeoutMap[rowId] && timeoutMap[rowId][colId]) {
				$timeout.cancel(timeoutMap[rowId][colId]);
				delete timeoutMap[rowId];
			}
			if (promiseMap[rowId] && promiseMap[rowId][colId]) {
				promiseMap[rowId][colId].cancel();
				delete promiseMap[rowId];
			}
		}

		function getLoadingHtml(label) {
			var html = '<div class="myTooltip">' +
				'<div class="tooltipBody">' +
				'<table border="2px solid white" style="background-color:black;color:white;">' +
				'<tr>' +
				'<th >Updated</th>' +
				'<th >' + label + '</th>' +
				'<th >User</th>' +
				'</tr>' +
				'<tr>' +
				'<td colspan="3">Loading...</td>' +
				'</tr>' +
				'</div>' +
				'</div>';
			return html;
		}

		function getRiskScoreLoadingHtml() {
			var html = '<div class="myTooltip">' +
				'<div class="tooltipBody">' +
				'<table border="2px solid white" style="background-color:black;color:white;">' +
				'<tr>' +
				'<th><span translate>Risk category</span></th>' +
				'<th><span translate>Score</span></th>' +
				'</tr>' +
				'<tr>' +
				'<td colspan="2">Loading...</td>' +
				'</tr>' +
				'</div>' +
				'</div>';
			return html;
		}

		function getCommentTooltipHtml(type, data, label) {
			var name = 'Comment History';
			var formatComment = type === 'firstPoEcdDate' || type === 'cmtRspEcdCmt' || type === 'cmtEcdCmt';
			var html = '<div style="text-align:left; padding:0px;" class="myTooltip">' +
				'<div class="tooltipBody">' +
				'<table border="2px solid white" style="background-color:black;color:white;">' +
				'<tr>' +
				'<th >Updated</th>' +
				'<th >' + label + '</th>' +
				'<th >User</th>' +
				'</tr>';

			for (var i = 0; i < data.length; i++) {
				var cmt = strip(data[i].comment);
				var extraText = '';
				if (data[i].roleType && data[i].roleType == 'Supplier') {
					extraText = ' (Supplier)';
				}
				if (formatComment) cmt = $filter('date')(cmt, 'mediumDate');
				if (type === 'cmtColorCmt' || type === 'prodOrderPriority') cmt = !cmt || cmt === 'LEANDNA_NONE' ? '' : colorClassMap[cmt];
				html += '<tr>' +
					'<td>' + $filter('date')(data[i].updatedTime, 'short') + '</td>' +
					'<td>' + cmt + '</td>' +
					'<td>' + data[i].updateUser + extraText + '</td>' +
					'</tr>';
			}
			html += '</table></div></div>';
			return $sce.trustAsHtml(html);
		}

		function getRiskScoreTooltipHtml(data) {
			var riskCategory = $translate.instant('Risk category');
			var score = $translate.instant('Score');
			var name = 'Comment History';
			var html = '<div style="text-align:left; padding:0px;" class="myTooltip">' +
				'<div class="tooltipBody">' +
				'<table border="2px solid white" style="background-color:black;color:white;">' +
				'<tr>' +
				'<th><span>' + riskCategory + '</span></th>' +
				'<th><span>' + score + '</span></th>' +
				'</tr>';

			for (var i = 0; i < data.length; i++) {
				var riskCategory = strip(data[i].label);
				var riskScore = data[i].score;
				html += '<tr>' +
					'<td>' + riskCategory + '</td>' +
					'<td>' + riskScore + '</td>' +
					'</tr>';
			}
			html += '</table></div></div>';
			return $sce.trustAsHtml(html);
		}

		function getTaskCommentHtml(data, isLoading) {
			var html = '<div style="text-align:left; padding:0px;" class="myTooltip">' +
			'<div class="tooltipBody task-comments" style="margin: 10px 0">';
			if (isLoading) {
				html += '<span>Loading...</span>';
			} else {
				if (!data || !data.length) {
					return '';
				}
				_.forEach(data, function(comment) {
					var cmt = $filter('lineBreaks')(strip(comment.comment));
					var dateTitle = $filter('date')(comment.creationUtcTime, 'mediumDate') + ' ' + $filter('date')(comment.creationUtcTime, 'shortTime');
					var relDate = $filter('relativeTime')(comment.creationUtcTime);
					html += '<div class="task-comment">' +
						'<div class="task-comment-time inside-tooltip"><span class="relative-datetime" title="' + dateTitle + '">' + relDate + '</span></div>' +
						'<div class="task-comment-body">' +
						'<span class="task-comment-author">' + comment.firstName + ' ' + comment.lastName + ': </span>' +
						'<span class="task-comment-text">' + cmt + '</span>' +
						'</div></div>';
				});
			}
			html += '</div>';
			return $sce.trustAsHtml(html);
		}

		function getYtdProjectLoadingHtml() {
			var html = '<div class="myTooltip">' +
				'<div class="tooltipBody">' +
				'<table border="2px solid white" style="background-color:black;color:white;">' +
				'<tr>' +
				'<th >Month</th>' +
				'<th >Target</th>' +
				'<th >Actual</th>' +
				'</tr>' +
				'<tr>' +
				'<td colspan="3">Loading...</td>' +
				'</tr>' +
				'</div>' +
				'</div>';
			return html;
		}

		function getAssessmentQuestionTooltipHtml(data) {
			var html = '<div style="text-align:left; padding:0px;" class="myTooltip assessment-questions">' + data + '</div></div>';
			return $sce.trustAsHtml(html);
		}

		function getYtdProjectTooltipHtml(type, results) {
			var html = '<div style="text-align:left; padding:0px;" class="myTooltip">' +
				'<div class="tooltipBody">' +
				'<table border="2px solid white" style="background-color:black;color:white;">' +
				'<tr>' +
				'<th >Month</th>' +
				'<th >Target</th>' +
				'<th >Actual</th>' +
				'</tr>';

			for (var i = 0; i < results.data.length; i++) {
				html += '<tr>' +
					'<td>' + results.data[i].yearMonth + '</td>' +
					'<td class="cell-align-right">' + formatterService.formatCurrency(results.data[i].targetSavingsValue, undefined, results.targetCurrency) + '</td>' +
					'<td class="cell-align-right">' + formatterService.formatCurrency(results.data[i].actualSavingsValue, undefined, results.targetCurrency, true) + '</td>' +
					'</tr>';
			}
			html += '</table></div></div>';
			return $sce.trustAsHtml(html);
		}

		function startEditList(rowIndex, column, cellValue, ndxKey, controllerName) {
			try {
				return startEditList1(rowIndex, column, cellValue, ndxKey, controllerName);
			} catch (exc) {
				throw exc;
			}
		}

		function startEditList1(rowIndex, column, cellValue, ndxKey, controllerName) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + column + rowIndex);
			var content;
			var editTemplate;
			var pos = cell.offset();
			if (column === 'cmtRspCmt') {
				var row = getRawData()[rowIndex];
				leanTableService.getResponsibleCategories(row.leanDirFactoryNdx).then(function (data) {
					vm.inlineLists.responsible = [].concat({
						'resVal': 'None',
						'resDisplay': 'None'
					}, data);
				});
				editTemplate = getTagListTemplate(pos, rowIndex, column, 'responsible', 'vm.currentStatus');
				content = cell.children('.inline-edit-cell').children('.edit-name-text').children('.name-field').html();
				vm.currentStatus = {
					'resVal': content,
					'resDisplay': content
				};
			} else if (column === 'cmtColorCmt' || column === 'prodOrderPriority') {
				vm.inlineLists.color = [{
					'name': 'None',
					'display': 'None'
				},
				{
					'name': 'color-code-10-red',
					'display': 'Red'
				},
				{
					'name': 'color-code-20-blue',
					'display': 'Blue'
				},
				{
					'name': 'color-code-30-yellow',
					'display': 'Yellow'
				}
				];
				editTemplate = getListTemplate(pos, rowIndex, column, 'color', 'vm.currentStatus');
				var classList = cell.children('.cell-div').attr('class').split(' ');
				angular.forEach(classList, function (className) {
					if (colorClassMap[className]) {
						content = className;
					}
				});
				vm.currentStatus = {
					'name': content,
					'display': colorClassMap[content]
				};
			} else if (column === 'rating') {
				vm.inlineLists.scores = vm.getMeta().scores;
				editTemplate = getAssessmentScoreTemplate(pos, rowIndex, column);
				content = cellValue;
				vm.scoreId = content;
			} else if (column === 'liability') {
				vm.inlineLists.liability = vm.getMeta().getLiabilities();
				editTemplate = getListTemplate(pos, rowIndex, column, 'liability', 'vm.currentStatus');
				content = cell.children('.inline-edit-cell').children('.edit-name-text').html();
				vm.currentStatus = {
					'name': content,
					'display': content
				};
			} else if (column === 'deliveryStatus') {
				vm.inlineLists.deliverystatus = vm.getMeta().getDeliveryStatuses();
				editTemplate = getListTemplate(pos, rowIndex, column, 'delivery status', 'vm.currentStatus');
				content = cell.children('.inline-edit-cell').children('.edit-name-text').html();
				vm.currentStatus = {
					'name': content,
					'display': content
				};
			} else if (column === 'actionOwner' || column === 'responsibleName' || column === 'iaTaskOwner') {
				var row = vm.displayedData[rowIndex];
				loadUserList(row);
				content = row[column];
				vm.currentUser = {
					ndx: row[ndxKey],
					display: content,
					updateDisplay: content
				};
				editTemplate = getListTemplate(pos, rowIndex, column, 'responsible', 'vm.currentUser');
			} else if (column === 'actionCategory') {
				var row = vm.displayedData[rowIndex];
				var archivedCategoryNdx = typeof row['isActiveCategory'] !== 'undefined' && !row['isActiveCategory'] ? row[ndxKey] : undefined;
				vm.currentCategory = {
					id: row[ndxKey],
					name: content
				};
				procurementTaskService.getCategories(row.leanDirFactoryNdx, undefined, archivedCategoryNdx).then(function(data) {
					vm.inlineLists.category = data;
					vm.currentCategory = _.find(vm.inlineLists.category, ['id', row[ndxKey]]);
				});
				content = row[column];
				editTemplate = getListTemplate(pos, rowIndex, column, 'category', 'vm.currentCategory', 'displayName');
			} else if (column === 'actionStatus' || column === 'status') {
				var row = vm.displayedData[rowIndex];
				var func = column === 'actionStatus' ? procurementTaskService.getStatuses : procurementTaskService.getIAStatuses;
				func(row.leanDirFactoryNdx).then(function(data) {
					vm.inlineLists.status = data.map(function (st) {
						st.displayName = st.name;
						if (st.name === 'Review Later') st.displayName = 'In Progress';
						return st;
					}) || [];
					if (cellValue === 'Unable to Fix' && column === 'status') {
						vm.inlineLists.status = vm.inlineLists.status.filter(function (st) {
							return st.name !== 'Review Later';
						});
					}
				});
				if (column === 'status') {
					vm.unableToFixCategoriesLoaded = false;
					vm.noActiveCategories = false; // Initialize to false until categories load
					vm.selected = {};
					vm.watchersObject = {tempWatchers: []};
					vm.statusChange = {id: row.taskId};
					vm.currentResponsibleTemp = undefined;
					inventoryActionConfigService.getUnableToFixCategories(row.leanDirFactoryNdx, true).then(function(data) {
						// Ensure categories is always an array
						vm.inlineLists['unableToFixCategories'] = Array.isArray(data) ? data : [];
						vm.unableToFixCategoriesLoaded = true;
						// Set a simple boolean for template binding (avoids function call issues in Angular templates)
						var activeCount = getActiveUnableToFixCategories().length;
						vm.noActiveCategories = activeCount === 0;
					});
					getEmailSuffix(row.leanDirFactoryNdx);
					loadUserList(row);
				}
				content = cellValue;
				vm.currentStatus = {
					id: row[ndxKey],
					name: content,
					displayName: content === 'Review Later' ? 'In Progress' : content
				};
				vm.previousStatus = content;
				vm.reviewLaterDatePickerOptions = {
					minDate: new Date(Date.now() + (24 * 60 * 60 * 1000)),
					initDate: new Date(Date.now() + 12096e5), // 2 weeks from now
					showWeeks: false
				};
				vm.currentReviewLaterDate = undefined;
				var actionType = row.actionId != undefined ? 'inventoryAction' : '';
				editTemplate = getStatusTemplate(pos, rowIndex, column, actionType);
			} else if (column === 'lateDeliveryDescription') {
				var row = vm.displayedData[rowIndex];
				leanTableService.getLateDeliveryCauses(row.leanDirFactoryNdx || row.factoryNdx).then(function (data) {
					vm.inlineLists.lateDeliveryIssues = [].concat({
						'description': 'None',
						'ndx': -1
					}, data);
				});
				editTemplate = getLateDeliveryIssuesTemplate(pos, rowIndex, column);
				vm.issueNdx = row.lateDeliveryIssueNdx;
			} else if (column === 'poStatusCategoryDescription') {
				var row = vm.displayedData[rowIndex];
				leanTableService.getPoStatusCategories().then(function (data) {
					vm.inlineLists.poStatusCategories = [].concat({
						'description': 'None',
						'ndx': -1
					}, data);
				});
				editTemplate = getPoStatusCategoriesTemplate(pos, rowIndex, column);
				vm.poStatusCategoryNdx = row.poStatusCategoryNdx;
			} else if (column === 'actualSavings') {
				var row = vm.displayedData[rowIndex];
				editTemplate = getActualSavingsTemplate(pos, rowIndex, column);
				vm.actualSavingsOptions = [
					{
						isValid: true,
						display: cellValue
					}, {
						isValid: false,
						display: 'Invalidate Actual Value'
					}
				];
				vm.hasValidSavings = row.hasValidSavings;
				vm.invalidComment = row.invalidSavingsComment || '';
			} else if (column === 'personName') {
				var rowData = vm.displayedData[rowIndex];
				var inactiveUserIndex = rowData['state'] == 'inactive' ? rowData['responsibleId'] : undefined;
				valueStreamService.getUsers(inactiveUserIndex, rowData['factoryNdx']).then(function(data) {
					var userList = data.map(function(user) {
						return {
							'name': user.id,
							'display': user.name
						};
					});
					vm.inlineLists.Responsible = userList;
					content = rowData.personName;
					vm.currentStatus = {
						'name': getNameFromDisplay(userList, content),
						'display': content
					};
				});
				editTemplate = getListTemplate(pos, rowIndex, column, 'Responsible', 'vm.currentStatus', undefined, controllerName);
			} else if (column === 'activated') {
				var rowData = vm.displayedData[rowIndex];
				var yesNoOptions = [
					{
						'name': 1,
						'display': 'Yes'
					},
					{
						'name': 0,
						'display': 'No'
					}
				];
				vm.inlineLists.PerformanceActivated = yesNoOptions;
				editTemplate = getListTemplate(pos, rowIndex, column, 'Performance Activated', 'vm.currentStatus', undefined, controllerName);
				content = rowData.activated ? 'Yes' : 'No';
				vm.currentStatus = {
					'name': rowData.activated ? 1 : 0,
					'display': content
				};
			} else if (controllerName == 'flexFieldConfigCtrl' && column == 'filterTypeDisplay') {
				var row = vm.displayedData[rowIndex];
				vm.inlineLists.FilterType = [
					{
						'name': 'multiselect',
						'display': 'Multi-Select List'
					}, {
						'name': 'string',
						'display': 'Text Search'
					}
				];
				editTemplate = getListTemplate(pos, rowIndex, column, 'Filter Type', 'vm.currentStatus', undefined, controllerName);
				vm.currentStatus = {
					'name': row.filterType.filterType,
					'display': row.filterType.filterTypeDisplay
				};
			}
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 27) {
					vm.cancelEdit();
				}
			});
			vm.inlineActive = true;
			vm.popupFirstShow = true;

			$timeout(function () {
				jQuery('.inlineEditDiv .ui-select-toggle').trigger('click');
			});

			function getNameFromDisplay (list, display) {
				var matchingOption = list.find(function (option) {
					return option.display === display;
				});
				return matchingOption && matchingOption.name;
			}
		}

		function loadUserList(row) {
			procurementTaskService.getUsers(row.leanDirFactoryNdx).then(function(data) {
				if (!Array.isArray(data)) {
					vm.inlineLists.responsible = [];
				}
				vm.inlineLists.responsible = data.filter(function(user) {
					return user.roleType !== 'Supplier';
				});
				_.map(vm.inlineLists.responsible, function(user) {
					user.display = user.lastName + ', ' + user.firstName + ' (' + user.emailAddress + ')';
					user.updateDisplay = user.firstName + ' ' + user.lastName;
				});
			});
		}

		function startEditDate(rowIndex, column, showApprovalModal) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var row = vm.displayedData[rowIndex];
			var columnId = column === 'soCommitDateCopy' ? 'firstPoEcdDate': column;
			vm.currentDate = row[columnId];
			vm.currentDateUnformatted = vm.currentDate;
			var cell = jQuery('#' + columnId + rowIndex);
			if (vm.currentDate) {
				if (typeof vm.currentDate === 'number') {
					vm.currentDate = moment.utc(vm.currentDate).format('YYYY-MM-DD');
				}

				var momentDate = moment(vm.currentDate, 'YYYY-MM-DD');
				vm.currentDate = momentDate.toDate();
			} else {
				vm.currentDate = null;
			}
			vm.checkValidDate();
			var pos = cell.offset();
			var editTemplate = getDateTemplate(pos, rowIndex, column, showApprovalModal);
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13 && vm.hasValidDate) {
					vm.saveEditDate(rowIndex, column, null, showApprovalModal);
				} else if (code == 27) {
					vm.cancelEdit();
				}
			});
			vm.inlineActive = true;
			$timeout(function() {
				jQuery('.dateInput').trigger('select');
				jQuery('[uib-datepicker-popup-wrap]').unbind().remove();
			});
		}

		function isDateLate(date, format) {
			if (format) {
				date = moment(date, 'YYYY-MM-DD');
			} else {
				date = moment(date);
			}
			if (typeof date === 'undefined') {
				return false;
			}
			var momentNow = moment().startOf('day');
			return (date.startOf('day') < momentNow);
		}

		// Filter to show only active categories (exclude 'inactive' or 'archived')
		// Categories without a state property are treated as active (for backwards compatibility)
		function getActiveUnableToFixCategories() {
			if (!vm.inlineLists.unableToFixCategories || !Array.isArray(vm.inlineLists.unableToFixCategories)) {
				return [];
			}
			return vm.inlineLists.unableToFixCategories.filter(function(category) {
				// Exclude if state is 'archived' or 'inactive' (case-insensitive)
				// Include everything else (no state, 'active', etc.)
				if (!category.state) {
					return true; // No state property = active
				}
				var stateLower = String(category.state).toLowerCase();
				// Explicitly exclude archived and inactive states
				if (stateLower === 'archived' || stateLower === 'inactive') {
					return false;
				}
				return true; // Include 'active' or any other state
			});
		}

		// Helper function to check if there are no active categories (for template binding)
		function hasNoActiveUnableToFixCategories() {
			return vm.unableToFixCategoriesLoaded && getActiveUnableToFixCategories().length === 0;
		}

		function canSaveStatusChange(isInventoryAction) {
			if (!vm.currentStatus) {
				return false;
			}
			if (isInventoryAction) {
				if (vm.currentStatus.name === 'Unable to Fix' && vm.previousStatus !== 'Unable to Fix') {
					if (!vm.unableToFixCategoriesLoaded) {
						return false;
					}
					// If no active categories exist, require a comment
					if (vm.noActiveCategories) {
						return !!vm.statusChange.reason && vm.statusChange.reason.trim().length > 0;
					}
					// Active categories exist - require category selection
					if (!vm.selected.unableToFixCategory) {
						return false;
					}
					if (vm.selected.unableToFixCategory.action === 'Add Comment (required)') {
						return !!vm.statusChange.reason && vm.statusChange.reason.trim().length > 0;
					}
					return vm.selected.unableToFixCategory.action !== 'Reassign' || vm.currentResponsibleTemp;
				}
			}
			return true;
		}

		function clearTaggingVariables(taskId) {
			vm.watchersObject.prefixForTagging = '';
			vm.watchersObject.suffixForTagging = '';
			vm.watchersObject.tempWatchers[taskId] = [];
		}

		function getEmailSuffix(factoryNdx) {
			procurementTaskService.getEmailSuffix(factoryNdx).then(function(suffix) {
				vm.watchersObject.emailSuffix = suffix;
			});
		}

		function addWatchersIfAny(taskId, commentText, factoryNdx) {
			var promiseList = [];
			var tempWatchersObj = vm.watchersObject.tempWatchers[taskId];
			for (var userNdx in tempWatchersObj) {
				var tag = tempWatchersObj[userNdx];
				if (commentText.indexOf(tag) >= 0) {
					promiseList.push(addWatcherToTask(userNdx, taskId, true, factoryNdx));
				}
			}
			return promiseList;
		}

		function addWatcherToTask(userNdx, taskId, quiet, factoryNdx){
			return procurementTaskService.addWatcher(factoryNdx, taskId, userNdx, quiet);
		}

		function checkValidDate() {
			vm.hasValidDate = !!vm.currentDate && vm.currentDate.getTime() > 0;
		}

		function getDateTemplate(position, ndx, column, showApprovalModal) {
			var dateFormat = 'mediumDate';
			var showClear = column !== 'actionDueDate' && column !== 'dueDate';
			ensurePopupInBound(position, 340, 420);
			var exampleDate = $filter('date')('2021-01-01', dateFormat);

			var editTemplate = '<div class="inlineEditDiv dateEdit withInput" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">Select a date</div>' +
				'<input type="text" ng-model="vm.currentDate" placeholder="(e.g. ' + exampleDate + ')" class="dateInput" uib-datepicker-popup="' + dateFormat + '" ng-change="vm.checkValidDate()"/>' +
				'<div class="errorMsg" ng-class="{\'invalid\': vm.currentDate !== null && !vm.hasValidDate}">Invalid date format (e.g. ' + exampleDate + ')</div>' +
				'<div uib-datepicker ng-model="vm.currentDate" class="well well-sm needs-focus" ng-change="vm.checkValidDate()"></div>' +
				'<div class="inlineEditButtons">' +
				(showClear ? '<button class="button flat" ng-click="vm.saveEditDate(' + ndx + ', ' + "'" + column + "', true" + ')">Clear</button>' : '') +
				'<button class="button flat" ng-click="vm.cancelEdit()">Cancel</button>' +
				'<button class="button flat colored" data-testid="dateColumn-inlineEdit-save-btn" ng-disabled="!vm.hasValidDate" ng-click="vm.saveEditDate(' + ndx + ', ' + "'" + column + "', null, " + showApprovalModal + ')">Save</button></div></div>';
			return editTemplate;
		}

		function getStatusTemplate(position, rowIndex, type, actionType) {
			var extraHeight = type === 'status' ? 240: 112;
			ensurePopupInBound(position, 340, extraHeight);

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' + position.left + 'px;height: auto">' +
				'<div class="inlineEditHeader">Choose status</div>' +
				'<ui-select autofocus="true" theme="bootstrap" ng-model="vm.currentStatus">' +
				'<ui-select-match placeholder="{{' + "'Select status...'" + ' | translate}}">' +
				'<span ng-bind-html="$select.selected.displayName"></span>' +
				'</ui-select-match>' +
				'<ui-select-choices repeat="item in vm.inlineLists.status | filter: $select.search">' +
				'<div ng-bind-html="item.displayName"></div>' +
				'</ui-select-choices>' +
				'</ui-select>' + (type === 'status' ? iaUnableToFixSection() : '') +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="vm.cancelEdit()">Cancel</button>' +
				'<button class="button flat colored" data-testid="' + (actionType != '' ? actionType + '-' : '') + 'statusColumn-inlineEdit-save-btn" ng-disabled="!vm.canSaveStatusChange(' + (type === 'status') + ')" ng-click="vm.saveEdit(' + rowIndex + ', ' + '\'' + type + '\')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function iaUnableToFixSection() {
			return '<div ng-if="vm.currentStatus.name === \'Unable to Fix\' && vm.previousStatus !== \'Unable to Fix\'">' +
				// Category dropdown - only show when active categories exist (not when vm.noActiveCategories is true)
				'<div ng-if="vm.unableToFixCategoriesLoaded && !vm.noActiveCategories" class="unable-to-fix-container" style="padding-top: 16px;">' +
					'<div class="inlineEditHeader" translate>leanTable.editor.inventoryAction.unableToFixCategory</div>' +
					'<ui-select theme="bootstrap" ng-model="vm.selected.unableToFixCategory" on-select="vm.focusReason();vm.updateActionStatusPosition($item)">' +
						'<ui-select-match placeholder="{{\'leanTable.editor.inventoryAction.chooseCategory\' | translate}}">' +
							'<span ng-bind-html="$select.selected.categoryName"></span>' +
						'</ui-select-match>' +
						'<ui-select-choices repeat="item in vm.getActiveUnableToFixCategories()">' +
							'<span ng-bind-html="item.categoryName"></span>' +
						'</ui-select-choices>' +
					'</ui-select>' +
				'</div>' +
				'<div class="task-status-unable-to-fix-comment">' +
					// Comment field - show when no active categories OR when a non-Reassign category is selected
					'<div ng-show="(vm.unableToFixCategoriesLoaded && vm.noActiveCategories) || (vm.selected && vm.selected.unableToFixCategory && vm.selected.unableToFixCategory.action !== \'Reassign\')" style="padding-top: 16px">' +
						'<div class="inlineEditHeader" ng-bind-html="(vm.unableToFixCategoriesLoaded && vm.noActiveCategories) ? (\'leanTable.editor.inventoryAction.addCommentRequired\' | translate) : (vm.selected.unableToFixCategory ? (vm.selected.unableToFixCategory.action === \'Add Comment (required)\' ? (\'leanTable.editor.inventoryAction.addCommentRequired\' | translate) : (vm.selected.unableToFixCategory.action === \'Add Comment (optional)\' ? (\'leanTable.editor.inventoryAction.addCommentOptional\' | translate) : vm.selected.unableToFixCategory.action)) : \'\')"></div>' +
						'<textarea class="form-control" name="reason" cols=60 rows=4 ng-model="vm.statusChange.reason" ' +
							'ng-attr-placeholder="{{(vm.unableToFixCategoriesLoaded && vm.noActiveCategories) ? (\'leanTable.editor.inventoryAction.commentReasonRequired\' | translate) : (vm.selected && vm.selected.unableToFixCategory && vm.selected.unableToFixCategory.message && vm.selected.unableToFixCategory.message.length ? vm.selected.unableToFixCategory.message : (\'leanTable.editor.inventoryAction.commentReasonRequired\' | translate))}}" ' +
							'uib-typeahead="user as user.userDisplay for user in vm.getUsersForTagging($viewValue, vm.watchersObject, vm.inlineLists.responsible)" ' +
							'typeahead-input-formatter="vm.formatTagResult($model, vm.statusChange, vm.watchersObject, false, \'reason\')"></textarea>' +
						'<div class="no-tag-results" ng-if="vm.watchersObject.displayNoUsersFound">No Users Found.</div>' +
					'</div>' +
					'<div ng-if="vm.selected && vm.selected.unableToFixCategory && vm.selected.unableToFixCategory.action === \'Reassign\'">' +
						'<div class="inlineEditHeader bold" style="padding-top: 16px" translate>leanTable.editor.inventoryAction.reassign</div>' +
						'<div class="assign-to-planner-message" ng-if="vm.selected.unableToFixCategory.message && vm.selected.unableToFixCategory.message.length">' +
							'{{vm.selected.unableToFixCategory.message}}' +
						'</div>' +
						'<div class="inlineEditHeader" style="padding-top: 16px" translate>Responsible</div>' +
						'<ui-select theme="bootstrap" ng-model="vm.currentResponsibleTemp">' +
							'<ui-select-match placeholder="{{\'Select responsible...\' | translate}}">' +
								'{{vm.currentResponsibleTemp.firstName + " " + vm.currentResponsibleTemp.lastName}}' +
								'{{vm.currentResponsibleTemp.state == "inactive" ? " (inactive)" : ""}}' +
							'</ui-select-match>' +
							'<ui-select-choices repeat="item in vm.inlineLists.responsible | filter: $select.search track by item.ndx">' +
								'<span style="color: {{item.state === \'inactive\' ? \'#999\' : \'#000\'}};">' +
									'{{item.lastName}}, {{item.firstName}} ({{item.emailAddress}})' +
								'</span>' +
							'</ui-select-choices>' +
						'</ui-select>' +
					'</div>' +
				'</div>' +
			'</div>';
		}

		function getSelectTemplate(position, model, onSelect, selectPlaceholder, selectMatchContent, repeatChoices, choiceDisplay, groupby, type, actionType) {
			var usingGroupBy = groupby ? groupby : '';
			var dataTestId = ' data-testid="' + (actionType != '' ? actionType + '-' : '') + type + 'Column-inlineEdit-optionList"';
			return '<div ng-click="$event.preventDefault();" class="inlineEditDiv inlineSelect" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
					'<ui-select autofocus="true" theme="bootstrap" ng-model="' + model + '" ' +
							'on-select="' + onSelect + '" ' +
							'uis-open-close="vm.handleSingleSelectOpenClose(isOpen)">' +
						'<ui-select-match placeholder="{{\'' + selectPlaceholder + '\' | translate}}">' +
							selectMatchContent +
						'</ui-select-match>' +
					'<ui-select-choices ' + usingGroupBy + dataTestId + ' repeat="' + repeatChoices + ' | filter: $select.search">' +
							choiceDisplay +
						'</ui-select-choices>' +
					'</ui-select>' +
				'</div>';
		}

		function onSingleSelect(selected, rowIndex, type, label, controllerNameHTML) {
			var selectedName;
			if (type === 'poStatusCategoryDescription' || type === 'lateDeliveryDescription') {
				selectedName = selected.description;
			} else if (type === 'cmtRspCmt') {
				selectedName = selected.resVal;
			} else if (type === 'deliveryStatus') {
				selectedName = selected.value;
			} else {
				selectedName = selected.name;
			}

			if (selectedName === 'None') {
				vm.saveEdit(rowIndex, type, true, label);
			} else {
				vm.saveEdit(rowIndex, type, undefined, label, controllerNameHTML);
			}
		}
		function handleSingleSelectOpenClose(isOpen) {
			if (!isOpen && !vm.popupFirstShow && jQuery('.inlineEditDiv.inlineSelect').length) {
				vm.cancelEdit();
			}
			vm.popupFirstShow = false;
		}

		function getListTemplate(position, rowIndex, type, label, model, display, controllerName) {
			ensurePopupInBound(position, 340, 120);
			var listKey = label.replace(/\s/g, '');
			var itemDisplay = (display ? display : 'display');
			var controllerNameHTML = controllerName ? "'" + controllerName + "'" : 'undefined';
			var groupby = label.toLowerCase() === 'role' ? 'group-by="roleGroup"' : '';
			var selectPlaceholder = 'Select ' + label + '...';
			var onSelect = 'vm.onSingleSelect($select.selected, ' + rowIndex + ', \'' + type + '\', \'' + label + '\', ' + controllerNameHTML + ')';
			var selectMatchContent = '<span ng-bind-html="$select.selected.' + itemDisplay + '"></span>';
			var repeatChoices = 'item in vm.inlineLists.' + listKey;
			var choiceDisplay = '<div ng-bind-html="item.' + itemDisplay + '"></div>';
			var row = getRawData()[rowIndex];
			var actionType = row.actionId != undefined ? 'inventoryAction' : '';
			return getSelectTemplate(position, model, onSelect, selectPlaceholder, selectMatchContent, repeatChoices, choiceDisplay, groupby, type, actionType);
		}

		function getMultiSelectTemplate(position, ndx, fieldName, label, allowBlank, key, value, addPlaceholder) {
			ensurePopupInBound(position, 340, 356);
			var multiSelectStr = ' multiple ';
			var className = 'multiselect-edit';
			var saveFunctionName = 'saveEdit';
			var allowBlankHTML = allowBlank === false ? 'vm.currentStatus.length>0 && ' : '';
			var disabledHTML = allowBlank === false ? ' ng-disabled="!vm.currentStatus.length"' : '';
			if (fieldName === 'approverUserNdx') saveFunctionName = 'saveEditProjectAreaApprovers';
			var optionKey = key || 'ndx';
			var optionValue = value || 'name';
			var uiSelectMatchTerm = '{{$item.' + optionValue + '}}';

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv ' + className + '" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">' + label + '</div>' +
				'<ui-select ' + multiSelectStr + 'append-to-body="true" theme="bootstrap" ng-model="vm.currentStatus">' +
				'<ui-select-match placeholder="{{\'' + (addPlaceholder || ('Select ' + label)) + '...\'' + ' | translate}}">' +
				uiSelectMatchTerm +
				'</ui-select-match>' +
				'<ui-select-choices ui-disable-choice="item.' + optionValue + '.indexOf(\'(inactive)\') !== -1" repeat="item.' + optionKey + ' as item in vm.multiSelectItems | filter: $select.search">' +
				'<div>{{item.' + optionValue + '}}</div>' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="vm.cancelEdit()">Cancel</button>' +
				'<button class="button flat colored"' + disabledHTML + 'ng-click="' + allowBlankHTML + 'vm.' + saveFunctionName + '(' + ndx + ', \'' +  fieldName + '\', \'' +  label + '\')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function startMultiSelectEdit(rowIndex, column, label,  fieldInputType, maxLength, controllerName, allowBlank) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var row = getRawData()[rowIndex];
			var cell = jQuery('#' + column + rowIndex);
			var pos = cell.offset();
			var fieldName = column;
			var content = row[fieldName];
			$scope.$parent.tableCtrl.getList().then(function (list) {
				vm.multiSelectItems = list;
			});
			var selectedItems = [];
			if (typeof content !== 'undefined') {
				angular.forEach(content.split(','), function (listItem) {
					selectedItems.push(parseInt(listItem));
				});
			}
			var editTemplate;
			vm.currentStatus = selectedItems;
			var allowBlank = allowBlank === false ? false: true;
			editTemplate = getMultiSelectTemplate(pos, row['ndx'], fieldName, label, allowBlank);
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code === 27) {
					cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function getTagListTemplate(position, rowIndex, type, label, model) {
			ensurePopupInBound(position, 340, 120);
			var displayField = label === 'responsible' ? 'resDisplay' : 'name';
			var onSelect = 'vm.onSingleSelect($select.selected, ' + rowIndex + ', \'' + type + '\')';
			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv inlineSelect" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<ui-select autofocus="true" tagging="vm.tagTransform" theme="bootstrap" ng-model="' + model + '" ' +
						'on-select="' + onSelect + '" ' +
						'uis-open-close="vm.handleSingleSelectOpenClose(isOpen)">' +
					'<ui-select-match placeholder="{{' + '\'Select ' + label + '...\'' + ' | translate}}">' +
						'<span ng-bind-html="$select.selected.' + displayField + '"></span>' +
					'</ui-select-match>' +
					'<ui-select-choices repeat="item in vm.inlineLists.' + label + ' | filter: $select.search" refresh="vm.refreshTagListResults($select, \'' + label + '\')" refresh-delay="0">' +
						'<div ng-bind-html="item.' + displayField + ' + item.extraLabel"></div>' +
					'</ui-select-choices>' +
				'</ui-select>' +
			'</div>';
			return editTemplate;
		}

		function getLateDeliveryIssuesTemplate(position, rowIndex, type) {
			ensurePopupInBound(position, 400, 356);
			var model = 'vm.issueNdx';
			var onSelect = 'vm.onSingleSelect($select.selected, ' + rowIndex + ', \'' + type + '\')';
			var selectPlaceholder = 'Choose Late Delivery Cause';
			var selectMatchContent = '{{$select.selected.description}}';
			var repeatChoices = 'item.ndx as item in vm.inlineLists.lateDeliveryIssues';
			var choiceDisplay = '<div title="{{item.description}}">{{item.description}}</div>';
			var groupby = 'group-by="vm.lateDeliveryCauseGrouping"';
			return getSelectTemplate(position, model, onSelect, selectPlaceholder, selectMatchContent, repeatChoices, choiceDisplay, groupby);
		}

		function getPoStatusCategoriesTemplate(position, rowIndex, type) {
			ensurePopupInBound(position, 400, 356);
			var selectPlaceholder = 'Select supply order status category...';
			var model = 'vm.poStatusCategoryNdx';
			var onSelect = 'vm.onSingleSelect($select.selected, ' + rowIndex + ', \'' + type + '\', \'PoStatusCategoryInPOReport\')';
			var selectMatchContent = '{{$select.selected.description}}';
			var repeatChoices = 'item.ndx as item in vm.inlineLists.poStatusCategories';
			var choiceDisplay = '<div title="{{item.description}}">{{item.description}}</div>';
			return getSelectTemplate(position, model, onSelect, selectPlaceholder, selectMatchContent, repeatChoices, choiceDisplay, type);
		}

		function getActualSavingsTemplate(position, rowIndex, type) {
			var row = vm.displayedData[rowIndex];
			ensurePopupInBound(position, 400, 356);
			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv textEdit larger" ng-style="" style="top:' + position.top + 'px; left: ' + position.left + 'px; height: auto;">' +
					'<div class="inlineEditHeader">Update Actual Value</div>' +
					'<ui-select autofocus="true" theme="bootstrap" ng-model="vm.hasValidSavings">' +
						'<ui-select-match placeholder="{{' + "'Select...'" + ' | translate}}">' +
							'{{$select.selected.display}}' +
						'</ui-select-match>' +
						'<ui-select-choices repeat="option.isValid as option in vm.actualSavingsOptions | filter: $select.search">' +
							'<div title="{{option.display}}">{{option.display}}</div>' +
						'</ui-select-choices>' +
					'</ui-select>' +
					'<div style="padding-top:16px" ng-show="vm.hasValidSavings == false">' +
						'<div class="inlineEditHeader">Add Comment (optional)</div>' +
						'<textarea class="form-control" name="reason"' +
							'cols=60 rows=4 ng-model="vm.invalidComment" ' +
							'ng-attr-placeholder="Reason this is invalid..."></textarea>' +
					'</div>' +
					'<div class="inlineEditButtons">' +
						'<button class="button flat" ng-click="vm.cancelEdit()">Cancel</button>' +
						'<button class="button flat colored" ng-disabled="vm.hasValidSavings == ' + row.hasValidSavings + ' && vm.invalidComment == \'' + (row.invalidSavingsComment || '') + '\'" ng-click="vm.saveEdit(' + rowIndex + ', ' + '\'' + type + '\')">Save</button>' +
					'</div>' +
				'</div>';
			return editTemplate;
		}

		function getAssessmentScoreTemplate(position, rowIndex, type) {
			ensurePopupInBound(position, 340, 356);
			var selectPlaceholder = 'Choose Score';
			var model = 'vm.scoreId';
			var onSelect = 'vm.onSingleSelect($select.selected, ' + rowIndex + ', \'' + type + '\')';
			var selectMatchContent = '{{$select.selected.display}}';
			var repeatChoices = 'item.id as item in vm.inlineLists.scores';
			var choiceDisplay = '<div>{{item.display}}</div>';
			return getSelectTemplate(position, model, onSelect, selectPlaceholder, selectMatchContent, repeatChoices, choiceDisplay, type);
		}

		function getForecastTemplate(position, rowIndex) {
			var popupWidth = 550;
			ensurePopupInBound(position, popupWidth, 226);
			vm.startedEmpty = !vm.currentForecast || !vm.currentForecast.length;
			if (vm.startedEmpty) {
				vm.currentForecast = [];
				vm.currentForecast.push({forecastDate: undefined, forecastQuantity: undefined});
			}
			var minDate = $filter('date')(new Date(), 'yyyy-MM-dd');
			var editTemplate = '<div ng-click="$event.preventDefault();" id="forecast-inline-edit" class="inlineEditDiv" style="top: ' + position.top + 'px; left: ' + position.left + 'px; width: ' + popupWidth + 'px">' +
				'<div class="inlineEditHeader">Add Delivery Schedule</div>' +
				'<div class="forecast-body container-fluid">' +
				'<div class="row row-4-padding">' +
				'<div class="col-md-4 forecast-column-label">Delivery date</div>' +
				'<div class="col-md-2 forecast-column-label">Quantity</div>' +
				'<div class="col-md-2 forecast-column-label">Tracking #</div>' +
				'<div class="col-md-3 forecast-column-label">Comment</div>' +
				'</div>' +
				'<div class="row row-4-padding" ng-show="!vm.startedEmpty && !(vm.currentForecast && vm.currentForecast.length)">' +
				'<p style="color: #757575">No scheduled deliveries for the PO line.  Click <strong>Save</strong> if this is correct.  Click <strong>Plus</strong> to add deliveries.</p>' +
				'</div>' +
				'<div class="row row-4-padding" ng-show="vm.currentForecast && vm.currentForecast.length" ng-repeat="forecast in vm.currentForecast">' +
				'<div class="col-md-4"><div class="input-group"><input type="text" class="form-control" ng-class="{\'ng-invalid\': forecast.errorMessage && forecast.errorMessage.length}" ' +
				'title="{{forecast.errorMessage}}" uib-datepicker-popup="mediumDate" ng-model="forecast.forecastDate" is-open="forecast.forecastDatePickerOpen" datepicker-append-to-body="true" '  +
				'onkeydown="return false" close-text="Cancel" datepicker-options="{\'showWeeks\':false, \'minDate\': \'' + minDate + '\'}" ng-click="vm.openForecastDatePicker(forecast)" />' +
				'<span class="input-group-btn"><button ng-class="{\'ng-invalid\': forecast.errorMessage && forecast.errorMessage.length}" type="button" class="btn btn-default" ng-click="forecast.forecastDatePickerOpen = true"><i class="fa fa-calendar"></i></button></span></div></div>' +

				'<div class="col-md-2"><input class="form-control" type="number" min="0" max="100000000" ng-model="forecast.forecastQuantity"></div>' +

				'<div class="col-md-2"><input class="form-control" type="text" maxLength="256" ng-model="forecast.forecastTrackingNumber"></div>' +

				'<div class="col-md-3"><input class="form-control" type="text" maxLength="2500" maxlength="2500" min="0" ng-model="forecast.forecastComment"></div>' +

				'<div class="col-md-1" style="text-align: center;"><i class="fa fa-times" style="padding-top: 9px; font-size: 15px" ng-click="vm.removeForecastRow($index)"></i></div>' +
				'</div>' +
				'</div>' +
				'<div class="forecast-add-line"><span><i class="fa fa-plus-circle" ng-click="vm.addForecastRow()"></i></span></div>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="closeAndDestroy()">Cancel</button>' +
				'<button class="button flat colored" ng-click="saveEditForecast(' + rowIndex + ')" ng-disabled="vm.disableSaveForecast()">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function addForecastRow() {
			var element = jQuery('#forecast-inline-edit');
			var windowHeight= window.innerHeight;
			var currentHeight = element.innerHeight();
			var currentPosition = element.position();
			if (currentPosition.top + currentHeight + 42 > windowHeight && vm.currentForecast.length < 4) {
				$timeout(function() {
					jQuery('#forecast-inline-edit').css({top: currentPosition.top - 42, left: currentPosition.left});
				});
			}
			vm.currentForecast.push({forecastDate: undefined, forecastQuantity: undefined});
		}

		function removeForecastRow(index) {
			vm.currentForecast.splice(index, 1);
		}

		function saveEditForecastInner(rowIndex) {
			// Delete case
			var factoryNdx = vm.rowData[rowIndex].factoryNdx || vm.rowData[rowIndex].leanDirFactoryNdx;
			var currentOrderNdx = vm.rowData[rowIndex].orderNdx || vm.rowData[rowIndex].forecastFirstDeliveryPoNdx || vm.rowData[rowIndex].firstPoNdx;
			if (!vm.currentForecast || !vm.currentForecast.length) {
				supplyOrderForecastService.deleteForecast(factoryNdx, currentOrderNdx)
					.then(function(x) {
						if (typeof x !== 'undefined') {
							postForecastSave(rowIndex, x);
						}
					});
			} else {
				var saveObject = [];
				vm.currentForecast.forEach(function(forecast) {
					var dt = new Date(forecast.forecastDate);
					var selectedDateUtc = moment(dt).subtract(dt.getTimezoneOffset(), 'minutes');
					saveObject.push({forecastQuantity: forecast.forecastQuantity, forecastDate: selectedDateUtc.valueOf(), forecastTrackingNumber: forecast.forecastTrackingNumber, forecastComment: forecast.forecastComment});
				});
				supplyOrderForecastService.saveForecast(factoryNdx, currentOrderNdx, saveObject)
					.then(function (x) {
						if (typeof x !== 'undefined') {
							postForecastSave(rowIndex, x);
						}
					});
			}
		}

		function postForecastSave(rowIndex, resp) {
			var currentRow = vm.rowData[rowIndex];
			// update the row with the new fields and refresh tabel
			var firstForecastDate = undefined;
			var firstForecastQuantity = undefined;
			var forecastTrackingNumber = undefined;
			var forecastComment = undefined;
			var totalForecastDeliveries = vm.currentForecast ? vm.currentForecast.length : 0;
			var totalForecastQuantity = 0;
			if (vm.currentForecast) {
				vm.currentForecast.forEach(function(forecast) {
					var forecastDateObj = moment(new Date(forecast.forecastDate).setHours(18)).subtract(new Date().getTimezoneOffset(), 'minutes');
					if (!firstForecastDate || firstForecastDate > forecastDateObj.valueOf()) {
						firstForecastDate = forecastDateObj.valueOf();
						firstForecastQuantity = forecast.forecastQuantity;
						forecastTrackingNumber = forecast.forecastTrackingNumber;
						forecastComment = forecast.forecastComment;
					}
					totalForecastQuantity += forecast.forecastQuantity;
				});
			}

			var updateRowsObject = {};
			updateRowsObject.identifier = {
				factoryNdx: currentRow.factoryNdx,
				leanDirFactoryNdx: currentRow.leanDirFactoryNdx,
				orderNdx: currentRow.orderNdx,
				forecastFirstDeliveryPoNdx: currentRow.forecastFirstDeliveryPoNdx,
				firstPoNdx: currentRow.firstPoNdx
			};
			updateRowsObject.identifier = _.pickBy(updateRowsObject.identifier, _.identity);
			updateRowsObject.newValues = {
				forecastDeliveryCount: totalForecastDeliveries,
				forecastTotalQuantity: totalForecastQuantity,
				forecastFirstDeliveryQuantity: firstForecastQuantity,
				forecastFirstDeliveryDate: firstForecastDate,
				forecastFirstTrackingNumber: forecastTrackingNumber,
				forecastFirstComment: forecastComment,
				confirmationStatusUsed: resp.confirmationStatusUsed
			};
			vm.currentForecast = undefined;
			updateRows(updateRowsObject);
			cancelEdit();
		}

		function openForecastDatePicker(forecast) {
			forecast.forecastDatePickerOpen = true;
		}

		function disableSaveForecast() {
			if (vm.currentForecast && vm.currentForecast.length) {
				var today = moment();
				var returnValue = false;
				var sortedList = _.sortBy(vm.currentForecast, 'forecastDate');
				var previousDate = undefined;
				sortedList.forEach(function(forecast) {
					if (!forecast.forecastDate || today.isAfter(moment(forecast.forecastDate), 'day')) {
						returnValue = true;
					}
					if (!forecast.forecastQuantity) {
						returnValue = true;
					}
					if (forecast.forecastComment && forecast.forecastComment.length > 2500) {
						returnValue = true;
						forecast.errorMessage = 'Max allowed characters for comment are 2500.';
					}
					if (!previousDate) {
						previousDate = moment(forecast.forecastDate);
					} else if (previousDate.isSame(moment(forecast.forecastDate), 'day')){
						returnValue = true;
						forecast.errorMessage = 'Another forecast already exists for this date.';
					} else {
						forecast.errorMessage = '';
					}
				});
				return returnValue;
			}
			return vm.startedEmpty;
		}

		function saveEditDate(ndx, column, clear, showApprovalModal) {
			var columnId = column === 'soCommitDateCopy' ? 'firstPoEcdDate': column;
			var cell = jQuery('#' + columnId + ndx);
			var content, currentDateUtc;
			var newDate = vm.currentDate;
			if (clear) {
				vm.currentDate = '';
				content = '';
			} else {
				if (vm.currentDate === $filter('date')(vm.currentDateUnformatted, 'mediumDate')) {
					vm.currentDate = vm.currentDateUnformatted;
					newDate = vm.currentDateUnformatted;
				}
				vm.currentDate = $filter('date')(vm.currentDate, 'yyyy-MM-dd');
				content = $filter('date')(vm.currentDate, 'mediumDate');
			}
			var row = vm.rowData[ndx];
			var currentContent = $filter('date')(row[column], 'mediumDate');
			var inlineEditDiv = jQuery('.inlineEditDiv');
			if (column !== 'actionDueDate' && column !== 'dueDate') {
				var value = {
					'comment': vm.currentDate
				};
				var ecdNdx;
				if (column === 'firstPoEcdDate') {
					ecdNdx = row.firstPoEcdNdx;
					value.subType = 'ecd';
				} else if (column === 'cmtRspEcdCmt') {
					ecdNdx = row.cmtRspEcdNdx;
					value.subType = 'recd';
				} else if (column === 'cmtEcdCmt') {
					ecdNdx = row.cmtEcdNdx;
					value.subType = 'ecd';
				} else if (column === 'prodOrderCommitDateString') {
					ecdNdx = row.prodOrderCommitDateNdx;
					value.subType = 'prodOrderCommitDate';
				} else if (column === 'prodOrderDropDeadDate') {
					ecdNdx = row.prodOrderDropDeadDateNdx;
					value.subType = 'prodOrderDropDeadDate';
				} else if (column === 'soCommitDateCopy') {
					ecdNdx = row.firstPoEcdNdx;
					value.subType = 'soCommitDateCopy';
				}
				var aMessage = 'Edit Commit Date';
				if (ecdNdx || ecdNdx === 0) value.ndx = ecdNdx;
				if (vm.currentDate || ecdNdx) {
					var settings = globalConfig.user.authFacts[row.leanDirFactoryNdx].settings;
					var rowData = vm.displayedData[ndx];
					var approvalRequired = settings.workbenchCommitDateApproval === '1' || settings.workbenchCommitDateApproval === 'true';
					var erpWriteBackEnabled = globalConfig.user.authFacts[row.leanDirFactoryNdx].isWriteBackOnTimeDateEnabled;
					if ((globalConfig.user.role !== 'Supplier' || (globalConfig.user.role == 'Supplier' && isSupplierPreview)) && erpWriteBackEnabled && approvalRequired && (rowData.leanDocumentType && rowData.leanDocumentType === 'Purchase Order') && showApprovalModal) {
						commitDateApproval(column, value, row, ndx, cell, currentContent);
					} else {
						saveComment(column, value, row, ndx, cell, currentContent);
					}
				}
				inlineEditDiv.unbind();
				inlineEditDiv.remove();
				vm.inlineActive = false;
			} else {
				inlineEditDiv.unbind();
				inlineEditDiv.remove();
				vm.inlineActive = false;
				var selectedDateUtc = moment(new Date(newDate).setHours(18)).subtract(new Date().getTimezoneOffset(), 'minutes');
				procurementTaskService.patchTask(row.leanDirFactoryNdx, row.taskId, {dueDate: {oldValue: row[column], newValue: selectedDateUtc.valueOf() }})
					.then(function(response) {
						if (response && response.status < 400 && response.status !== 304) {
							var updateRowsObject = {};
							updateRowsObject.identifier = {
								taskId: row.taskId
							};
							updateRowsObject.newValues = {};
							updateRowsObject.newValues[column] = selectedDateUtc.valueOf();
							updateRowsObject.newValues.lastActivityTimestamp = parseInt(strip(response.data.lastModifiedDate));
							updateRowsObject.newValues.actionLastUpdateDate = updateRowsObject.newValues.lastActivityTimestamp;
							updateRows(updateRowsObject);
						} else if (response && response.status >= 400) {
							var message = response.data.error || 'Unknown server error.';
							$rootScope.$emit('toast', {
								'message': message,
								'success': false
							});
						}
					});
			}
		}

		function startEditForecast(rowIndex, column) {
			var row = vm.rowData[rowIndex];
			var orderNdx = row.orderNdx || row.forecastFirstDeliveryPoNdx || row.firstPoNdx;

			if (promiseMap[column]) {
				promiseMap[column].cancel();
			}

			promiseMap[column] = supplyOrderForecastService.getForecastForOrder(row.factoryNdx || row.leanDirFactoryNdx, orderNdx);
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			if (vm.oldForcastscope) {
				vm.oldForcastscope.$destroy();
			}
			var forecastScope = $scope.$new();
			vm.oldForcastscope = forecastScope;
			forecastScope.closeAndDestroy = function () {
				vm.cancelEdit();
				if (forecastScope) {
					forecastScope.$destroy();
				}
			};
			forecastScope.saveEditForecast = function (rowIndex) {
				saveEditForecastInner(rowIndex);
				forecastScope.closeAndDestroy();
			};
			var cell = jQuery('#' + column + rowIndex);
			var pos = cell.offset();
			vm.currentForecast = undefined;
			promiseMap[column].promise.then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					vm.currentForecast = response.data;
					var template = getForecastTemplate(pos, rowIndex);
					var compiledDiv = $compile(template)(forecastScope);
					jQuery('.embeddedBody').append(compiledDiv);
					compiledDiv.keyup(function (event) {
						var code = event.keyCode || event.which;
						if (code == 27) {
							forecastScope.closeAndDestroy();
						} else if (code == 13) {
							$timeout(addForecastRow);
						}
					});
					vm.inlineActive = true;
				}
			});
		}

		function startEdit(rowIndex, column, label, fieldInputType, maxLength, controllerName, allowBlank, allowNegativeNumbers) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			vm.currentNumericStatus = null;
			var element = column === 'soStatusCopy' ? 'firstPoStatus': column;
			var row = getRawData()[rowIndex];
			var cell = jQuery('#' + element + rowIndex);
			var pos = cell.offset();
			var content = row[element];
			fieldInputType =  (typeof fieldInputType === 'undefined') ? 'text' : fieldInputType;
			var actionType = row.actionId != undefined ? 'inventoryAction' : '';
			var editTemplate = label !== 'Comment'
				? getTemplate(pos, rowIndex, column, label, fieldInputType, maxLength, allowBlank, controllerName, allowNegativeNumbers)
				: getTaskCommentTemplate(pos, rowIndex, column, actionType);
			vm.currentStatus = fieldInputType === 'numeric' ? + _.unescape(content) : _.unescape(content);
			if (fieldInputType === 'numeric') {
				vm.currentNumericStatus = + _.unescape(content);
			}
			if (column === 'value' && row.valueFunction && row.valueFunction !== 'value') {
				vm.currentStatus = {
					valueA: row.valueA,
					valueB: row.valueB
				};
			}
			if (label === 'Comment') {
				vm.watchersObject = {tempWatchers: []};
				vm.commentChange = {id: row.taskId};
				getEmailSuffix(row.leanDirFactoryNdx);
				loadUserList(row);
				procurementTaskService.getCommentsForAction(vm.displayedData[rowIndex]['taskId'], vm.displayedData[rowIndex]['leanDirFactoryNdx']).promise.then(function(response) {
					vm.currentComments = response.data || [];
				});
			}
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (fieldInputType !== 'textArea' && code == 13) {
					if (label === 'Comment') {
						if (allowBlank === false && (vm.commentChange.comment == null || !vm.commentChange.comment.length)) {
							return;
						}
						vm.saveTaskComment(rowIndex, column);
					} else {
						if (fieldInputType === 'numeric') {
							vm.currentStatus = vm.currentNumericStatus;
						}
						var hasValidInput = true;
						// check for field input value if blank is not allowed and make sure sure has entered a value other wise return
						if (allowBlank === false) {
							if (column === 'value' && row.valueFunction && row.valueFunction !== 'value') {
								if (vm.currentStatus['valueA'] == null || _.isNaN(vm.currentStatus['valueA']) ||
								 vm.currentStatus['valueB'] == null || _.isNaN(vm.currentStatus['valueB']) || vm.currentStatus['valueB'] === 0) {
									hasValidInput = false;
								}
							} else {
								if ((fieldInputType === 'numeric' && (vm.currentStatus == null || _.isNaN(vm.currentStatus))) || !vm.currentStatus ||
								(fieldInputType !== 'numeric' && !vm.currentStatus.length)) {
									hasValidInput = false;
								}
							}
						}

						if (maxLength !== undefined && (fieldInputType === 'text' || fieldInputType === 'textArea') &&
							vm.currentStatus != null && vm.currentStatus.length > maxLength) {
							return;
						}

						if (hasValidInput) {
							vm.saveEdit(rowIndex, column, false, label, controllerName, fieldInputType);
						} else {
							return;
						}
					}
				} else if (code == 27) {
					vm.cancelEdit();
				}
			});
			var selector = '';
			if (column === 'value' && row.valueFunction && row.valueFunction !== 'value') {
				selector = '.inlineEditDiv input.firstFocus';
			} else {
				var selector = '.inlineEditDiv input';
				if (fieldInputType === 'textArea') {
					selector = '.inlineEditDiv textarea';
				}
			}
			//use timeout to do the text selection after the text added to the input.
			$timeout(function () {
				jQuery(selector).trigger('select');
			});

			vm.inlineActive = true;
		}

		function startEditCheckbox(rowIndex, column) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var row = getRawData()[rowIndex];
			var content = row[column];
			var cell = jQuery('#' + column + rowIndex);
			var pos = cell.offset();
			var checked = content ? content.length > 0 : false;
			var editTemplate = getCheckboxTemplate(pos, rowIndex, checked, column);
			vm.currentStatus = checked;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					$scope.saveEdit(rowIndex);
				} else if (code == 27) {
					$scope.cancelEdit();
				}
			});
			vm.inlineActive = true;
		};

		function getTemplate(position, ndx, column, label, fieldInputType, maxLength, allowBlank, controllerName, allowNegativeNumbers) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			var divHeight = 112;
			var extraClass = ' textEdit';
			var containerWidth = '';
			var row = getRawData()[ndx];
			if (fieldInputType === 'textArea') {
				divHeight = 348;
				extraClass = ' textAreaEdit description-area';
			}
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + divHeight > windowHeight) {
				position.top = position.top - (position.top + divHeight - windowHeight - 8);
			}
			if (fieldInputType === 'textArea') {
				if (position.left + 840 > windowWidth) {
					containerWidth = windowWidth - position.left - 50;
					containerWidth = 'width:' + containerWidth + 'px;';
				}
			}
			var header = label.indexOf('Edit') === 0 ? label : 'Add ' + label;
			var scopeModal = fieldInputType === 'numeric' ? 'vm.currentNumericStatus' : 'vm.currentStatus';
			var inputClass = (fieldInputType === 'numeric' || fieldInputType === 'textArea') ? 'inlineEditInput' : 'inlineEditInput with-clear';
			var disabledHTML = allowBlank === false ? 'ng-disabled="!' + scopeModal + '.length" ' : '';
			if (fieldInputType === 'numeric' && allowBlank === false) {
				disabledHTML = 'ng-disabled="!' + scopeModal + ' && ' + scopeModal + ' !== 0" ';
			}
			var input = fieldInputType === 'textArea'
				? '<textarea autofocus="true" class="' + inputClass + '" ng-model="' + scopeModal + '"></textarea>'
				: '<input class="' + inputClass + '" autofocus="true" ng-model="' + scopeModal + '"' +
			(fieldInputType === 'numeric' ? ' type="number" ' + (!allowNegativeNumbers ? 'min="0" ng-min="0"' : '') : '') + ' />';
			var isMetricValueRatio = column === 'value' && row.valueFunction && row.valueFunction !== 'value';
			if (isMetricValueRatio) {
				disabledHTML = 'ng-disabled="(!vm.currentStatus.valueA || ' +
				'!vm.currentStatus.valueB || vm.currentStatus.valueB === 0)" ';
				input = '<input class="inlineEditInput firstFocus" type="number" ng-model="' + scopeModal + '.valueA" style="width:47%;" />' +
				' / <input class="inlineEditInput" type="number" ng-model="' + scopeModal + '.valueB" style="width:47%;"/>';
			}
			var editTemplate = '<div class="inlineEditDiv' + extraClass + '" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;' + containerWidth + '"><div class="inlineEditHeader" translate>' + header + '</div>' +
				'<div class="input-holder-with-clear">' + input +
						(typeof maxLength !== 'undefined'
							? '<span class="error-desc" ng-if="' + scopeModal + '.length>' + maxLength + '">Max allowed characters are ' + maxLength + '.</span>'
							: '');
			if (fieldInputType !== 'textArea' && fieldInputType !== 'numeric') {
				editTemplate += '<span class="input-clear" ng-show="vm.currentStatus && vm.currentStatus.length" ng-click="vm.currentStatus = \'\'"><i class="fa fa-times"></i></span>';
			}

			editTemplate += '</div>' +
				'<div class="inlineEditButtons"><button class="button flat" ng-click="vm.cancelEdit()" translate>Cancel</button>' +
				'<button class="button flat colored" ' + disabledHTML +
				'ng-click="' + (typeof maxLength !== 'undefined' ? '!(' + scopeModal + '.length>' + maxLength + ') && ' : '');
			var controllerNameHTML = controllerName ? "'" + controllerName + "'" : 'undefined';
			editTemplate += ' vm.saveEdit(' + ndx + ', ' + '\'' + column + '\'' + ', undefined, ' + '\'' + label + '\'' + ', ' + controllerNameHTML + ', ' + (fieldInputType? "'" + fieldInputType + "'": undefined) + ')" translate>Save</button></div></div>';

			return editTemplate;
		}

		function getTaskCommentTemplate(position, ndx, column, actionType) {
			ensurePopupInBound(position, 420, 112);
			var model = 'vm.commentChange.comment';
			var disabledHTML = 'ng-disabled="!' + model + '.length" ';
			var editTemplate = '<div class="inlineEditDiv textEdit" style="height: auto; width: 420px; top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">Add Comment</div>' +
				'<div class="input-holder-with-clear">' +
				'<input autofocus="true" class="inlineEditInput with-clear" ng-model="' + model + '"' +
				'uib-typeahead="user as user.userDisplay for user in vm.getUsersForTagging($viewValue, vm.watchersObject, vm.inlineLists.responsible)"' +
				'typeahead-input-formatter="vm.formatTagResult($model, vm.commentChange, vm.watchersObject, false, \'reason\')"/>' +
				'<div class="no-tag-results" ng-if="vm.watchersObject.displayNoUsersFound">No Users Found.</div>' +
				'<span class="input-clear" ng-show="vm.commentChange.comment && vm.commentChange.comment.length" ng-click="vm.commentChange.comment = \'\'"><i class="fa fa-times"></i></span>' +
				'</div>' +
				'<div class="inlineEditButtons"><button class="button flat" ng-click="vm.cancelEdit()">Cancel</button>' +
				'<button data-testid="' + (actionType != '' ? actionType + '-' : '') + 'comment-save-btn" class="button flat colored" ' + disabledHTML +
				'ng-click="';
			editTemplate += '(' + model + ' && ' + model + '.length>0) && ';
			editTemplate += ' vm.saveTaskComment(' + ndx + ', ' + '\'' + column + '\'' + ')">Save</button></div>';
			editTemplate += '<div class="task-comments comments fixed-size">' +
			'<div class="task-comment" ng-repeat="comment in vm.currentComments">' +
			'<relative-datetime class="task-comment-time inside-tooltip" style="color: #757575" time="comment.creationUtcTime"></relative-datetime>' +
			'<div class="task-comment-body">' +
			'<span class="task-comment-author">{{comment.firstName}} {{comment.lastName}}: </span>' +
			'<span class="task-comment-text" ng-bind-html="comment.comment | lineBreaks"></span>' +
			'</div></div>' +
			'</div></div>';
			return editTemplate;
		}

		function getCheckboxTemplate(position, rowIndex, checked, column) {
			ensurePopupInBound(position, 296, 112);
			var checkboxName;
			if (column === 'conditions') checkboxName = 'condition'; // set conditionally so we can re-use checkbox template;
			var checkboxNameCapitalized = checkboxName.slice(0,1).toUpperCase() + checkboxName.slice(1);
			var saveFunction = 'saveEdit';
			if (column === 'conditions') saveFunction = 'saveEditConditions'; // set conditionally so we can re-use checkbox template;
			var label;
			if (column === 'conditions') { // set conditionally so we can re-use checkbox template;
				var row = getRawData()[rowIndex];
				if (row.userNdx) {
					label = 'Only show parts for this buyer';
				} else {
					label = 'Only show parts for each buyer';
				}
			}
			var editTemplate = '<div class="inlineEditDiv checkboxEdit" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">Add ' + checkboxNameCapitalized + '</div>' +
				'<form>' +
				'<input id="' + checkboxName + '" name="' + checkboxName + '" class="with-font" ng-model="vm.currentStatus" type="checkbox">' +
				'<label style="padding-left: 0px; font-weight: normal" class="control-label checkboxLabel" for="' + checkboxName + '">' + label  + '</label>' +
				'</form>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="vm.cancelEdit()">Cancel</button>' +
				'<button class="button flat colored" ng-click="vm.' + saveFunction + '(' + rowIndex + ',\'' + column + '\')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function saveEditConditions(rowIndex, column) {
			var checked = vm.currentStatus;
			var row = getRawData()[rowIndex];
			if (checked) {
				row.conditions = 'buyerFilter';
			} else {
				row.conditions = '';
			}
			var alertType = leanFilterService.getSelectedIds('alert')[0];
			var handleResponse = function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					$rootScope.$emit('toast', {
						'message': 'Condition has been saved successfully',
						'success': true
					});
					$scope.$broadcast('reloadTable');
				} else {
					$rootScope.$emit('toast', {
						'message': 'Unexpected server error',
						'success': false
					});
					$scope.$broadcast('reloadTable');
				}
			};
			var siteId = storeService.getState().adminConfig.factory.id;
			if (row.userNdx) {
				manageEmailAlertsService.updateSubscriptionForUser(false, alertType, row.userNdx, row.conditions, siteId)
				.then(handleResponse);
			} else {
				manageEmailAlertsService.updateSubscriptionForRole(alertType, row.role, row.conditions, siteId)
				.then(handleResponse);
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			$scope.inlineActive = false;
		};

		function saveEdit(ndx, type, clear, label, controllerName, fieldInputType) {
			var element = type === 'soStatusCopy' ? 'firstPoStatus': type;
			if (clear) {
				vm.currentStatus = '';
				vm.currentNumericStatus = '';
				vm.issueNdx = '';
				vm.poStatusCategoryNdx = '';
			}
			if (fieldInputType && fieldInputType === 'numeric') {
				vm.currentStatus = vm.currentNumericStatus;
			}
			var cell = jQuery('#' + element + ndx);
			var currentContent = cell.children('.inline-edit-cell').children('.edit-name-text').html();
			var content;
			var row = getRawData()[ndx];
			if (controllerName === 'viewMetricData') {
				content = strip(vm.currentStatus);
				$scope.$parent.tableCtrl.saveMetricComment(row, content);
			} else if (controllerName === 'projectArea') {
				content = strip(vm.currentStatus);
				$scope.$parent.tableCtrl.saveProjectArea(row, content, type);
			} else if (label && label === 'Edit Parameter Name') {
				content = strip(vm.currentStatus);
				saveReportCardParameterData(type, ndx, content);
			} else if (label === 'Edit Supply Order Status Category') {
				if (!vm.groupBy) {
					row = vm.displayedData[ndx];
				} else {
					var rawData = getRawData();
					row = rawData[ndx];
				}
				content = strip(vm.currentStatus);
				savePoStatusCategory(type, row, ndx, cell, currentContent, content);
			} else if (label === 'Edit Customer Order Status Category') {
				if (!vm.groupBy) {
					row = vm.displayedData[ndx];
				} else {
					var rawData = getRawData();
					row = rawData[ndx];
				}
				content = strip(vm.currentStatus);
				saveCustomerOrderStatusCategory(type, row, ndx, cell, currentContent, content);
			} else if (controllerName !== 'flexFieldConfigCtrl' && (type === 'category' || type === 'description' || type === 'liability' || type === 'deliveryStatus')) {
				if (!vm.groupBy) {
					row = vm.displayedData[ndx];
				} else {
					var rawData = getRawData();
					row = rawData[ndx];
				}
				if (type === 'liability') {
					content = strip(vm.currentStatus.name);
				} else if (type === 'deliveryStatus') {
					content = strip(vm.currentStatus.value);
				} else {
					content = strip(vm.currentStatus);
				}
				saveLateDeliveryIssueData(type, row, ndx, cell, currentContent, content);
			} else if (type === 'rating' || type === 'comments') {
				if (!vm.groupBy) {
					row = vm.displayedData[ndx];
				} else {
					var rawData = getRawData();
					row = rawData[ndx];
				}
				if (type === 'rating') {
					content = strip(vm.scoreId);
				} else {
					content = strip(vm.currentStatus);
				}
				saveAssessmentData(type, row, content);
			} else if (type === 'responsibleName' || type === 'actionOwner' || type === 'iaTaskOwner') {
				row = vm.displayedData[ndx];
				var column = getColumn(type);
				procurementTaskService.patchTask(row.leanDirFactoryNdx, row.taskId, {responsible: {oldValue: row[column.idField], newValue: vm.currentUser.ndx}})
					.then(function(response) {
						if (response && response.status < 400 && response.status !== 304) {
							var updateRowsObject = {};
							updateRowsObject.identifier = {
								taskId: row.taskId
							};
							updateRowsObject.newValues = {};
							updateRowsObject.newValues[column.id] = vm.currentUser.updateDisplay;
							updateRowsObject.newValues[column.idField] = vm.currentUser.ndx;
							updateRowsObject.newValues.lastActivityTimestamp = parseInt(strip(response.data.lastModifiedDate));
							updateRowsObject.newValues.actionLastUpdateDate = updateRowsObject.newValues.lastActivityTimestamp;
							updateRows(updateRowsObject);
						} else if (response && response.status >= 400) {
							var message = response.data.error || 'Unknown server error.';
							$rootScope.$emit('toast', {
								'message': message,
								'success': false
							});
						}
					});
			} else if (type === 'actionCategory') {
				row = vm.displayedData[ndx];
				var column = getColumn(type);
				var existingCategory = procurementTaskService.findExistingCategory(vm.inlineLists.category, vm.currentCategory);
				if (existingCategory) {
					vm.currentCategory.id = existingCategory.id;
					updateTaskCategory(row, column);
				} else {
					var newCategory = {};
					newCategory.name = strip(vm.currentCategory.name);
					procurementTaskService.addCategory(newCategory, row.leanDirFactoryNdx)
						.then(function(data) {
							if (!data || !data.val || data.val === -1) {
								$rootScope.$emit('toast', {
									'message': 'Task Category was not created, please try again',
									'success': false
								});
								return;
							}
							vm.currentCategory.id = data.val;
							updateTaskCategory(row, column);
						});
				}
			} else if (type === 'actionStatus' || type === 'status') {
				saveTaskStatus(ndx, type);
			} else if (type === 'actualSavings') {
				saveInventoryActionValidSavings(ndx, vm.hasValidSavings,
					vm.invalidComment);
			} else if (controllerName === 'projectCategories') {
				content = strip(vm.currentStatus);
				if (content) {
					row[type] = content;
					$scope.$parent.tableCtrl.saveProjectCategory(row);
				}
			} else if (type === 'personName' || type === 'activated' || type === 'name') {
				content = type === 'name' ? strip(vm.currentStatus) : strip(vm.currentStatus.name);
				saveValueStreamData(type, ndx, content);
			} else if (type === 'value') {
				var row = vm.displayedData[ndx];
				if (row.valueFunction === 'value') {
					content = strip(vm.currentStatus);
				} else {
					content = {
						valueA: strip(vm.currentStatus.valueA),
						valueB: strip(vm.currentStatus.valueB)
					};
				}
				saveMetricValues(ndx, type, content);
			} else if (controllerName === 'flexFieldConfigCtrl') {
				row = vm.displayedData[ndx];
				content = vm.currentStatus;
				$scope.$parent.tableCtrl.saveFlexField(row.id, row.columnName, type, content, row.lastModified);
			} else {
				var aMessage = '';
				var statusNdx;
				var value = {};
				if (type === 'firstPoStatus') {
					statusNdx = row.firstPoStatusNdx;
					value.subType = 'status';
					aMessage = 'Edit Status';
					content = vm.currentStatus;
				} else if (type === 'firstPoTrackingNumber') {
					statusNdx = row.firstPoTrackingNumberNdx;
					value.subType = 'trackingNumber';
					aMessage = 'Edit Tracking Number';
					content = vm.currentStatus;
				} else if (type === 'cmtStsCmt') {
					statusNdx = row.cmtStsNdx;
					value.subType = 'status';
					aMessage = 'Edit Status';
					content = vm.currentStatus;
				} else if (type === 'cmtOpsCmt') {
					statusNdx = row.cmtOpsNdx;
					value.subType = 'operations';
					aMessage = 'Edit Operations Comment';
					content = vm.currentStatus;
				} else if (type === 'cmtColorCmt') {
					statusNdx = row.cmtColorNdx;
					value.subType = 'color';
					aMessage = 'Edit Color';
					content = vm.currentStatus ? vm.currentStatus.name : '';
				} else if (type === 'cmtRspCmt') {
					statusNdx = row.cmtRspNdx;
					value.subType = 'responsible';
					aMessage = 'Edit Responsible';
					content = vm.currentStatus ? vm.currentStatus.resVal : '';
				} else if (type === 'lateDeliveryDescription') {
					statusNdx = row.lateDeliveryIssueCommentNdx;
					value.subType = 'lateDeliveryIssue';
					aMessage = 'Edit Supplier Delivery Cause';
					content = vm.issueNdx;
				} else if (type === 'poStatusCategory' || type === 'poStatusCategoryDescription') {
					statusNdx = row.poStatusCategoryCommentNdx;
					value.subType = 'poStatusCategory';
					aMessage = 'Edit Supply Order Status Category';
					content = vm.poStatusCategoryNdx;
				} else if (type === 'prodOrderPriority') {
					statusNdx = row.prodOrderPriorityNdx;
					value.subType = 'prodOrderPriority';
					aMessage = 'Edit Priority';
					content = vm.currentStatus ? vm.currentStatus.name : 'LEANDNA_NONE';
				} else if (type === 'prodOrderOperationsComment') {
					statusNdx = row.prodOrderOperationsCommentNdx;
					value.subType = 'prodOrderOperationsComment';
					aMessage = 'Edit Operations Comment';
					content = vm.currentStatus;
				} else if (type === 'prodOrderStatus') {
					statusNdx = row.prodOrderStatusNdx;
					value.subType = 'prodOrderStatus';
					aMessage = 'Edit Status';
					content = vm.currentStatus;
				} else if (type === 'soStatusCopy') {
					statusNdx = row.firstPoStatusNdx;
					value.subType = 'soStatusCopy';
					aMessage = 'Edit Status';
					content = vm.currentStatus;
				}
				value.comment = content;
				if (statusNdx || statusNdx === 0) value.ndx = statusNdx;

				if ((statusNdx || statusNdx === 0) || content) {
					saveComment(type, value, row, ndx, cell, currentContent);
				}
			}

			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		}

		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.currentComments = [];
			vm.inlineActive = false;

			if ($scope.$$childTail.$selectMultiple) {
				// destroy multiselects if exists
				delete $scope.$$childTail.$select;
				delete $scope.$$childTail.$selectMultiple;
			}
		}

		function updateTaskCategory(row, column) {
			procurementTaskService.patchTask(row.leanDirFactoryNdx, row.taskId, {category: {oldValue: row[column.idField], newValue: vm.currentCategory.id}})
				.then(function(response) {
					if (response && response.status < 400 && response.status !== 304) {
						var updateRowsObject = {};
						updateRowsObject.identifier = {
							taskId: row.taskId
						};
						updateRowsObject.newValues = {};
						updateRowsObject.newValues[column.id] = vm.currentCategory.name;
						updateRowsObject.newValues[column.idField] = vm.currentCategory.id;
						updateRowsObject.newValues['isActiveCategory'] = vm.currentCategory.active;
						updateRowsObject.newValues.lastActivityTimestamp = parseInt(strip(response.data.lastModifiedDate));
						updateRowsObject.newValues.actionLastUpdateDate = updateRowsObject.newValues.lastActivityTimestamp;
						updateRows(updateRowsObject);
					} else if (response && response.status >= 400) {
						var message = response.data.error || 'Unknown server error.';
						$rootScope.$emit('toast', {
							'message': message,
							'success': false
						});
					}
				});
		}

		function saveTaskStatus(ndx, type) {
			var updateResponsible = false;
			var row = vm.displayedData[ndx];
			var column = getColumn(type);
			var idField = type === 'status' ? 'iaStatusNdx' : 'actionStatusNdx';
			var saveObject = {
				status: {
					oldValue: row[idField],
					newValue: vm.currentStatus.id
				}
			};
			if (vm.currentStatus.name === 'Review Later') {
				var selectedDateUtc = moment(new Date(vm.currentReviewLaterDate).setHours(18)).subtract(new Date().getTimezoneOffset(), 'minutes');
				saveObject.reviewLaterDate = {
					oldValue: row.actionReviewLaterExpireDate,
					newValue: selectedDateUtc.valueOf()
				};
			} else if (type === 'status' && vm.currentStatus.name === 'Unable to Fix') {
				if (vm.selected.unableToFixCategory) {
					if (vm.selected.unableToFixCategory.action === 'Reassign') {
						saveObject.responsible = {
							newValue: vm.currentResponsibleTemp.ndx,
							oldValue: row.iaTaskOwnerNdx // Currently only inventory action report can call this, so we can use the correct field
						};
						vm.currentStatus = _.find(vm.inlineLists.status, {name: 'Open'});
						saveObject.status.newValue = vm.currentStatus.id;
						var text = globalConfig.user.firstName + ' ' + globalConfig.user.lastName + ' has categorized this '
						+ 'a "' + vm.selected.unableToFixCategory.categoryName + '" issue and assigned the task to '
						+ vm.currentResponsibleTemp.firstName + ' ' + vm.currentResponsibleTemp.lastName + '.';
						addCommentToTask(row.leanDirFactoryNdx, row.taskId, text, false, true, vm.currentResponsibleTemp.ndx, vm.selected.unableToFixCategory.ndx);
						updateResponsible = true;
					} else {
						var reasonComment = generateUnableToFixComment();
						var promiseList = addWatchersIfAny(row.taskId, reasonComment, row.leanDirFactoryNdx);
						$q.all(promiseList).then(function() {
							addCommentToTask(row.leanDirFactoryNdx, row.taskId, reasonComment, true);
							if (vm.selected.unableToFixCategory && vm.selected.unableToFixCategory.categoryName) {
								procurementTaskService.updateInventoryActionUnableToFixCategory(row.leanDirFactoryNdx, row.actionId, vm.selected.unableToFixCategory.ndx)
									.then(function(response) {
										var updateRowsObject = {};
										updateRowsObject.identifier = {
											taskId: row.taskId
										};
										updateRowsObject.newValues = {};
										updateRowsObject.newValues.unableToFixCategoryName = vm.selected.unableToFixCategory.categoryName;
										updateRowsObject.newValues.unableToFixComment = reasonComment;
										updateRowsObject.newValues.dateCompleted = new Date();
										vm.selected.unableToFixCategory = undefined;
										updateRows(updateRowsObject);
									});
							}
						});
						clearTaggingVariables(row.taskId);
					}
				}
			}
			procurementTaskService.patchTask(row.leanDirFactoryNdx, row.taskId, saveObject)
				.then(function(response) {
					if (response && response.status < 400 && response.status !== 304) {
						var updateRowsObject = {};
						updateRowsObject.identifier = {
							taskId: row.taskId
						};
						updateRowsObject.newValues = {};
						updateRowsObject.newValues[column.id] = vm.currentStatus.name;
						updateRowsObject.newValues[idField] = vm.currentStatus.id;
						updateRowsObject.newValues.lastActivityTimestamp = parseInt(strip(response.data.lastModifiedDate));
						updateRowsObject.newValues.actionLastUpdateDate = updateRowsObject.newValues.lastActivityTimestamp;
						if (vm.currentStatus.name === 'Review Later') {
							updateRowsObject.newValues.actionReviewLaterExpireDate = selectedDateUtc.valueOf();
						}
						if (updateResponsible) {
							updateRowsObject.newValues.iaTaskOwnerNdx = vm.currentResponsibleTemp.ndx;
							updateRowsObject.newValues.iaTaskOwner = vm.currentResponsibleTemp.firstName + ' ' + vm.currentResponsibleTemp.lastName;
							updateRowsObject.newValues.isReassign = true;
						}
						if (vm.currentStatus.name === 'Open') {
							updateRowsObject.newValues.unableToFixComment = '';
							updateRowsObject.newValues.dateCompleted = undefined;
							updateRowsObject.newValues.actionReviewLaterExpireDate = undefined;
							updateRowsObject.newValues.unableToFixCategoryName = '';
						}
						updateRows(updateRowsObject);
					} else if (response && response.status >= 400) {
						var responseError = response.data && response.data.error;
						var message = response.status === 409 && responseError === 'conflictingActiveAction'
							? $translate.instant('Cannot reopen because a different inventory action is already open for this item.')
							: responseError || 'Unknown server error.';
						$rootScope.$emit('toast', {
							'message': message,
							'success': false
						});
					}
				});
		}

		function saveTaskComment(rowIndex) {
			var row = vm.displayedData[rowIndex];
			var promiseList = addWatchersIfAny(row.taskId, vm.commentChange.comment, row.leanDirFactoryNdx);
			$q.all(promiseList).then(function() {
				addCommentToTask(row.leanDirFactoryNdx, row.taskId, vm.commentChange.comment).then(function() {
					var updateRowsObject = {};
					updateRowsObject.identifier = {
						taskId: row.taskId
					};
					updateRowsObject.newValues = {};
					updateRowsObject.newValues.actionLastUpdateDate = moment();
					updateRowsObject.newValues.lastActivityTimestamp = moment().valueOf();
					updateRowsObject.newValues.lastComment = vm.commentChange.comment;
					updateRowsObject.newValues.lastCommentDate = moment().valueOf();
					updateRowsObject.newValues.lastCommenter = globalConfig.user.firstName + ' ' + globalConfig.user.lastName;
					updateRows(updateRowsObject);
				});
			});
			clearTaggingVariables(row.taskId);
			cancelEdit();
		}

		function saveInventoryActionValidSavings(rowIndex, hasValidSavings, invalidComment) {
			var row = vm.displayedData[rowIndex];
			if (hasValidSavings) {
				invalidComment = null;
			}

			inventoryActionsService.saveInventoryActionValidSavings(row.leanDirFactoryNdx,
				row.actionId, hasValidSavings, invalidComment)
			.then(function() {
				var updateRowsObject = {};
				updateRowsObject.identifier = {
					taskId: row.taskId
				};

				if (row.hasValidSavings !== hasValidSavings) {
					$rootScope.$broadcast('updateHeaders', {
						hasValidSavings: hasValidSavings,
						actualSavings: row.actualSavings
					});
				}

				updateRowsObject.newValues = {};
				updateRowsObject.newValues.hasValidSavings = hasValidSavings;
				updateRowsObject.newValues.invalidSavingsComment = invalidComment;
				updateRows(updateRowsObject);
			});
			cancelEdit();
		}

		function generateUnableToFixComment() {
			var comment = 'Unable to Fix';
			if (vm.selected.unableToFixCategory
				&& vm.selected.unableToFixCategory.categoryName
				&& vm.selected.unableToFixCategory.categoryName !== 'Other...') {
				comment += ': ' + vm.selected.unableToFixCategory.categoryName;
			}
			if (vm.statusChange.reason && vm.statusChange.reason.length) {
				comment += ': ' + vm.statusChange.reason;
			}
			return comment;
		}

		function addCommentToTask(factoryNdx, taskId, text, unableToFixFlag, systemGenerated, assignToPlannerNdx, unableToFixCategoryNdx) {
			var comment = {
				comment: text,
				creationUtcTime: new Date().getTime().toString(),
				actionNdx: taskId,
				isUnableToFixCommentFlag: !!unableToFixFlag,
				systemGenerated: systemGenerated,
				assignToPlannerNdx: assignToPlannerNdx,
				unableToFixCategoryNdx: unableToFixCategoryNdx
			};
			return procurementTaskService.addComment(comment, factoryNdx);
		}

		function copy(rowIndex, type) {
			var content = vm.displayedData[rowIndex][type];
			if (type === 'cmtRspEcdCmt' || type === 'cmtEcdCmt') {
				commentClipboard.content = content ? $filter('date')(content, 'yyyy-MM-dd') : '';
				commentClipboard.type = 'date';
			} else {
				commentClipboard.content = content ? content : '';
				commentClipboard.type = 'string';
			}
		}

		function paste(ndx, type, controllerName) {
			if (commentClipboard.content == undefined) {
				$rootScope.$emit('toast', {
					'message': 'Nothing to paste.  Use <i class="fa fa-copy"></i> to copy.',
					'success': false
				});
				return;
			} else if (commentClipboard.type != 'date' && (type === 'cmtRspEcdCmt' || type === 'cmtEcdCmt')) {
				$rootScope.$emit('toast', {
					'message': 'Please copy from a date field first.',
					'success': false
				});
				return;
			}
			var cell = jQuery('#' + type + ndx);
			var currentContent = cell.children('.inline-edit-cell').children('.edit-name-text').html();
			var row = vm.rowData[ndx];
			if (controllerName === 'viewMetricData') {
				$scope.$parent.tableCtrl.saveMetricComment(row, commentClipboard.content);
				return;
			}
			var value = {
				'comment': commentClipboard.content
			};
			var subType, commentNdx;
			switch (type) {
			case 'cmtStsCmt':
				commentNdx = row.cmtStsNdx;
				value.subType = 'status';
				break;
			case 'cmtOpsCmt':
				commentNdx = row.cmtOpsNdx;
				value.subType = 'operations';
				break;
			case 'cmtRspCmt':
				commentNdx = row.cmtRspNdx;
				value.subType = 'responsible';
				break;
			case 'cmtRspEcdCmt':
				commentNdx = row.cmtRspEcdNdx;
				value.subType = 'recd';
				break;
			case 'cmtEcdCmt':
				commentNdx = row.cmtEcdNdx;
				value.subType = 'ecd';
				break;
			}
			if (commentNdx || commentNdx === 0) value.ndx = commentNdx;
			if ((commentClipboard.content && commentClipboard.content.length) || (commentNdx || commentNdx === 0)) {
				saveComment(type, value, row, ndx, cell, currentContent);
			}
		}

		function saveComment(type, value, row, ndx, cell, currentContent, writeFirmDate) {
			var htmlText = '';
			if (['firstPoEcdDate', 'firstPoStatus', 'firstPoTrackingNumber', 'lateDeliveryDescription', 'poStatusCategoryDescription'].indexOf(type) !== -1) {
				value.orderNdx = row.orderNdx;
				value.currentValue = row[type];
				value.poNumber = row.firstPurchaseOrderNumber || row.purchaseOrderNumber || row.orderNumber;
				value.poLine = row.firstPurchaseOrderLine || row.orderLine || row.purchaseOrderLine;
				value.scheduleLine = row.firstPurchaseOrderScheduleLine || row.scheduleLine;
				value.leanDirFactoryNdx = row.leanDirFactoryNdx;
				value.itemNdx = row.itemNdx;
				value.writeFirmDate = writeFirmDate;
				var unstrippedComment = value.comment;
				value.comment = strip(value.comment);
				if (row[type] === value.comment) {
					return;
				}
				commentsService.saveComment(row.leanDirFactoryNdx, 'poComment', value)
					.then(function (data) {
						if (data && data.ndx) {
							if (data && data.error) {
								$rootScope.$emit('toast', {
									'message': data.error,
									'success': false
								});
								cell.children('.inline-edit-cell').html(currentContent);
							} else {
								var updateRowsObject = {};
								updateRowsObject.identifier = {
									itemNdx: row.itemNdx,
									leanDirFactoryNdx: row.leanDirFactoryNdx
								};
								if (row.firstPurchaseOrderLine) {
									updateRowsObject.identifier.firstPurchaseOrderNumber = row.firstPurchaseOrderNumber;
									updateRowsObject.identifier.firstPurchaseOrderLine = row.firstPurchaseOrderLine;
									updateRowsObject.identifier.firstPurchaseOrderScheduleLine = row.firstPurchaseOrderScheduleLine;
								} else if (row.orderLine) {
									updateRowsObject.identifier.orderNumber = row.orderNumber;
									updateRowsObject.identifier.orderLine = row.orderLine;
									updateRowsObject.identifier.scheduleLine = row.scheduleLine;
								} else if (row.purchaseOrderLine) {
									updateRowsObject.identifier.purchaseOrderNumber = row.purchaseOrderNumber;
									updateRowsObject.identifier.purchaseOrderLine = row.purchaseOrderLine;
									updateRowsObject.identifier.scheduleLine = row.scheduleLine;
								}
								updateRowsObject.newValues = {
									confirmationStatusUsed: data.confirmationStatusUsed,
									firstPurchaseOrderDateStatus: data.deliveryDateStatus
								};
								switch (type) {
								case 'firstPoStatus':
									updateRowsObject.newValues.firstPoStatusNdx = data.ndx;
									updateRowsObject.newValues.firstPoStatus = unstrippedComment;
									updateRowsObject.newValues.firstPoStatusLastModified = data.lastModified;
									htmlText = value.comment;
									break;
								case 'firstPoTrackingNumber':
									updateRowsObject.newValues.firstPoTrackingNumberNdx = data.ndx;
									updateRowsObject.newValues.firstPoTrackingNumber = unstrippedComment;
									htmlText = value.comment;
									break;
								case 'lateDeliveryDescription':
									updateRowsObject.newValues.lateDeliveryIssueCommentNdx = data.ndx;
									updateRowsObject.newValues.lateDeliveryIssueNdx = parseInt(unstrippedComment);
									var result = _.find(vm.inlineLists.lateDeliveryIssues, { 'ndx': parseInt(unstrippedComment)});
									if (result) {
										updateRowsObject.newValues.lateDeliveryDescription = result.description;
										updateRowsObject.newValues.lateDeliveryCategory = result.category;
										updateRowsObject.newValues.lateDeliveryLiability = result.liability;
										htmlText = result.description;
									} else if (!unstrippedComment) {
										updateRowsObject.newValues.lateDeliveryDescription = '';
										updateRowsObject.newValues.lateDeliveryCategory = '';
										updateRowsObject.newValues.lateDeliveryLiability = '';
										htmlText = '';
									}
									break;
								case 'poStatusCategoryDescription':
									updateRowsObject.newValues.poStatusCategoryCommentNdx = data.ndx;
									updateRowsObject.newValues.poStatusCategoryNdx = parseInt(unstrippedComment);
									var result = _.find(vm.inlineLists.poStatusCategories, { 'ndx': parseInt(unstrippedComment)});
									if (result) {
										updateRowsObject.newValues.poStatusCategoryDescription = result.description;
										htmlText = result.description;
									} else if (!unstrippedComment) {
										updateRowsObject.newValues.poStatusCategoryDescription = '';
										htmlText = '';
									}
									break;
								case 'firstPoEcdDate':
									updateRowsObject.newValues.firstPoEcdNdx = data.ndx;
									updateRowsObject.newValues.firstPoEcdLastModified = data.lastModified;
									if (value.comment && value.comment.toString().length) {
										value.comment = $filter('date')(value.comment, 'yyyy-MM-dd');
									}
									updateRowsObject.newValues.firstPoEcd = value.comment;
									updateRowsObject.newValues.firstPoEcdDate = value.comment;
									htmlText = value.comment ? $filter('date')(value.comment, 'mediumDate') : '';
									if (overdueDate(value.comment)) {
										cell.children('.inline-edit-cell').addClass('red');
									} else {
										cell.children('.inline-edit-cell').removeClass('red');
									}
								}
								cell.children('.inline-edit-cell').children('.edit-name-text').html(htmlText);
								cell.children('.inline-edit-cell').children('.edit-name-text').attr('title', htmlText);
								updateRows(updateRowsObject);
							}
						} else if (data && data.data && data.data.error) {
							$rootScope.$emit('toast', {
								'message': data.data.error,
								'success': false
							});
						}
					});
			} else if (['prodOrderPriority', 'prodOrderOperationsComment', 'prodOrderStatus', 'prodOrderCommitDateString', 'prodOrderDropDeadDate', 'soStatusCopy', 'soCommitDateCopy'].indexOf(type) > -1) {
				value.productionOrder = row.productionOrder;
				value.operationsNumber = row.operationsNumber;
				value.leanDirFactoryNdx = row.leanDirFactoryNdx;
				value.itemNdx = row.itemNdx;
				var unstrippedComment = value.comment;
				value.comment = strip(value.comment);
				if (row[type] === value.comment ||
					(type === 'prodOrderDropDeadDate' && $filter('date')(row[type], 'yyyy-MM-dd') === value.comment) ||
					(type === 'soStatusCopy' && row['firstPoStatus'] === value.comment) ||
					(type === 'soCommitDateCopy' && $filter('date')(row['firstPoEcdDate'], 'yyyy-MM-dd') === value.comment)) {
					return;
				}
				commentsService.saveComment(row.leanDirFactoryNdx, 'productionOrderComment', value)
					.then(function (data) {
						if (data && data.ndx) {
							if (data && data.error) {
								$rootScope.$emit('toast', {
									'message': data.error,
									'success': false
								});
								cell.children('.inline-edit-cell').html(currentContent);
							} else {
								var updateRowsObject = {};
								updateRowsObject.identifier = {
									itemNdx: row.itemNdx,
									leanDirFactoryNdx: row.leanDirFactoryNdx,
									productionOrder: row.productionOrder,
									operationsNumber: row.operationsNumber
								};
								updateRowsObject.newValues = {};
								switch (type) {
								case 'prodOrderPriority':
									updateRowsObject.newValues.prodOrderPriorityNdx = data.ndx;
									updateRowsObject.newValues.prodOrderPriority = unstrippedComment;
									htmlText = value.comment;
									break;
								case 'prodOrderOperationsComment':
									updateRowsObject.newValues.prodOrderOperationsCommentNdx = data.ndx;
									updateRowsObject.newValues.prodOrderOperationsComment = unstrippedComment;
									htmlText = value.comment;
									break;
								case 'prodOrderStatus':
									updateRowsObject.newValues.prodOrderStatusNdx = data.ndx;
									updateRowsObject.newValues.prodOrderStatus = unstrippedComment;
									htmlText = value.comment;
									break;
								case 'prodOrderCommitDateString':
									updateRowsObject.newValues.prodOrderCommitDateLastModified = data.lastModified;
									updateRowsObject.newValues.prodOrderCommitDateNdx = data.ndx;
									if (value.comment && value.comment.toString().length) {
										value.comment = $filter('date')(value.comment, 'yyyy-MM-dd');
									}
									updateRowsObject.newValues.prodOrderCommitDateString = value.comment;
									htmlText = value.comment ? $filter('date')(value.comment, 'mediumDate') : '';
									if (overdueDate(value.comment)) {
										cell.children('.inline-edit-cell').addClass('red');
									} else {
										cell.children('.inline-edit-cell').removeClass('red');
									}
									break;
								case 'prodOrderDropDeadDate':
									updateRowsObject.newValues.prodOrderDropDeadDateNdx = data.ndx;
									if (value.comment && value.comment.toString().length) {
										value.comment = $filter('date')(value.comment, 'yyyy-MM-dd');
									}
									updateRowsObject.newValues.prodOrderDropDeadDate = value.comment;
									htmlText = value.comment ? $filter('date')(value.comment, 'mediumDate') : '';
									if (overdueDate(value.comment)) {
										cell.children('.inline-edit-cell').addClass('red');
									} else {
										cell.children('.inline-edit-cell').removeClass('red');
									}
									break;
								case 'soStatusCopy':
									updateRowsObject.newValues.firstPoStatusNdx = data.ndx;
									updateRowsObject.newValues.firstPoStatus = unstrippedComment;
									htmlText = value.comment;
									updateRowsObject.identifier['isTmq'] = true;
									break;
								case 'soCommitDateCopy':
									updateRowsObject.newValues.firstPoEcdNdx = data.ndx;
									if (value.comment && value.comment.toString().length) {
										value.comment = $filter('date')(value.comment, 'yyyy-MM-dd');
									}
									updateRowsObject.newValues.firstPoEcdDate = value.comment;
									htmlText = value.comment ? $filter('date')(value.comment, 'mediumDate') : '';
									if (overdueDate(value.comment)) {
										cell.children('.inline-edit-cell').addClass('red');
									} else {
										cell.children('.inline-edit-cell').removeClass('red');
									}
									updateRowsObject.identifier['isTmq'] = true;
									break;
								}
								cell.children('.inline-edit-cell').children('.edit-name-text').html(htmlText);
								cell.children('.inline-edit-cell').children('.edit-name-text').attr('title', htmlText);
								updateRows(updateRowsObject);
							}
						} else if (data && data.data && data.data.error) {
							$rootScope.$emit('toast', {
								'message': data.data.error,
								'success': false
							});
						}
					});
			} else {
				var commentNdx;
				var subType;
				var message;
				var idField;
				var formatDate;
				var newValue = {
					'comment': strip(value.comment)
				};
				switch (type) {
				case 'cmtStsCmt':
					subType = 'status';
					commentNdx = row.cmtStsNdx;
					message = 'Edit Status';
					idField = 'cmtStsNdx';
					break;
				case 'cmtOpsCmt':
					subType = 'operations';
					commentNdx = row.cmtOpsNdx;
					message = 'Edit Operations Comment';
					idField = 'cmtOpsNdx';
					break;
				case 'cmtRspCmt':
					subType = 'responsible';
					commentNdx = row.cmtRspNdx;
					message = 'Edit Responsible';
					idField = 'cmtRspNdx';
					break;
				case 'cmtColorCmt':
					subType = 'color';
					commentNdx = row.cmtColorNdx;
					message = 'Edit color';
					idField = 'cmtColorNdx';
					break;
				case 'cmtRspEcdCmt':
					subType = 'recd';
					commentNdx = row.cmtRspEcdNdx;
					message = 'Edit Responsible Commit Date';
					idField = 'cmtRspEcdNdx';
					break;
				case 'cmtEcdCmt':
					subType = 'ecd';
					commentNdx = row.cmtEcdNdx;
					message = 'Edit Commit Date';
					idField = 'cmtEcdNdx';
					break;
				case 'commentNdx':
					subType = 'status';
					commentNdx = row[type];
					message = 'Edit Comment';
					idField = 'comment';
				}
				if (commentNdx || commentNdx === 0) {
					newValue.id = commentNdx;
					if (!value.comment) {
						addLoadingSpinnerOnSave(cell);
						leanTableService.deleteInline(commentNdx)
							.then(function (data) {
								if (data && data.error) {
									$rootScope.$emit('toast', {
										'message': data.error,
										'success': false
									});
									htmlText = currentContent;
								} else {
									row[type] = '';
									htmlText = '';
									cell.children('.inline-edit-cell').removeClass('red');
									if (type === 'cmtColorCmt') {
										removeLoadingSpinnerOnFinish(cell);
										cell.children('.inline-edit-cell').removeClass('color-code-10-red');
										cell.children('.inline-edit-cell').removeClass('color-code-20-blue');
										cell.children('.inline-edit-cell').removeClass('color-code-30-yellow');
									} else if (type === 'cmtEcdCmt') {
										updateCommitDateStatus(value.comment, row, ndx);
									}
								}
								removeLoadingSpinnerOnFinish(cell);
								cell.children('.inline-edit-cell').children('.edit-name-text').html(htmlText);
								cell.children('.inline-edit-cell').children('.edit-name-text').attr('title', htmlText);
							});
					}
				}
				if (value.comment) {
					addLoadingSpinnerOnSave(cell);
					leanTableService.setInline(newValue, row.ndx, 'SHORTAGE_BY_ORDER', subType, row.leanDirFactoryNdx)
						.then(function (data) {
							if (data && data.error) {
								$rootScope.$emit('toast', {
									'message': data.error,
									'success': false
								});
								cell.children('.inline-edit-cell').html(currentContent);
							} else if (data && data.id) {
								row[type] = value.comment;
								row[idField] = data.id;
								htmlText = strip(value.comment);
								if (type === 'cmtRspEcdCmt' || type === 'cmtEcdCmt') {
									if (type === 'cmtEcdCmt'){
										updateCommitDateStatus(value.comment, row, ndx);
									}
									value.comment = $filter('date')(value.comment, 'yyyy-MM-dd');
									row[type] = value.comment;
									htmlText = $filter('date')(value.comment, 'mediumDate');
									if (overdueDate(value.comment)) {
										cell.children('.inline-edit-cell').addClass('red');
									} else {
										cell.children('.inline-edit-cell').removeClass('red');
									}
								}
								removeLoadingSpinnerOnFinish(cell);
								if (type == 'cmtColorCmt') {
									cell.children('.inline-edit-cell').children('.edit-name-text').html('<i class="fa fa-fw fa-circle small-circle"></i>');
									cell.children('.inline-edit-cell').removeClass('color-code-10-red');
									cell.children('.inline-edit-cell').removeClass('color-code-30-yellow');
									cell.children('.inline-edit-cell').removeClass('color-code-20-blue');
									cell.children('.inline-edit-cell').addClass(value.comment);
									cell.children('.inline-edit-cell').children('.edit-name-text').attr('title', colorClassMap[value.comment]);
								} else {
									cell.children('.inline-edit-cell').children('.edit-name-text').html(htmlText);
									cell.children('.inline-edit-cell').children('.edit-name-text').attr('title', htmlText);
								}
							}
						});
				}
			}
		}

		function saveLateDeliveryIssueData(type, row, ndx, cell, currentContent, content) {
			var oldContent = row[type];

			if (oldContent != content) {
				var saveObj = {
					'ndx': row['ndx']
				};
				saveObj[type] = content;
				supplierLateDeliveryIssueService.updateLateDeliveryIssue(saveObj, (new Date(row['lastModified'])).toUTCString(), row.leanDirFactoryNdx)
					.then(function (response) {
						if (response && response.status < 400 && response.status !== 304) {
							var modifiedType = type == 'description' ? 'Cause' : 'Liability';
							switch(type) {
							case 'deliveryStatus':
								modifiedType = 'Status';
								break;
							case 'liability':
								modifiedType = 'Liability';
								break;
							case 'description':
							default:
								modifiedType = 'Cause';
							}
							$rootScope.$emit('toast', {
								'message': 'Supplier Delivery ' + modifiedType + ' updated successfully',
								'success': true
							});
							reloadTable();
						} else if (response && response.status >= 400) {
							var message = response.data.error || 'Unknown server error.';
							$rootScope.$emit('toast', {
								'message': message,
								'success': false
							});
						}

					});
			}
		}

		function savePoStatusCategory(type, row, ndx, cell, currentContent, content) {
			var oldContent = row[type];

			if (oldContent != content) {
				var saveObj = {
					'ndx': row['ndx']
				};
				saveObj[type] = content;
				poStatusCategoryService.updatePoStatusCategory(saveObj, (new Date(row['lastModified'])).toUTCString())
					.then(function (response) {
						if (response && response.status < 400 && response.status !== 304) {
							$rootScope.$emit('toast', { 'message': 'Supply Order Status Category updated successfully', 'success': true});
							reloadTable();
						} else if (response && response.status >= 400) {
							$rootScope.$emit('toast', {
								'message': 'Failed to update Supply Order Status Category.',
								'success': false
							});
						}

					});
			}
		}

		function saveCustomerOrderStatusCategory(type, row, ndx, cell, currentContent, content) {
			var oldContent = row[type];

			if (oldContent != content) {
				var saveObj = {
					'ndx': row['ndx']
				};
				saveObj[type] = content;
				customerOrderStatusCategoryService.updateCustomerOrderStatusCategory(saveObj, (new Date(row['lastModified'])).toUTCString())
					.then(function (response) {
						if (response && response.status < 400 && response.status !== 304) {
							$rootScope.$emit('toast', { 'message': 'Customer Order Status Category updated successfully', 'success': true});
							reloadTable();
						} else if (response && response.status >= 400) {
							$rootScope.$emit('toast', {
								'message': 'Failed to update Customer Order Status Category.',
								'success': false
							});
						}

					});
			}
		}

		function saveAssessmentData(type, row, content) {
			var oldContent = row[type];

			if (oldContent != content) {
				var saveObj = {
					'ndx': row['assessmentNdx']
				};
				saveObj[type] = content;
				assessmentService.updateAssessment(row['leanDirFactoryNdx'], saveObj, (new Date(row['lastModified'])).toUTCString())
					.then(function (data) {
						reloadTable();
					});
			}
		}

		function saveReportCardParameterData(colId, ndx, newContent) {
			var existingReportCardParameter = vm.displayedData[ndx] || {};
			var saveObj = {};
			saveObj.ndx = existingReportCardParameter.ndx;

			var currentContent = existingReportCardParameter && existingReportCardParameter[colId];
			if (newContent !== currentContent) {
				saveObj[colId] = newContent;
				reportCardParamsService.updateReportCardParameter(saveObj, (new Date(existingReportCardParameter.lastModified)).toUTCString(), existingReportCardParameter['factoryNdx'])
					.then(function(response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {'message': 'Report card parameter was saved successfully', 'success': true});
							reloadTable();
						} else if (response && response.status >= 400) {
							var errorMessage = 'Unexpected Server Error';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
						}
					});
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		}

		function saveValueStreamData(colId, ndx, newContent) {
			var matchingValueStream = vm.displayedData[ndx] || {};
			var saveObj = {};
			saveObj.ndx = matchingValueStream.ndx;
			var fieldName = colId === 'personName' ? 'responsibleId' : colId;
			var labels = {
				personName: 'Responsible',
				name: 'Name',
				activated: 'Performance Activated'
			};
			var label = labels[colId];
			var currentContent = matchingValueStream && matchingValueStream[fieldName];
			if (newContent !== currentContent) {
				saveObj[fieldName] = newContent;
				valueStreamService.updateValueStream(saveObj, (new Date(matchingValueStream.lastModified)).toUTCString(), matchingValueStream['factoryNdx'])
					.then(function(response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {'message': 'Value stream ' + label.toLowerCase() + ' was saved successfully', 'success': true});
							reloadTable();
						} else if (response && response.status >= 400) {
							var errorMessage = 'Unexpected Server Error';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
						}
					});
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		}

		function deleteValueStream (rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.deleteValueStream(row.ndx);
		}

		function deleteReportCardParameter (rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.deleteReportCardParameter(row.ndx);
		}

		function editStrategicGoal(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.addStrategicGoals(row);
		}

		function showStrategicGoalProjects(goalNdx) {
			$scope.$parent.tableCtrl.showStrategicGoalProjects(goalNdx);
		}

		function updateStrategicGoalStatus(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.updateStrategicGoalStatus(row);
		}

		function deleteStrategicGoal(goalNdx) {
			$scope.$parent.tableCtrl.deleteStrategicGoal(goalNdx);
		}

		function saveMetricValues (rowIndex, column, content) {
			var row = vm.displayedData[rowIndex];
			var cell = jQuery('#' + column + rowIndex).children('cell-div');
			$scope.$parent.tableCtrl.saveMetricValues(row, cell, content);
		}

		function deleteMetricResult (rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.deleteMetricResult(row);
		}

		function updateCommitDateStatus(newCommitDate, row, rowIndex) {
			var currentCommitDateStatus = row.commitDateStatus;
			var newCommitDateStatus = 'None';
			var momentDate = moment(newCommitDate);
			momentDate.set;
			var requirementDate = moment(row.requirementDate);
			var today = moment();
			if (newCommitDate &&
					(momentDate.startOf('day').isAfter(requirementDate.startOf('day'))
						|| today.startOf('day').isAfter(momentDate.startOf('day')))) {
				newCommitDateStatus = 'Late';
			} else if (newCommitDate) {
				newCommitDateStatus = 'OK';
			}
			var cell = jQuery('#commitDateStatus' + rowIndex);
			cell.children('.cell-div').html(newCommitDateStatus);
		}


		function addLoadingSpinnerOnSave(cell) {
			cell.children('.inline-edit-cell').children('.edit-name-text').html('');
			cell.children('.inline-edit-cell').children('.inlineEditIcon').css('display', 'none');
			cell.children('.inline-edit-cell').children('.edit-name-text').removeClass('edit-name-text').addClass('individual-spinner').css('margin-top', '4px');
		}

		function removeLoadingSpinnerOnFinish(cell) {
			cell.children('.inline-edit-cell').children('.individual-spinner').css('margin-top', '0').removeClass('individual-spinner').addClass('edit-name-text');
			cell.children('.inline-edit-cell').children('.inlineEditIcon').css('display', '');
		}

		function getCriticalityDate(row, type) {
			if (type === 'weeks') {
				if (row.firstCriticalBucket === 0) {
					return 'Current';
				} else if (row.firstCriticalBucket === -1) {
					return 'none';
				} else {
					var colId = 'bucket' + row.firstCriticalBucketWeek + 'quantity';
					for (var i = 0; i < vm.columns.length; i++) {
						if (vm.columns[i].id === colId) {
							return vm.columns[i].display;
						}
					}
					return '';
				}
			} else if (type === 'months') {
				if (row.firstCriticalBucketMonth === 0) {
					return 'Current';
				} else if (row.firstCriticalBucketMonth === -1) {
					return 'None';
				} else {
					var colId = 'month' + row.firstCriticalBucketMonth + 'quantity';
					for (var i = 0; i < vm.columns.length; i++) {
						if (vm.columns[i].id === colId) {
							return vm.columns[i].display;
						}
					}
				}
				return '';
			} else {
				if (row.firstCriticalBucketDay === 0) {
					return 'Current';
				} else if (row.firstCriticalBucketDay === -1) {
					return 'None';
				} else {
					var colId = 'day' + row.firstCriticalBucketDay + 'quantity';
					for (var i = 0; i < vm.columns.length; i++) {
						if (vm.columns[i].id === colId) {
							return vm.columns[i].display;
						}
					}
				}
				return '';
			}
		}

		function showStatusHistory(rowIndex, type, bucketType, commentType) {
			var row = vm.displayedData[rowIndex];
			if (opened) return;
			opened = true;
			var statusHistoryScope = $scope.$new();
			statusHistoryScope.row = row;
			statusHistoryScope.loading = true;
			statusHistoryScope.empty = true;
			var instance;
			var template;
			var commentMapping = {
				'status': 'Status',
				'ecd': 'PO Commit Date',
				'lateDeliveryIssue': 'Late Delivery Cause',
				'trackingNumber': 'Tracking Number',
				'poStatusCategory': 'Supply Order Status Category',
				'prodOrderStatus': 'Production Order Status'
			};
			if (type === 'poComment' && row.orderNumber) {
				template = 'po-status-history-for-supply-report.html';
			} else if (type === 'poComment') {
				statusHistoryScope.bucketType = bucketType === undefined ? 'weeks' : bucketType;
				row.weekOfFirstShortage = _.isNumber(row.firstCriticalBucket) ? getCriticalityDate(row, statusHistoryScope.bucketType) : null;
				template = 'po-status-history.html';
			} else {
				template = 'current-shortage-status-history.html';
			}
			var poCommentNdx = row.firstPoStatusNdx;;
			if (commentType) {
				if (commentType === 'firstPoTrackingNumber') {
					poCommentNdx = row.firstPoTrackingNumberNdx;
				} else if (commentType === 'poStatusCategoryDescription') {
					poCommentNdx = row.poStatusCategoryCommentNdx;
				} else if (commentType === 'lateDeliveryDescription') {
					poCommentNdx = row.lateDeliveryIssueCommentNdx;
				}
			}

			leanTableService.getCommentHistory(poCommentNdx, 'userComment', row['leanDirFactoryNdx'], type, row.lateDeliveryIssueCommentNdx, row.firstPoEcdNdx).promise
				.then(function (response) {
					statusHistoryScope.history = response.data;
					statusHistoryScope.loading = false;
					if (response && response.status && response.status >= 200 && response.status < 400) {
						statusHistoryScope.empty = !response || !response.data || !response.data.length;
						angular.forEach(statusHistoryScope.history, function (his) {
							his.updatedTimeDisplay = moment(his.updatedTime).fromNow();
						});
					} else {
						statusHistoryScope.empty = true;
					}
				}).then(showTooltip);

			function showTooltip() {
				instance = slideInModalService.openModal({
					scope: statusHistoryScope,
					templateUrl: '/application/f/reports/' + template,
					windowTemplateUrl: '/application/f/core/item-drilldown/item-drilldown-template.html'
				});
				instance.result.then(function () {
					opened = false;
				});
				instance.result.catch(function() {
					jQuery('.inlineEditDiv').unbind();
					jQuery('.inlineEditDiv').remove();
					opened = false;
				});
			};

			statusHistoryScope.getCommentMapping = function (commentType, deliveryStatus) {
				if (commentType === 'lateDeliveryIssue') {
					if (deliveryStatus === 'Early') {
						return 'Early Delivery Cause';
					}
					return 'Late Delivery Cause';
				} else if (commentMapping[commentType]) {
					return commentMapping[commentType];
				} else {
					return 'Comment';
				}
			};

			statusHistoryScope.formatNumber = function (val) {
				return numberFormatService.getWithParameters(val, numberOfDecimals(val, 0));
			};

			statusHistoryScope.closeDialog = function () {
				slideInModalService.closeModal();
				if (statusHistoryScope) {
					statusHistoryScope.$destroy();
				}
			};
		}

		function sboShowStatusHistory(rowIndex, ndxKey, commentType) {
			if (opened) return;
			var instance;
			var commentMapping = {
				'status': 'Status',
				'ecd': 'PO Commit Date',
				'lateDeliveryIssue': 'Late Delivery Cause',
				'trackingNumber': 'Tracking Number',
				'poStatusCategory': 'Supply Order Status Category',
				'prodOrderStatus': 'Production Order Status'
			};
			var row = vm.displayedData[rowIndex];
			var historyTemplate = ['prodOrderStatusNdx', 'prodOrderOperationsCommentNdx'].indexOf(ndxKey) >= 0 || row['isTmq']
				? '/application/f/reports/production-order-status-history.html'
				: '/application/f/reports/status-history.html';
			opened = true;
			var statusHistoryScope = $scope.$new();
			statusHistoryScope.row = row;
			statusHistoryScope.empty = true;
			statusHistoryScope.showSiteName = row.leanDirFactoryNdx !== globalConfig.factory.id;
			statusHistoryScope.siteName = row.factoryName || row.siteAlias;
			statusHistoryScope.loading = true;
			leanTableService.getCommentHistory(row[ndxKey], commentType).promise
				.then(function (response) {
					statusHistoryScope.history = response.data;
					statusHistoryScope.loading = false;
					if (response && response.status && response.status >= 200 && response.status < 400) {
						statusHistoryScope.empty = !response || !response.data || !response.data.length;
						angular.forEach(statusHistoryScope.history, function (his) {
							his.updatedTimeDisplay = moment(his.updatedTime).fromNow();
						});
					} else {
						statusHistoryScope.empty = true;
					}
				}).then(showTooltip);

			function showTooltip() {
				instance = slideInModalService.openModal({
					scope: statusHistoryScope,
					templateUrl: historyTemplate,
					windowTemplateUrl: '/application/f/core/item-drilldown/item-drilldown-template.html'
				});
				instance.result.then(function () {
					opened = false;
				});
				instance.result.catch(function () {
					opened = false;
				});
			}

			statusHistoryScope.getCommentMapping = function (commentType) {
				if (commentMapping[commentType]) {
					return commentMapping[commentType];
				} else {
					return 'Comment';
				}
			};

			statusHistoryScope.closeDialog = function () {
				slideInModalService.closeModal();
				if (statusHistoryScope) {
					statusHistoryScope.$destroy();
				}
			};

		}

		function openItemSearchSlideIn(rowIndex) {
			var row = vm.displayedData[rowIndex];
			openItemDetailSlideIn(rowIndex, row, undefined, false, 'ItemSearch', undefined, undefined, row.factoryNdx);
		}

		function openSlideIn(rowIndex, sections, itemType, factoryNdxs, specificTaskType, taskId, shortageRootCauseType, currentTaskId, supplyAndDemandFilterActive, expandDoneSection, openSidebar, sidebarOnlyMode, currentTableName, openChat, chatId, chatType) {
			// Default to this Angular report so React Add Task can refresh the row (actionCount / status badge).
			if (!currentTableName) {
				currentTableName = reportSettingsName;
			}
			$timeout(function () {
				if (!vm.groupBy) {
					openItemDetailSlideIn(rowIndex, vm.displayedData[rowIndex], reportSettingsName + 'Grid', false, reportSettingsName, itemType, sections, factoryNdxs, specificTaskType, taskId, shortageRootCauseType, currentTaskId, supplyAndDemandFilterActive, expandDoneSection, openSidebar, sidebarOnlyMode, currentTableName, openChat, chatId, chatType);
				} else {
					var orderedData = [];
					_.forEach(vm.displayedData, function (group) {
						_.forEach(group.items, function (row) {
							orderedData.push(row);
						});
					});
					openItemDetailSlideIn(rowIndex, orderedData[rowIndex], reportSettingsName + 'Grid', false, reportSettingsName, itemType, sections, factoryNdxs, specificTaskType, taskId, shortageRootCauseType, currentTaskId, supplyAndDemandFilterActive, expandDoneSection, openSidebar, sidebarOnlyMode, currentTableName, openChat, chatId, chatType);
				}
			});
		}



		function openItemDrilldown(rowIndex, reportName, openParam) {
			var row = vm.displayedData[rowIndex];
			var poNumber = row.firstPurchaseOrderNumber || row.supplyOrderNumber || row.purchaseOrderNumber || row.orderNumber;
			var poLine = row.firstPurchaseOrderLine || row.orderLine || row.purchaseOrderLine;
			var scheduleLine = row.firstPurchaseOrderScheduleLine || row.scheduleLine;
			var identifier = '';
			if (poNumber) {
				identifier = poNumber + ':' + poLine + ':' + scheduleLine;
				identifier = row.itemNdx + ':' + identifier;
			}

			var params = {
				itemCode: row.itemCode,
				fullItemCode: row.fullItemCode,
				itemType: row.itemType,
				itemDescription: row.itemDescription,
				factoryNdx: row.factoryNdx || row.leanDirFactoryNdx,
				currentTableName: reportName,
				taskId: row.taskId,
				chatId: identifier,
				chatType: 'supplyOrder',
				sidebarOnlyMode: identifier !== '',
				exactMatch: true
			};
			// eslint didn't like dynamic key when creating an object
			params[openParam || 'openSidebar'] = identifier !== '';

			storeService.dispatch(storeService.actionCreators.modal.openItemDrilldownAction(params));
		}

		function addTask(rowIndex, specificTaskType) {
			var row = vm.displayedData[rowIndex];
			$rootScope.$broadcast('createProcurementTask', {
				factoryNdx: row.leanDirFactoryNdx,
				itemNdx: row.itemNdx,
				itemCodeDisplay: row.itemCode || row.itemCodeDisplay,
				fullItemCode: row.fullItemCode,
				location: reportSettingsName + 'Grid',
				row: row,
				specificTaskType: specificTaskType
			});
		}

		// For supplier scorecard rollup row, we stop the propogatoin of click event.
		// By doing that when ever user click on the other row, last scope was not getting destroyed.
		// This method ensures all existing scopes are being destroyed.
		function clearSupplierscoreScopes() {
			angular.forEach(supplierScoreCardOpened, function(scorecardScope) {
				if (scorecardScope) {
					scorecardScope.closeDialog();
				}
			});
		}

		function openSupplierScoreCard(rowIndex) {
			var row = vm.displayedData[rowIndex];
			if (supplierScoreCardOpened[rowIndex] !== undefined) return;
			var supplierScoreCardScope = $scope.$new();
			clearSupplierscoreScopes();
			supplierScoreCardOpened[rowIndex] = supplierScoreCardScope;
			var instance;
			var buckets = getSupplierPerformanceBuckets(row, 12);
			supplierScoreCardScope.supplierNdxs = row['supplierNdxs'];
			supplierScoreCardScope.leanDirFactoryNdxs = row['leanDirFactoryNdxs'];
			supplierScoreCardScope.supplierName = row['supplierName'];
			supplierScoreCardScope.supplierCode = row['supplierCode'] || row['supplierCodeInner'];
			supplierScoreCardScope.siteNames = getSiteNamesForSotd(row['leanDirFactoryNdxs']);
			supplierScoreCardScope.monthlyValues = _.reverse(buckets['delPerfMonthBucket']);
			supplierScoreCardScope.threeMonthAvgValues = _.reverse(buckets['delPerf3MonthRollingBucket']);
			supplierScoreCardScope.monthlyRank = _.reverse(buckets['delPerfMonthBucketRnk']);
			supplierScoreCardScope.noPerformanceData = _.reject(supplierScoreCardScope.monthlyValues, _.isNumber).length == 12 &&
				_.reject(supplierScoreCardScope.threeMonthAvgValues, _.isNumber).length == 12;
			supplierScoreCardScope.isEmbedded = true;
			incomingData.factory = row['leanDirFactoryNdxs'];
			incomingData.supplierNdxs = row['supplierNdxs'];
			incomingData.isScoreCard = true;
			incomingData.isRemote = false;
			$timeout(function () {
				instance = slideInModalService.openModal({
					scope: supplierScoreCardScope,
					templateUrl: '/application/f/supply-chain/supplier-performance/supplier-score-card-report.html',
					windowTemplateUrl: '/application/f/core/item-drilldown/item-drilldown-template.html'
				});
				instance.result.then(function () {
					delete supplierScoreCardOpened[rowIndex];
				});
				instance.result.catch(function() {
					jQuery('.inlineEditDiv').unbind();
					jQuery('.inlineEditDiv').remove();
					delete supplierScoreCardOpened[rowIndex];
				});
			}, 0);

			supplierScoreCardScope.closeDialog = function () {
				slideInModalService.closeModal();
				if (supplierScoreCardScope) {
					supplierScoreCardScope.$destroy();
				}
				delete supplierScoreCardOpened[rowIndex];
			};
		}

		function openItemDetailSlideIn(rowIndex, row, id, isSupplierPortal, sourceLocation, itemType, sections, factoryNdxs, specificTaskType, taskId, shortageRootCauseType, currentTaskId, supplyAndDemandFilterActive, expandDoneSection, openSidebar, sidebarOnlyMode, currentTableName, openChat, chatId, chatType) {
			var element = angular.element(document.getElementById('itemCtrlDiv'));
			var scope = element.scope();
			if (!itemType) {
				itemType = row.itemType;
			}
			scope.openModal(row.fullItemCode, row, sourceLocation, isSupplierPortal, row.itemCode, row.itemDescription, rowIndex, sections, undefined, itemType, factoryNdxs, specificTaskType, taskId, shortageRootCauseType, currentTaskId, supplyAndDemandFilterActive, expandDoneSection, openSidebar, sidebarOnlyMode, currentTableName, openChat, chatId, chatType);
		}

		var tooltipReady;
		function tooltipSetReady(colId, rowId) {
			tooltipReady = tooltipId(colId, rowId);
		}

		function tooltipSetNotReady(colId, rowId) {
			if (tooltipReady === tooltipId(colId, rowId)) {
				tooltipReady = null;
			}
		}

		function tooltipIsReady(colId, rowId) {
			return tooltipReady === tooltipId(colId, rowId);
		}

		function tooltipId(colId, rowId) {
			return rowId + ':' + colId;
		}

		function overdueDate(dueDate, status) {
			if (status === 'Completed' || dueDate === '') {
				return false;
			}
			return moment().isAfter(dueDate, 'day');
		}

		function tagTransform(newTag, type) {
			if (type === 'responsible') {
				return {
					'resDisplay': newTag,
					'resVal': newTag
				};
			} else if (type === 'category') {
				return {
					'name': newTag
				};
			}
		}

		function refreshTagListResults($select, type) {
			var search = $select.search,
				list = angular.copy($select.items),
				FLAG = -1;
			//remove last user input
			list = list.filter(function (item) {
				return item.id !== FLAG;
			});

			if (!search) {
				//use the predefined list
				$select.items = list;
			} else {
				//manually add user input and set selection
				var userInputItem = {
					id: FLAG,
					extraLabel: ' (Click or press Enter to create)'
				};
				if (type === 'responsible') {
					userInputItem.resDisplay = search;
					userInputItem.resVal = search;
				} else {
					userInputItem.name = search;
				}
				$select.items = [userInputItem].concat(list);
				$select.selected = $select.items[0];
				$select.activeIndex = 0;
				$select.activate($select.items[0]);
			}
		}

		function getRawData() {
			var data = vm.displayedData;
			if (vm.groupBy) {
				var rawData = [];
				_.forEach(vm.displayedData, function (group) {
					rawData = rawData.concat(group.items);
				});
				data = rawData;
			}
			return data;
		}
		function deactivateFlexField(id, fieldDefinition, fieldName, lastModified) {
			$scope.$parent.tableCtrl.deactivateFlexField(id, fieldDefinition, fieldName, lastModified);
		}
		function archiveProject(projNdx, lastModified, factoryNdx) {
			$scope.$parent.tableCtrl.archiveProject(projNdx, lastModified, factoryNdx);
		}

		function deleteProject(projNdx, lastModified, factoryNdx) {
			$scope.$parent.tableCtrl.deleteProject(projNdx, lastModified, factoryNdx);
		}

		function approveProject(projNdx, lastModified, factoryNdx) {
			$scope.$parent.tableCtrl.approveProject(projNdx, lastModified, factoryNdx);
		}

		function archiveLateDeliveryIssue(lateDeliveryIssueNdx, lastModified, factoryNdx) {
			$scope.$parent.tableCtrl.archiveLateDeliveryIssue(lateDeliveryIssueNdx, lastModified, factoryNdx);
		}

		function archivePoStatusCategory(poStatusCategoryNdx, lastModified, factoryNdx) {
			$scope.$parent.tableCtrl.archivePoStatusCategory(poStatusCategoryNdx, lastModified, factoryNdx);
		}

		function archiveCustomerOrderStatusCategory(customerOrderStatusCategoryNdx, lastModified, stateType) {
			$scope.$parent.tableCtrl.archiveCustomerOrderStatusCategory(customerOrderStatusCategoryNdx, lastModified, stateType);
		}

		function isReadOnly() {
			return storeService.getState().reportSettings.readOnly;
		}

		function viewA3Report(projNdx, factoryNdx) {
			$scope.$parent.tableCtrl.viewA3Report(projNdx, factoryNdx);
		}

		function copyMetricTargets(metricName, metricNdx, periodType, isRatioTarget) {
			$scope.$parent.tableCtrl.copyMetricTargets(metricName, metricNdx, periodType, isRatioTarget);
		}

		function openReportCard(valueStreamNdx, valueStreamName, userNdx) {
			$scope.$parent.tableCtrl.openReportCard(valueStreamNdx, valueStreamName, userNdx);
		}

		function getSupplierPerformanceBuckets(row, noOfMonths) {
			var buckets = {
				'delPerfMonthBucket': [],
				'delPerf3MonthRollingBucket': [],
				'delPerfMonthBucketRnk': []
			};
			for (var i = 0; i < noOfMonths; i++) {
				buckets['delPerfMonthBucket'].push(row['delPerfMonthBucket' + (i+1)] || 'null');
				buckets['delPerf3MonthRollingBucket'].push(row['delPerf3MonthRollingBucket' + (i+1)] || 'null');
				buckets['delPerfMonthBucketRnk'].push(row['delPerfMonthBucket' +(i+1) + 'Rnk'] || 'null');
			}
			return buckets;
		}

		function getSiteNamesForSotd(siteIds) {
			var sites = siteIds.toString().split(',');
			var showMoreText = '';
			if (sites.length > 2) {
				showMoreText = ', ' + (sites.length - 2) + ' more...';
				sites = sites.splice(0, 2);
			}
			var siteNames = _.join(_.map(sites, function (siteId) {
				return globalConfig.user.authFacts[siteId]['alias'];
			}), ', ');

			return siteNames + showMoreText;
		}

		function viewSOTDReport(rowIndex) {
			var row = vm.displayedData[rowIndex];
			var reportScope = $scope.$new();
			reportScope.isEmbedded = true;
			reportScope.supplierName = row['supplierName'];
			var buckets = getSupplierPerformanceBuckets(row, 12);
			reportScope.siteNames = getSiteNamesForSotd(row['leanDirFactoryNdxs']);
			reportScope.monthlyValues = _.reverse(buckets['delPerfMonthBucket']);
			reportScope.threeMonthAvgValues = _.reverse(buckets['delPerf3MonthRollingBucket']);
			reportScope.monthlyRank = _.reverse(buckets['delPerfMonthBucketRnk']);
			reportScope.noPerformanceData = _.reject(reportScope.monthlyValues, _.isNumber).length == 12 &&
				_.reject(reportScope.threeMonthAvgValues, _.isNumber).length == 12;
			incomingData.factory = row['leanDirFactoryNdxs'];
			incomingData.supplierNdxs = row['supplierNdxs'];
			incomingData.isScoreCard = false;
			var instance = $uibModal.open({
				scope: reportScope,
				templateUrl: '/application/f/supply-chain/supplier-performance/sotd.html',
				windowTemplateUrl: '/application/f/dashboard/widgets/a3metric-template.html'
			});

			instance.result.then(function () {
				// do nothing on success
			}, function () {
				reportScope.closeDialog();
			});

			reportScope.closeDialog = function () {
				incomingData = {};
				instance.close();
				reportScope.$destroy();

			};
		}

		function openExcessToSellDetail(rowIndex, factoryId, factoryName) {
			var modalScope = $scope.$new();
			var data = vm.displayedData[rowIndex];
			modalScope.row = {
				factoryName: factoryName,
				itemCodeDisplay: data.itemCodeDisplay,
				itemDescription: data.itemDescription,
				potentialToSell: formatterService.formatCurrency(data['potentialToSell_' + factoryId], undefined, vm.currencySymbol),
				potentialToSellQuantity: numberFormatService.getWithParameters(data['potentialToSellQuanity_' + factoryId], numberOfDecimals(data['potentialToSellQuanity_' + factoryId])),
				oneYearReq: numberFormatService.getWithParameters(data['oneYearReq_' + factoryId], numberOfDecimals(data['oneYearReq_' + factoryId])),
				onHand: numberFormatService.getWithParameters(data['onHand_' + factoryId], numberOfDecimals(data['onHand_' + factoryId])),
				onOrderIslt: integerFormatService.getWithParameters(data['onOrderIslt_' + factoryId], 0),
				itemCodes: data['itemCodes_' + factoryId],
				uom: data['uom'],
				currencyCode: vm.currencySymbol
			};
			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/supply-chain/cross-site/excess-to-sell-factory-detail-modal.html',
				animation: false,
				windowTemplateUrl: '/application/f/core/loading-template.html',
				backdrop: 'static'
			};
			var instance = $uibModal.open(opts);
			modalScope.closeDialog = function () {
				instance.dismiss('cancel');
			};

		}

		function lateDeliveryCauseGrouping(item) {
			if (item.liability === 'Customer')
				return globalConfig.customer.name;
			else
				return item.liability;
		}

		function openAuditLogContent(rowIndex) {
			var modalScope = $scope.$new();
			var data = vm.displayedData[rowIndex];
			var content = data;

			modalScope.row = {
				content: getAuditLogContent(data['content'])
			};
			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/setup/leandna/audit-log-content-modal.html',
				animation: false,
				windowTemplateUrl: '/application/f/core/loading-template.html',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			modalScope.closeDialog = function () {
				instance.dismiss('cancel');
			};

			function getAuditLogContent(rawContent) {
				var contentJson;
				try {
					contentJson = JSON.parse(rawContent);
				} catch(err) {
					return contentJson;
				}
				return '<pre>' + JSON.stringify(contentJson, undefined, 2) + '</pre>';
			}

			var modal, getModal;
			var getIFrameInterval = function () {
				modal = document.getElementById('previewAuditLog');
				if (modal) {
					clearInterval(getModal);
					showHtmlInIframe();
				}
			};

			modal = document.getElementById('previewAuditLog');
			if (!modal) {
				getModal = setInterval(getIFrameInterval, 200);
			} else {
				showHtmlInIframe();
			}

			function showHtmlInIframe() {
				var previewAuditLogFrame = document.getElementById('previewAuditLog');
				var preview = previewAuditLogFrame.contentDocument || previewAuditLogFrame.contentWindow.document;
				preview.open();
				preview.write(getAuditLogContent(data['content']));
				preview.close();
			}
		}

		function handleEmailAction(rowIndex, callback){
			if(vm.displayedData[rowIndex].id ===  0){
				$rootScope.$emit('toast', {
					'message': 'Unable to fetch email contents',
					'success': false
				});
				return;
			}
			leanTableService.getEmailPreview(vm.displayedData[rowIndex].id).promise.then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					callback(response.data);
				}
			});
		}

		function openEmailPreview(rowIndex){
			handleEmailAction(rowIndex, openEmailDetail);
		}

		function openEmailDetail(data) {
			var modalScope = $scope.$new();
			var regex = new RegExp('^<([^>]+)>');
			var regexResult = regex.exec(data['message']);
			var isHtmlPage = (regexResult && _.includes(regexResult.pop(), 'html'));
			modalScope.row = {
				toAddress: data['to'],
				fromAddress: data['from'],
				tag: data['tag'],
				subject: data['subject'],
				emailMessage: data['message'],
				isHtmlPage: isHtmlPage
			};
			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/setup/leandna/email-detail-modal.html',
				animation: false,
				windowTemplateUrl: '/application/f/core/loading-template.html',
				backdrop: 'static'
			};
			var instance = $uibModal.open(opts);
			modalScope.closeDialog = function () {
				instance.dismiss('cancel');
			};

			var modal, getModal;
			var getIFrameInterval = function () {
				modal = document.getElementById('previewEmail');

				if (modal) {
					clearInterval(getModal);
					showHtmlInIframe();
				}
			};

			if (isHtmlPage) {
				modal = document.getElementById('previewEmail');
				if (!modal) {
					getModal = setInterval(getIFrameInterval, 200);
				} else {
					showHtmlInIframe();
				}
			}

			function showHtmlInIframe() {
				var previewEmailFrame = document.getElementById('previewEmail');
				var preview =  previewEmailFrame.contentDocument ||  previewEmailFrame.contentWindow.document;
				preview.open();
				preview.write(data['message']);
				preview.close();
			}
		}

		function addSupplierUser(rowIndex) {
			var modalScope = $scope.$new();
			var data = vm.displayedData[rowIndex];

			modalScope.supplierCode = data['supplierCode'] || data['supplierCodeInner'];
			modalScope.enableWhitelistByDefault = true;
			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/supply-chain/supplier-performance/add-supplier-user-modal.html',
				animation: false,
				windowTemplateUrl: '/application/f/core/loading-template.html',
				backdrop: 'static'
			};
			var instance = $uibModal.open(opts);
			modalScope.closeDialog = function (reload) {
				if (reload) {
					$scope.$broadcast('reloadTable');
				}
				instance.dismiss('cancel');
			};
		}

		function downloadEmailTrigger(rowIndex){
			handleEmailAction(rowIndex, downloadEmail);
		}

		function downloadEmail(data) {
			var href = URLS.host + '2/EmailMessageReport/Message/' + data.sesMessageId;

			if (window.navigator.msSaveBlob) {
				$http.get(href)
					.then(function(response) {
						var blob = new Blob([JSON.stringify(response.data)], {type : 'application/json'});
						window.navigator.msSaveOrOpenBlob(blob, data.sesMessageId + '.json');
					});
			} else {
				var a = window.document.createElement('a');
				a.href = href;
				a.download = data.sesMessageId + '.json';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			}
		}

		function selectFactoriesForSelectedCustomer(column, rowIndex, checkboxState) {
			var checkboxIcon;
			var row;
			rowIndex++;
			for (var i = rowIndex; i < vm.displayedData.length; i++) {
				row = vm.displayedData[i];
				if (row.isRollup || !row) break;
				row[column] = checkboxState;
				checkboxIcon = jQuery('#' + column + i + ' i');
				checkboxIcon.removeClass('fa-square-o').removeClass('fa-check-square').addClass(row[column] ? 'fa-check-square': 'fa-square-o');
			}
		}

		function updateSelectAllBox(column) {
			var notAllSelected = jQuery('.' + column + ' .fa-square-o').length;
			var notNoneSelected = jQuery('.' + column + ' .fa-check-square').length;
			var newClass;
			$scope.$emit('updateNoneSelected', { noneSelected: !notNoneSelected });
			if (notAllSelected && notNoneSelected) {
				newClass = 'fa-minus-square';
			} else if (notAllSelected) {
				newClass = 'fa-square-o';
			} else {
				newClass = 'fa-check-square';
			}
			$timeout(function () {
				jQuery('#header' + column + ' .fa-minus-square').removeClass('fa-minus-square').addClass(newClass);
				jQuery('#header' + column + ' .fa-check-square').removeClass('fa-check-square').addClass(newClass);
				jQuery('#header' + column + ' .fa-square-o').removeClass('fa-square-o').addClass(newClass);
			}, 0);
		}

		function toggleCheckboxRow(rowIndex, column) {
			var checkboxIcon = jQuery('#' + column + rowIndex + ' i');
			var row = vm.displayedData[rowIndex];
			var wasChecked = row[column];
			if (row) {
				row[column] = !wasChecked;
				if (wasChecked) {
					checkboxIcon.removeClass('fa-check-square').addClass('fa-square-o');
				} else {
					checkboxIcon.removeClass('fa-square-o').addClass('fa-check-square');
				}

				if (row.isRollup) {
					selectFactoriesForSelectedCustomer(column, rowIndex, row[column]);
				}
			}
			$scope.$emit('updateCustomersSelected', { customersSelected: getSelectedEntities().customerNdxList.length });
			updateSelectAllBox(column);
		}

		function selectAllCheckboxes(column) {
			$scope.$emit('updateNoneSelected', { noneSelected: false });
			angular.forEach(vm.displayedData, function (row) {
				if (!row.isRollup || (row.isRollup && row.isCustomerAdministrator)) {
					row[column] = true;
				}
				if (row.isRollup && row.isCustomerAdministrator) {
					$scope.$emit('updateCustomersSelected', { customersSelected: true });
				}
			});
			$timeout(function () {
				jQuery('.' + column + ' .fa-square-o').addClass('fa-check-square').removeClass('fa-square-o');
				jQuery('#header' + column + ' .fa-square-o').removeClass('fa-square-o').addClass('fa-check-square');
			});
		}

		function deselectAllCheckboxes(column) {
			$scope.$emit('updateNoneSelected', { noneSelected: true });
			$scope.$emit('updateCustomersSelected', { customersSelected: false });
			angular.forEach(vm.displayedData, function (row) {
				row[column] = false;
			});
			$timeout(function () {
				jQuery('.' + column + ' .fa-minus-square').addClass('fa-square-o').removeClass('fa-minus-square');
				jQuery('.' + column + ' .fa-check-square').addClass('fa-square-o').removeClass('fa-check-square');
				jQuery('#header' + column + ' .fa-minus-square').removeClass('fa-minus-square').addClass('fa-square-o');
				jQuery('#header' + column + ' .fa-check-square').removeClass('fa-check-square').addClass('fa-square-o');
			}, 0);
		}

		function toggleAllCheckboxes(column) {
			var anySelected = jQuery('.' + column + ' .fa-check-square').length;
			if (anySelected) {
				deselectAllCheckboxes(column);
			} else {
				selectAllCheckboxes(column);
			}
		}

		$scope.$on('changeSubscription', function (event, args) {
			var sub = args.subscribe;
			var list = args.list;
			var type = args.type;
			var factory = args.factory;
			changeSubscription(sub, list, type, factory);
		});

		$scope.$on('unsubscribeSelected', function (event, args) {
			var type = args.type;
			var factory = args.factory;
			unsubscribeSelected(type, factory);
		});

		function changeSubscription(sub, list, type, factory) {
			var updateFunction = type === 'role' ? 'updateSubscriptionForRoles' : 'updateSubscriptionForUsers';
			var alertType = leanFilterService.getSelectedIds('alert')[0];
			manageEmailAlertsService[updateFunction](!sub, alertType, list, factory).then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					$rootScope.$emit('toast', {
						'message': 'Subscription has been updated successfully'
					});
				} else {
					$rootScope.$emit('toast', {
						'message': 'Unexpected server error',
						'success': false
					});
				}
				reloadTable();
				deselectAllCheckboxes('isChecked');
			});
		}

		function unsubscribeSelected(type, factory) {
			var unsubscribedList = [];
			angular.forEach(vm.displayedData, function (row) {
				if (row.isChecked) unsubscribedList.push(row[type]);
			});
			changeSubscription(false, unsubscribedList.toString(), type, factory);
		};

		$scope.$on('deactivateSelectedUsers', function (event, args) {
			deactivateSelectedUsers();
		});

		function deactivateSelectedUsers() {
			var userList = _.filter(vm.displayedData, ['isChecked', true]).map(function(user) {
				return user.userNdx;
			});
			if (userList && userList.length) {
				userManagementService.getListOfAuthorizedActiveSitesForUsers(userList)
					.then(function (factoryIds) {
						if (!factoryIds.length) return;
						var confirmScope = $scope.$new();
						confirmScope.factoryList = leanFilterService.getFilterById('allFactory').objectList;
						confirmScope.selected = {};
						confirmScope.selected.factories = [];
						for (var i = 0; i < confirmScope.factoryList.length; i++) {
							if (confirmScope.factoryList[i].selected && factoryIds.indexOf(confirmScope.factoryList[i].id) !== -1) {
								confirmScope.selected.factories.push(confirmScope.factoryList[i]);
							}
						}
						var opts = {
							scope: confirmScope,
							templateUrl: '/application/f/setup/deactivate_users_factory_selector.html'
						};

						confirmScope.deactivate = function () {
							var factList = [];
							for (var i = 0; i < confirmScope.selected.factories.length; i++) {
								factList.push(confirmScope.selected.factories[i].id);
							}
							userManagementService.deactivateMultipleUsersForFactories(userList, factList)
								.then(function (response) {
									if (response && response.status && response.status >= 200 && response.status < 400) {
										$rootScope.$emit('toast', {
											'message': 'Users have been deactivated successfully',
											'success': true
										});
									} else {
										$rootScope.$emit('toast', {
											'message': 'Unexpected server error',
											'success': false
										});
									}
									reloadTable();
									deselectAllCheckboxes('isChecked');
									confirmScope.closeDialog();
								});
						};

						var instance = $uibModal.open(opts);
						confirmScope.closeDialog = function () {
							instance.close();
							confirmScope.$destroy();
						};
					});
			}
		}

		function commitDateApproval(column, value, row, ndx, cell, currentContent) {
			var confirmScope = $scope.$new();
			confirmScope.args = {};
			confirmScope.args.writeErpFirmDate = false;

			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/supply-chain/approve_commit_date_with_erp_firm_date.html'
			};

			confirmScope.approve = function () {
				saveComment(column, value, row, ndx, cell, currentContent, confirmScope.args.writeErpFirmDate);
				confirmScope.closeDialog();
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};
		}

		function getListTemplateForUserFactory(position, rowIndex, variableName, variableDisplay, display, value, factoryNdx, supplierRow) {
			var width = 296;
			var extraClass = '';
			if (variableName === 'supplierNdx') {
				width = 496;
				extraClass = 'supplier';
			}
			ensurePopupInBound(position, width, 112);
			var extraFilter = '';
			if (value === 'uri') {
				extraFilter = ', isActive:true';
				if (supplierRow) extraFilter += ', forSupplier:true';
			}

			var useFactoryNdx = (factoryNdx && variableName == 'supplierNdx');

			var filter = 'filter: {' + display + ': $select.search' + extraFilter + '}';
			if (variableName === 'supplierNdx') filter = 'supplierFilter:$select.search';

			var groupby = variableName === 'roleType' ? 'vm.translateRoleGroup' : '';

			var editTemplate = '<div class="inlineEditDiv textEdit ' + extraClass + '" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader" translate>Change ' + variableDisplay + '</div>' +
				'<ui-select append-to-body="true" theme="bootstrap" ng-model="vm.editing.' + variableName + '">' +
				'<ui-select-match placeholder="{{' + "'Select " + variableDisplay + "...'" + ' | translate}}">' +
				'{{$select.selected.' + display + ' | translate}}' +
				'</ui-select-match>' +
				'<ui-select-choices group-by="' + groupby + '" repeat="item.' + value + ' as item in vm.lists.' + variableName + (useFactoryNdx ? '[' + factoryNdx + ']' : '') + ' | ' + filter + '">' +
				'{{item.' + display + (variableName === 'supplierNdx' ? ' + " : " + item.supplierCode' : '') + ' | translate}}' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="vm.cancelEdit()" translate>Cancel</button>' +
				'<button class="button flat colored" ng-disabled="!vm.editing.' + variableName + ' && !(vm.editing.' + variableName + ' == false)" ng-click="vm.saveEditSelectForUserFactory(' + "'" + variableName + "'," + rowIndex + ')" translate>Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function startEditSelectForUserFactory(variableName, rowIndex, display, value, isBoolean) {
			var userFactoryCtrl = $scope.$parent.tableCtrl;
			var factoryNdx = vm.displayedData[rowIndex].leanDirFactoryNdx;
			vm.lists = vm.lists || userFactoryCtrl.lists;
			vm.editing = {};
			if (variableName == 'supplierNdx') {
				if (!vm.lists[variableName]) vm.lists[variableName] = {};
				if (!vm.lists[variableName][factoryNdx]) {
					userFactoryCtrl.urlMap[variableName](factoryNdx).then(function (data) {
						vm.lists[variableName][factoryNdx] = data;
					});
				}
			} else if (!vm.lists[variableName]) {
				userFactoryCtrl.urlMap[variableName]().then(function (data) {
					// Unfortunately this page is setup poorly so this had to be done
					var userName = jQuery('#emailAddressValue').text().trim();
					if (variableName === 'profileType' && userName && userName.indexOf('@leandna.com') === -1) {
						data = _.filter(data, function (o) {
							return o.profileType !== 'SuperSystemAdministrator';
						});
					}
					var isSuperSystemAdministrator = jQuery('#isSuperSystemAdministratorValue').text().trim();
					if (variableName === 'roleType' &&  (isSuperSystemAdministrator || vm.displayedData[rowIndex].isCustomerAdministrator)) {
						data = _.filter(data, function (o) {
							return o.roleType !== 'Supplier';
						});
					}
					vm.lists[variableName] = data;
				});
			}
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var supplierRow = vm.displayedData[rowIndex].roleType && vm.displayedData[rowIndex].roleType == 'Supplier';
			var cell = jQuery('#' + variableName + rowIndex);
			var pos = cell.offset();
			var content = vm.displayedData[rowIndex][variableName];
			var editTemplate = getListTemplateForUserFactory(pos, rowIndex, variableName, userFactoryCtrl.variableLabel[variableName],
				display, value, factoryNdx, supplierRow);
			vm.editing[variableName] = isBoolean ? Boolean(content): content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					vm.saveEditSelect(variableName, rowIndex);
				} else if (code == 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		};

		function setSupplierValues(rowIndex) {
			var row = vm.displayedData[rowIndex];
			row.profileType = 'ReadWriteUser';
			row.authorizeLeanInitiativeFlag = false;
			row.roleType = 'Supplier';
			if (!row.forSupplier) {
				row.homePage = 'f/home.html#/supply-chain/supplier';
				row.homePageName = 'Supplier Scorecard';
			}
		}

		function saveEditSelectForUserFactory(variableName, rowIndex) {
			var userFactoryCtrl = $scope.$parent.tableCtrl;
			var cell = jQuery('#' + variableName + rowIndex);
			var content = vm.editing[variableName];
			var row = vm.displayedData[rowIndex];
			var oldVal = row[variableName];
			row[variableName] = content;
			var allowEdit = true;
			var errorMessage = '';
			if (variableName === 'roleType' && content && content == 'Supplier') {
				if (!vm.displayedData[rowIndex].supplierNdx) {
					allowEdit = false;
					errorMessage = 'Please select a supplier prior to changing roles to supplier';
				}
			}
			if (!content && content !== false) {
				allowEdit = false;
				errorMessage = 'Please enter a value for ' + userFactoryCtrl.variableLabel[variableName];
			}
			if (allowEdit) {
				// If this is a rollup (company) row, show confirmation modal before bulk-updating all sites
				if (row.isRollup) {
					var bulkConfirmScope = $scope.$new();
					var bulkModalInstance = $uibModal.open({
						scope: bulkConfirmScope,
						templateUrl: '/application/f/core/bulk-update-account-settings-confirm.html'
					});

					bulkConfirmScope.closeDialog = function () {
						bulkModalInstance.close();
						bulkConfirmScope.$destroy();
						// Revert the value since user cancelled
						row[variableName] = oldVal;
					};

					bulkConfirmScope.confirmBulkUpdate = function () {
						bulkModalInstance.close();
						bulkConfirmScope.$destroy();
						performSaveForUserFactory(variableName, rowIndex, row, oldVal, content, userFactoryCtrl);
					};
				} else {
					performSaveForUserFactory(variableName, rowIndex, row, oldVal, content, userFactoryCtrl);
				}
			} else {
				vm.displayedData[rowIndex][variableName] = oldVal;
				$rootScope.$emit('toast', {
					'message': errorMessage,
					'success': false
				});
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		};

		function performSaveForUserFactory(variableName, rowIndex, row, oldVal, content, userFactoryCtrl) {
			if (variableName === 'roleType' && content == 'Supplier') {
				setSupplierValues(rowIndex);
			} else if (variableName === 'supplierNdx' && content > 0) {
				setSupplierValues(rowIndex);
			}
			if (row.supplierNdxs) {
				row.supplierNdxs = row.supplierNdxs.split(',');
			}
			// For rollup rows, pass bulkField and bulkValue so the backend cascades to all site rows
			var bulkField = row.isRollup ? variableName : null;
			var bulkValue = row.isRollup ? content : null;
			// Convert booleans to 1/0 for MySQL tinyint columns
			if (typeof bulkValue === 'boolean') {
				bulkValue = bulkValue ? 1 : 0;
			}
			userManagementService.saveFactory(row, userFactoryCtrl.userNdx, bulkField, bulkValue)
				.then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						if (variableName === 'isSmeCertified') { 
							storeService.dispatch(storeService.actionCreators.clearUserEngagementKpiTooltips());
						}
						vm.displayedData[rowIndex][variableName] = content;
						$rootScope.$emit('toast', {
							'message': userFactoryCtrl.variableLabel[variableName] + ' has been saved successfully'
						});
						$scope.$broadcast('reloadTable');
					} else if (response && response.status == 412) {
						vm.displayedData[rowIndex][variableName] = oldVal;
						$rootScope.$emit('toast', {
							'message': 'This data has been updated since you loaded the page, please refresh the page',
							'success': false
						});
					} else if (response.data.error) {
						if (response.data.error === 'forbiddenSuperSystemAdmin') {
							$rootScope.$emit('toast', {
								'message': 'This user is not allowed to be a Super System Administrator',
								'success': false
							});
						}
					} else {
						vm.displayedData[rowIndex][variableName] = oldVal;
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
				});
		}

		$scope.$on('changeFactoryActivation', function (event, args) {
			changeFactoryActivation(args);
		});

		$scope.$on('deleteSelectedFactories', function (event, args) {
			deleteSelectedFactories(args);
		});

		$scope.$on('downgradeCompanyAdmin', function (event, args) {
			downgradeCompanyAdmin(args);
		});

		function getSelectedEntities() {
			var factoryNdxList = new Set();
			var customerNdxList = new Set();
			angular.forEach(vm.displayedData, function (row) {
				if (row.isChecked && row.leanDirFactoryNdx) factoryNdxList.add(row.leanDirFactoryNdx);
				if (row.isChecked && row.isRollup) {
					customerNdxList.add(row.customerNdx);
					angular.forEach(row.factoryNdxs.split(','), function (factoryNdx) {
						factoryNdxList.add(parseInt(factoryNdx));
					});
				}
			});
			return {
				'factoryNdxList': Array.from(factoryNdxList),
				'customerNdxList': Array.from(customerNdxList)
			};
		}

		function changeFactoryActivation(args) {
			var ndxList = getSelectedEntities().factoryNdxList;
			userManagementService.changeState(args.userNdx, ndxList.toString(), args.activation).then(function (response) {
				if (response && response.status && response.status < 400) {
					$rootScope.$emit('toast', {
						'message': 'Status changed successfully',
						'success': true
					});
				} else {
					$rootScope.$emit('toast', {
						'message': 'Unexpected server error',
						'success': false
					});
				}
				$scope.$emit('reloadUser', {});
				reloadTable();
				deselectAllCheckboxes('isChecked');
			});
		}

		function deleteSelectedFactories(args) {
			var deleteFactoryScope = $scope.$new();
			var ndxList = getSelectedEntities();
			var customerNdxs = ndxList.customerNdxList;
			var factoryNdxs = ndxList.factoryNdxList;
			deleteFactoryScope.selected = {};
			if (factoryNdxs && factoryNdxs.length) {
				userManagementService.getUsers(factoryNdxs).then(function (response) {
					if (response.status == 204) {
						$rootScope.$emit('toast', {
							'message': 'Cannot find a user to	 assign metrics and tasks for all selected sites. Try limiting the selected sites.',
							'success': false,
							'time': 6000
						});
						return;
					}
					var list = [];
					angular.forEach(response.data, function (user) {
						if (user.userNdx.toString() !== args.userNdx) {
							list.push(user);
						}
					});
					if (list.length === 0) {
						$rootScope.$emit('toast', {
							'message': 'Cannot find a user to assign metrics and tasks for all selected sites. Try limiting the selected sites.',
							'success': false,
							'time': 6000
						});
						return;
					}
					deleteFactoryScope.users = list;
					var opts = {
						scope: deleteFactoryScope,
						templateUrl: '/application/f/setup/delete_factory_for_user.html'
					};

					var instance = $uibModal.open(opts);
					deleteFactoryScope.closeDialog = function () {
						instance.close();
						deleteFactoryScope.$destroy();
					};
				});

				deleteFactoryScope.deleteFactory = function deleteFactory() {
					var newUserNdx = deleteFactoryScope.selected.user.userNdx;
					var totalRecords = _.filter(vm.displayedData, function (row) {
						return !row.isRollup;
					}).length;
					userManagementService.deleteFactory(args.userNdx, factoryNdxs, customerNdxs, newUserNdx).then(function (response) {
						if (response && response.status && response.status < 400) {
							$rootScope.$emit('toast', {
								'message': 'User successfully removed from site(s)',
								'success': true
							});
						} else if (response.status = 412) {
							$rootScope.$emit('toast', {
								'message': 'Uncheck the super admin privilege checkbox before attempting to delete this user',
								'success': false
							});
						}	else {
							$rootScope.$emit('toast', {
								'message': 'Unexpected server error',
								'success': false
							});
						}
						// Redirect to manage users page if all factories are deleted for a user.
						// Total records represent the total no of factories user have. Total Records are compared with
						// the total no of factories selected factories.
						if ((totalRecords === 1 || totalRecords === factoryNdxs.length) && response && response.status && response.status < 400) {
							location.href = '/application/f/home.html#/setup/manage-users?message=User%20deleted%20successfully';
						} else {
							reloadTable();
							deselectAllCheckboxes('isChecked');
						}
						deleteFactoryScope.closeDialog();
					});
				};
			}
		};

		function downgradeCompanyAdmin(args) {
			var userNdx = args.userNdx;
			var customerNdxList = getSelectedEntities().customerNdxList;
			userManagementService.downgradeCompanyAdmin(userNdx, customerNdxList).then(function (response) {
				if (response && response.status && response.status < 400) {
					$rootScope.$emit('toast', {
						'message': 'Company administrator status downgraded successfully',
						'success': true
					});
					location.reload();
				} else {
					$rootScope.$emit('toast', {
						'message': 'Unexpected server error',
						'success': false
					});
				}
				$scope.$emit('reloadUser', {});
				reloadTable();
				deselectAllCheckboxes('isChecked');
			});
		}

		function updateActionStatusPosition($item) {
			if ($item) {
				var windowHeight = window.innerHeight;
				var elementPosition = jQuery('.inlineEditDiv').position();
				if (elementPosition.top + 340 > windowHeight) {
					elementPosition.top = elementPosition.top - (elementPosition.top + 340 - windowHeight - 8);
					jQuery('.inlineEditDiv').css('top', elementPosition.top);
				}
			}
		}

		function editProjectType(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.addProjectType(row);
		}

		function deleteProjectType(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.deleteProjectType(row);
		}

		function editProjectSavingsCategory(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.addProjectSavingsCategory(row);
		}

		function deleteProjectSavingsCategory(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.deleteProjectSavingsCategory(row);
		}

		function updateProjectSavingsCategoryStatus(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.updateProjectSavingsCategoryStatus(row);
		}

		function disableSamlProfile(id) {
			var row = id;
			$scope.$parent.tableCtrl.disableSamlProfile(row);
		}

		function toggleLegacyEntityID(id) {
			var row = id;
			$scope.$parent.tableCtrl.toggleLegacyEntityID(row);
		}

		function activateSamlProfile(id) {
			var row = id;
			$scope.$parent.tableCtrl.activateSamlProfile(row);
		}

		function deleteSamlProfile(id) {
			var row = id;
			$scope.$parent.tableCtrl.deleteSamlProfile(row);
		}

		function editSamlProfile(id) {
			var row = id;
			$scope.$parent.tableCtrl.editSamlProfile(row);
		}

		function addSamlProfile() {
			$scope.$parent.tableCtrl.addSamlProfile();
		}

		function addMetadataSp() {
			$scope.$parent.tableCtrl.addMetadataSp();
		}

		function startEditProjectAreaApprovers(rowIndex, column, label, inputType, maxLength, controllerName, allowBlank, addPlaceholder) {
			var row = vm.displayedData[rowIndex];
			var factoryNdx = row.factoryNdx;
			var cell = jQuery('#' + column + rowIndex);
			var pos = cell.offset();
			vm.editing = {};
			projectAreaService.getUsers(factoryNdx).then(function (approvers) {
				vm.multiSelectItems = approvers.data;
			});
			var content = row.approverUserNdx;
			var selectedItems = [];
			if (typeof content !== 'undefined') {
				angular.forEach(content.split(','), function (listItem) {
					selectedItems.push(parseInt(listItem));
				});
			}
			var editTemplate;
			vm.currentStatus = selectedItems;
			editTemplate = getMultiSelectTemplate(pos, rowIndex, 'approverUserNdx', label, true, 'userNdx', 'responsibleName', addPlaceholder);
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code === 27) {
					cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		};

		function saveEditProjectAreaApprovers(rowIndex) {
			var projectAreaCtrl = $scope.$parent.tableCtrl;
			var content = vm.currentStatus;
			var row = vm.displayedData[rowIndex];
			projectAreaCtrl.saveAreaApprovers(row.projectAreaNdx, content);
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		};

		function deleteProjectArea(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.deleteProjectArea(row);
		}

		function saveProjectCategory(rowIndex, status) {
			var row = vm.displayedData[rowIndex];
			if (status) {
				row.status = status;
			}
			$scope.$parent.tableCtrl.saveProjectCategory(row);
		}

		function updateProjectCategoryStatus(rowIndex, status) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.updateProjectCategoryStatus(row, status);
		}

		function deleteProjectCategory(rowIndex) {
			var row = vm.displayedData[rowIndex];
			$scope.$parent.tableCtrl.deleteProjectCategory(row);
		}


		/* Renderer Functions END */
		$scope.$on('$destroy', function () {
			storeService.dispatch({type: storeService.actions.REPORT_SETTINGS_RESET});
			if (reportConfigListener) {
				reportConfigListener();
			}
			if (saveErrorUnsub) {
				saveErrorUnsub();
			}
			if(chatChangeListener) {
				chatChangeListener();
			}

			if(updateInterval) {
				$interval.cancel(updateInterval);
			}

			window.removeEventListener('resize', setScroll);
		});
	}
})();
